// MITRE ATT&CK Enterprise (v19.1) — minimized cascade dataset
// Shape: { tactics:[{id,name}], techniques:{tacticId:[{id,name,sub}]}, subs:{techId:[{id,name}]}, procs:{techOrSubId:[string]} }
const ATTACK_DATA = {
  tactics: [
    { id: "TA0043", name: "Reconnaissance" },
    { id: "TA0042", name: "Resource Development" },
    { id: "TA0001", name: "Initial Access" },
    { id: "TA0002", name: "Execution" },
    { id: "TA0003", name: "Persistence" },
    { id: "TA0004", name: "Privilege Escalation" },
    { id: "TA0005", name: "Stealth" },
    { id: "TA0112", name: "Defense Impairment" },
    { id: "TA0006", name: "Credential Access" },
    { id: "TA0007", name: "Discovery" },
    { id: "TA0008", name: "Lateral Movement" },
    { id: "TA0009", name: "Collection" },
    { id: "TA0011", name: "Command and Control" },
    { id: "TA0010", name: "Exfiltration" },
    { id: "TA0040", name: "Impact" },
  ],
  techniques: {
    TA0043: [
      { id: "T1589", name: "Gather Victim Identity Information", sub: true },
      { id: "T1590", name: "Gather Victim Network Information", sub: true },
      { id: "T1591", name: "Gather Victim Org Information", sub: true },
      { id: "T1592", name: "Gather Victim Host Information", sub: true },
      { id: "T1593", name: "Search Open Websites/Domains", sub: true },
      { id: "T1594", name: "Search Victim-Owned Websites", sub: false },
      { id: "T1595", name: "Active Scanning", sub: true },
      { id: "T1596", name: "Search Open Technical Databases", sub: true },
      { id: "T1597", name: "Search Closed Sources", sub: true },
      { id: "T1598", name: "Phishing for Information", sub: true },
      { id: "T1681", name: "Search Threat Vendor Data", sub: false },
      { id: "T1682", name: "Query Public AI Services", sub: false },
    ],
    TA0042: [
      { id: "T1583", name: "Acquire Infrastructure", sub: true },
      { id: "T1584", name: "Compromise Infrastructure", sub: true },
      { id: "T1585", name: "Establish Accounts", sub: true },
      { id: "T1586", name: "Compromise Accounts", sub: true },
      { id: "T1587", name: "Develop Capabilities", sub: true },
      { id: "T1588", name: "Obtain Capabilities", sub: true },
      { id: "T1608", name: "Stage Capabilities", sub: true },
      { id: "T1650", name: "Acquire Access", sub: false },
      { id: "T1683", name: "Generate Content", sub: true },
    ],
    TA0001: [
      { id: "T1078", name: "Valid Accounts", sub: true },
      { id: "T1091", name: "Replication Through Removable Media", sub: false },
      { id: "T1133", name: "External Remote Services", sub: false },
      { id: "T1189", name: "Drive-by Compromise", sub: false },
      { id: "T1190", name: "Exploit Public-Facing Application", sub: false },
      { id: "T1195", name: "Supply Chain Compromise", sub: true },
      { id: "T1199", name: "Trusted Relationship", sub: false },
      { id: "T1200", name: "Hardware Additions", sub: false },
      { id: "T1566", name: "Phishing", sub: true },
      { id: "T1659", name: "Content Injection", sub: false },
      { id: "T1669", name: "Wi-Fi Networks", sub: false },
    ],
    TA0002: [
      { id: "T1047", name: "Windows Management Instrumentation", sub: false },
      { id: "T1053", name: "Scheduled Task/Job", sub: true },
      { id: "T1059", name: "Command and Scripting Interpreter", sub: true },
      { id: "T1072", name: "Software Deployment Tools", sub: false },
      { id: "T1106", name: "Native API", sub: false },
      {
        id: "T1127",
        name: "Trusted Developer Utilities Proxy Execution",
        sub: true,
      },
      { id: "T1129", name: "Shared Modules", sub: false },
      { id: "T1197", name: "BITS Jobs", sub: false },
      { id: "T1203", name: "Exploitation for Client Execution", sub: false },
      { id: "T1204", name: "User Execution", sub: true },
      { id: "T1559", name: "Inter-Process Communication", sub: true },
      { id: "T1569", name: "System Services", sub: true },
      { id: "T1574", name: "Hijack Execution Flow", sub: true },
      { id: "T1609", name: "Container Administration Command", sub: false },
      { id: "T1610", name: "Deploy Container", sub: false },
      { id: "T1648", name: "Serverless Execution", sub: false },
      { id: "T1651", name: "Cloud Administration Command", sub: false },
      { id: "T1674", name: "Input Injection", sub: false },
      { id: "T1675", name: "ESXi Administration Command", sub: false },
      { id: "T1677", name: "Poisoned Pipeline Execution", sub: false },
    ],
    TA0003: [
      { id: "T1037", name: "Boot or Logon Initialization Scripts", sub: true },
      { id: "T1053", name: "Scheduled Task/Job", sub: true },
      { id: "T1078", name: "Valid Accounts", sub: true },
      { id: "T1098", name: "Account Manipulation", sub: true },
      { id: "T1112", name: "Modify Registry", sub: false },
      { id: "T1133", name: "External Remote Services", sub: false },
      { id: "T1136", name: "Create Account", sub: true },
      { id: "T1137", name: "Office Application Startup", sub: true },
      { id: "T1176", name: "Software Extensions", sub: true },
      { id: "T1197", name: "BITS Jobs", sub: false },
      { id: "T1205", name: "Traffic Signaling", sub: true },
      { id: "T1505", name: "Server Software Component", sub: true },
      { id: "T1525", name: "Implant Internal Image", sub: false },
      { id: "T1542", name: "Pre-OS Boot", sub: true },
      { id: "T1543", name: "Create or Modify System Process", sub: true },
      { id: "T1546", name: "Event Triggered Execution", sub: true },
      { id: "T1547", name: "Boot or Logon Autostart Execution", sub: true },
      { id: "T1554", name: "Compromise Host Software Binary", sub: false },
      { id: "T1556", name: "Modify Authentication Process", sub: true },
      { id: "T1653", name: "Power Settings", sub: false },
      { id: "T1668", name: "Exclusive Control", sub: false },
      { id: "T1671", name: "Cloud Application Integration", sub: false },
    ],
    TA0004: [
      { id: "T1037", name: "Boot or Logon Initialization Scripts", sub: true },
      { id: "T1053", name: "Scheduled Task/Job", sub: true },
      { id: "T1055", name: "Process Injection", sub: true },
      {
        id: "T1068",
        name: "Exploitation for Privilege Escalation",
        sub: false,
      },
      { id: "T1078", name: "Valid Accounts", sub: true },
      { id: "T1098", name: "Account Manipulation", sub: true },
      { id: "T1134", name: "Access Token Manipulation", sub: true },
      { id: "T1484", name: "Domain or Tenant Policy Modification", sub: true },
      { id: "T1543", name: "Create or Modify System Process", sub: true },
      { id: "T1546", name: "Event Triggered Execution", sub: true },
      { id: "T1547", name: "Boot or Logon Autostart Execution", sub: true },
      { id: "T1548", name: "Abuse Elevation Control Mechanism", sub: true },
      { id: "T1611", name: "Escape to Host", sub: false },
    ],
    TA0005: [
      { id: "T1006", name: "Direct Volume Access", sub: false },
      { id: "T1014", name: "Rootkit", sub: false },
      { id: "T1027", name: "Obfuscated Files or Information", sub: true },
      { id: "T1036", name: "Masquerading", sub: true },
      { id: "T1055", name: "Process Injection", sub: true },
      { id: "T1070", name: "Indicator Removal", sub: true },
      { id: "T1078", name: "Valid Accounts", sub: true },
      {
        id: "T1127",
        name: "Trusted Developer Utilities Proxy Execution",
        sub: true,
      },
      { id: "T1134", name: "Access Token Manipulation", sub: true },
      {
        id: "T1140",
        name: "Deobfuscate/Decode Files or Information",
        sub: false,
      },
      { id: "T1197", name: "BITS Jobs", sub: false },
      { id: "T1202", name: "Indirect Command Execution", sub: false },
      { id: "T1205", name: "Traffic Signaling", sub: true },
      { id: "T1211", name: "Exploitation for Stealth", sub: false },
      { id: "T1216", name: "System Script Proxy Execution", sub: true },
      { id: "T1218", name: "System Binary Proxy Execution", sub: true },
      { id: "T1220", name: "XSL Script Processing", sub: false },
      { id: "T1221", name: "Template Injection", sub: false },
      { id: "T1480", name: "Execution Guardrails", sub: true },
      { id: "T1497", name: "Virtualization/Sandbox Evasion", sub: true },
      { id: "T1535", name: "Unused/Unsupported Cloud Regions", sub: false },
      { id: "T1542", name: "Pre-OS Boot", sub: true },
      { id: "T1564", name: "Hide Artifacts", sub: true },
      { id: "T1574", name: "Hijack Execution Flow", sub: true },
      { id: "T1612", name: "Build Image on Host", sub: false },
      { id: "T1620", name: "Reflective Code Loading", sub: false },
      { id: "T1622", name: "Debugger Evasion", sub: false },
      { id: "T1678", name: "Delay Execution", sub: false },
      { id: "T1679", name: "Selective Exclusion", sub: false },
      { id: "T1684", name: "Social Engineering", sub: true },
    ],
    TA0112: [
      { id: "T1112", name: "Modify Registry", sub: false },
      { id: "T1207", name: "Rogue Domain Controller", sub: false },
      {
        id: "T1222",
        name: "File and Directory Permissions Modification",
        sub: true,
      },
      { id: "T1484", name: "Domain or Tenant Policy Modification", sub: true },
      { id: "T1553", name: "Subvert Trust Controls", sub: true },
      { id: "T1556", name: "Modify Authentication Process", sub: true },
      { id: "T1578", name: "Modify Cloud Compute Infrastructure", sub: true },
      { id: "T1599", name: "Network Boundary Bridging", sub: true },
      { id: "T1600", name: "Weaken Encryption", sub: true },
      { id: "T1601", name: "Modify System Image", sub: true },
      { id: "T1647", name: "Plist File Modification", sub: false },
      { id: "T1666", name: "Modify Cloud Resource Hierarchy", sub: false },
      { id: "T1685", name: "Disable or Modify Tools", sub: true },
      { id: "T1686", name: "Disable or Modify System Firewall", sub: true },
      { id: "T1687", name: "Exploitation for Defense Impairment", sub: false },
      { id: "T1688", name: "Safe Mode Boot", sub: false },
      { id: "T1689", name: "Downgrade Attack", sub: false },
      { id: "T1690", name: "Prevent Command History Logging", sub: false },
    ],
    TA0006: [
      { id: "T1003", name: "OS Credential Dumping", sub: true },
      { id: "T1040", name: "Network Sniffing", sub: false },
      { id: "T1056", name: "Input Capture", sub: true },
      { id: "T1110", name: "Brute Force", sub: true },
      {
        id: "T1111",
        name: "Multi-Factor Authentication Interception",
        sub: false,
      },
      { id: "T1187", name: "Forced Authentication", sub: false },
      { id: "T1212", name: "Exploitation for Credential Access", sub: false },
      { id: "T1528", name: "Steal Application Access Token", sub: false },
      { id: "T1539", name: "Steal Web Session Cookie", sub: false },
      { id: "T1552", name: "Unsecured Credentials", sub: true },
      { id: "T1555", name: "Credentials from Password Stores", sub: true },
      { id: "T1556", name: "Modify Authentication Process", sub: true },
      { id: "T1557", name: "Adversary-in-the-Middle", sub: true },
      { id: "T1558", name: "Steal or Forge Kerberos Tickets", sub: true },
      { id: "T1606", name: "Forge Web Credentials", sub: true },
      {
        id: "T1621",
        name: "Multi-Factor Authentication Request Generation",
        sub: false,
      },
      {
        id: "T1649",
        name: "Steal or Forge Authentication Certificates",
        sub: false,
      },
    ],
    TA0007: [
      { id: "T1007", name: "System Service Discovery", sub: false },
      { id: "T1010", name: "Application Window Discovery", sub: false },
      { id: "T1012", name: "Query Registry", sub: false },
      {
        id: "T1016",
        name: "System Network Configuration Discovery",
        sub: true,
      },
      { id: "T1018", name: "Remote System Discovery", sub: false },
      { id: "T1033", name: "System Owner/User Discovery", sub: false },
      { id: "T1040", name: "Network Sniffing", sub: false },
      { id: "T1046", name: "Network Service Discovery", sub: false },
      { id: "T1049", name: "System Network Connections Discovery", sub: false },
      { id: "T1057", name: "Process Discovery", sub: false },
      { id: "T1069", name: "Permission Groups Discovery", sub: true },
      { id: "T1082", name: "System Information Discovery", sub: false },
      { id: "T1083", name: "File and Directory Discovery", sub: false },
      { id: "T1087", name: "Account Discovery", sub: true },
      { id: "T1120", name: "Peripheral Device Discovery", sub: false },
      { id: "T1124", name: "System Time Discovery", sub: false },
      { id: "T1135", name: "Network Share Discovery", sub: false },
      { id: "T1201", name: "Password Policy Discovery", sub: false },
      { id: "T1217", name: "Browser Information Discovery", sub: false },
      { id: "T1482", name: "Domain Trust Discovery", sub: false },
      { id: "T1497", name: "Virtualization/Sandbox Evasion", sub: true },
      { id: "T1518", name: "Software Discovery", sub: true },
      { id: "T1526", name: "Cloud Service Discovery", sub: false },
      { id: "T1538", name: "Cloud Service Dashboard", sub: false },
      { id: "T1580", name: "Cloud Infrastructure Discovery", sub: false },
      { id: "T1613", name: "Container and Resource Discovery", sub: false },
      { id: "T1614", name: "System Location Discovery", sub: true },
      { id: "T1615", name: "Group Policy Discovery", sub: false },
      { id: "T1619", name: "Cloud Storage Object Discovery", sub: false },
      { id: "T1622", name: "Debugger Evasion", sub: false },
      { id: "T1652", name: "Device Driver Discovery", sub: false },
      { id: "T1654", name: "Log Enumeration", sub: false },
      { id: "T1673", name: "Virtual Machine Discovery", sub: false },
      { id: "T1680", name: "Local Storage Discovery", sub: false },
    ],
    TA0008: [
      { id: "T1021", name: "Remote Services", sub: true },
      { id: "T1072", name: "Software Deployment Tools", sub: false },
      { id: "T1080", name: "Taint Shared Content", sub: false },
      { id: "T1091", name: "Replication Through Removable Media", sub: false },
      { id: "T1210", name: "Exploitation of Remote Services", sub: false },
      { id: "T1534", name: "Internal Spearphishing", sub: false },
      { id: "T1550", name: "Use Alternate Authentication Material", sub: true },
      { id: "T1563", name: "Remote Service Session Hijacking", sub: true },
      { id: "T1570", name: "Lateral Tool Transfer", sub: false },
    ],
    TA0009: [
      { id: "T1005", name: "Data from Local System", sub: false },
      { id: "T1025", name: "Data from Removable Media", sub: false },
      { id: "T1039", name: "Data from Network Shared Drive", sub: false },
      { id: "T1056", name: "Input Capture", sub: true },
      { id: "T1074", name: "Data Staged", sub: true },
      { id: "T1113", name: "Screen Capture", sub: false },
      { id: "T1114", name: "Email Collection", sub: true },
      { id: "T1115", name: "Clipboard Data", sub: false },
      { id: "T1119", name: "Automated Collection", sub: false },
      { id: "T1123", name: "Audio Capture", sub: false },
      { id: "T1125", name: "Video Capture", sub: false },
      { id: "T1185", name: "Browser Session Hijacking", sub: false },
      { id: "T1213", name: "Data from Information Repositories", sub: true },
      { id: "T1530", name: "Data from Cloud Storage", sub: false },
      { id: "T1557", name: "Adversary-in-the-Middle", sub: true },
      { id: "T1560", name: "Archive Collected Data", sub: true },
      { id: "T1602", name: "Data from Configuration Repository", sub: true },
    ],
    TA0011: [
      { id: "T1001", name: "Data Obfuscation", sub: true },
      { id: "T1008", name: "Fallback Channels", sub: false },
      { id: "T1071", name: "Application Layer Protocol", sub: true },
      { id: "T1090", name: "Proxy", sub: true },
      {
        id: "T1092",
        name: "Communication Through Removable Media",
        sub: false,
      },
      { id: "T1095", name: "Non-Application Layer Protocol", sub: false },
      { id: "T1102", name: "Web Service", sub: true },
      { id: "T1104", name: "Multi-Stage Channels", sub: false },
      { id: "T1105", name: "Ingress Tool Transfer", sub: false },
      { id: "T1132", name: "Data Encoding", sub: true },
      { id: "T1205", name: "Traffic Signaling", sub: true },
      { id: "T1219", name: "Remote Access Tools", sub: true },
      { id: "T1568", name: "Dynamic Resolution", sub: true },
      { id: "T1571", name: "Non-Standard Port", sub: false },
      { id: "T1572", name: "Protocol Tunneling", sub: false },
      { id: "T1573", name: "Encrypted Channel", sub: true },
      { id: "T1659", name: "Content Injection", sub: false },
      { id: "T1665", name: "Hide Infrastructure", sub: false },
    ],
    TA0010: [
      {
        id: "T1011",
        name: "Exfiltration Over Other Network Medium",
        sub: true,
      },
      { id: "T1020", name: "Automated Exfiltration", sub: true },
      { id: "T1029", name: "Scheduled Transfer", sub: false },
      { id: "T1030", name: "Data Transfer Size Limits", sub: false },
      { id: "T1041", name: "Exfiltration Over C2 Channel", sub: false },
      {
        id: "T1048",
        name: "Exfiltration Over Alternative Protocol",
        sub: true,
      },
      { id: "T1052", name: "Exfiltration Over Physical Medium", sub: true },
      { id: "T1537", name: "Transfer Data to Cloud Account", sub: false },
      { id: "T1567", name: "Exfiltration Over Web Service", sub: true },
    ],
    TA0040: [
      { id: "T1485", name: "Data Destruction", sub: true },
      { id: "T1486", name: "Data Encrypted for Impact", sub: false },
      { id: "T1489", name: "Service Stop", sub: false },
      { id: "T1490", name: "Inhibit System Recovery", sub: false },
      { id: "T1491", name: "Defacement", sub: true },
      { id: "T1495", name: "Firmware Corruption", sub: false },
      { id: "T1496", name: "Resource Hijacking", sub: true },
      { id: "T1498", name: "Network Denial of Service", sub: true },
      { id: "T1499", name: "Endpoint Denial of Service", sub: true },
      { id: "T1529", name: "System Shutdown/Reboot", sub: false },
      { id: "T1531", name: "Account Access Removal", sub: false },
      { id: "T1561", name: "Disk Wipe", sub: true },
      { id: "T1565", name: "Data Manipulation", sub: true },
      { id: "T1657", name: "Financial Theft", sub: false },
      { id: "T1667", name: "Email Bombing", sub: false },
    ],
  },
  subs: {
    T1055: [
      { id: "T1055.001", name: "Dynamic-link Library Injection" },
      { id: "T1055.002", name: "Portable Executable Injection" },
      { id: "T1055.003", name: "Thread Execution Hijacking" },
      { id: "T1055.004", name: "Asynchronous Procedure Call" },
      { id: "T1055.005", name: "Thread Local Storage" },
      { id: "T1055.008", name: "Ptrace System Calls" },
      { id: "T1055.009", name: "Proc Memory" },
      { id: "T1055.011", name: "Extra Window Memory Injection" },
      { id: "T1055.012", name: "Process Hollowing" },
      { id: "T1055.013", name: "Process Doppelg\u00e4nging" },
      { id: "T1055.014", name: "VDSO Hijacking" },
      { id: "T1055.015", name: "ListPlanting" },
    ],
    T1053: [
      { id: "T1053.002", name: "At" },
      { id: "T1053.003", name: "Cron" },
      { id: "T1053.005", name: "Scheduled Task" },
      { id: "T1053.006", name: "Systemd Timers" },
      { id: "T1053.007", name: "Container Orchestration Job" },
    ],
    T1205: [
      { id: "T1205.001", name: "Port Knocking" },
      { id: "T1205.002", name: "Socket Filters" },
    ],
    T1560: [
      { id: "T1560.001", name: "Archive via Utility" },
      { id: "T1560.002", name: "Archive via Library" },
      { id: "T1560.003", name: "Archive via Custom Method" },
    ],
    T1021: [
      { id: "T1021.001", name: "Remote Desktop Protocol" },
      { id: "T1021.002", name: "SMB/Windows Admin Shares" },
      { id: "T1021.003", name: "Distributed Component Object Model" },
      { id: "T1021.004", name: "SSH" },
      { id: "T1021.005", name: "VNC" },
      { id: "T1021.006", name: "Windows Remote Management" },
      { id: "T1021.007", name: "Cloud Services" },
      { id: "T1021.008", name: "Direct Cloud VM Connections" },
    ],
    T1027: [
      { id: "T1027.001", name: "Binary Padding" },
      { id: "T1027.002", name: "Software Packing" },
      { id: "T1027.003", name: "Steganography" },
      { id: "T1027.004", name: "Compile After Delivery" },
      { id: "T1027.005", name: "Indicator Removal from Tools" },
      { id: "T1027.006", name: "HTML Smuggling" },
      { id: "T1027.007", name: "Dynamic API Resolution" },
      { id: "T1027.008", name: "Stripped Payloads" },
      { id: "T1027.009", name: "Embedded Payloads" },
      { id: "T1027.010", name: "Command Obfuscation" },
      { id: "T1027.011", name: "Fileless Storage" },
      { id: "T1027.012", name: "LNK Icon Smuggling" },
      { id: "T1027.013", name: "Encrypted/Encoded File" },
      { id: "T1027.014", name: "Polymorphic Code" },
      { id: "T1027.015", name: "Compression" },
      { id: "T1027.016", name: "Junk Code Insertion" },
      { id: "T1027.017", name: "SVG Smuggling" },
      { id: "T1027.018", name: "Invisible Unicode" },
    ],
    T1218: [
      { id: "T1218.001", name: "Compiled HTML File" },
      { id: "T1218.002", name: "Control Panel" },
      { id: "T1218.003", name: "CMSTP" },
      { id: "T1218.004", name: "InstallUtil" },
      { id: "T1218.005", name: "Mshta" },
      { id: "T1218.007", name: "Msiexec" },
      { id: "T1218.008", name: "Odbcconf" },
      { id: "T1218.009", name: "Regsvcs/Regasm" },
      { id: "T1218.010", name: "Regsvr32" },
      { id: "T1218.011", name: "Rundll32" },
      { id: "T1218.012", name: "Verclsid" },
      { id: "T1218.013", name: "Mavinject" },
      { id: "T1218.014", name: "MMC" },
      { id: "T1218.015", name: "Electron Applications" },
    ],
    T1583: [
      { id: "T1583.001", name: "Domains" },
      { id: "T1583.002", name: "DNS Server" },
      { id: "T1583.003", name: "Virtual Private Server" },
      { id: "T1583.004", name: "Server" },
      { id: "T1583.005", name: "Botnet" },
      { id: "T1583.006", name: "Web Services" },
      { id: "T1583.007", name: "Serverless" },
      { id: "T1583.008", name: "Malvertising" },
    ],
    T1132: [
      { id: "T1132.001", name: "Standard Encoding" },
      { id: "T1132.002", name: "Non-Standard Encoding" },
    ],
    T1556: [
      { id: "T1556.001", name: "Domain Controller Authentication" },
      { id: "T1556.002", name: "Password Filter DLL" },
      { id: "T1556.003", name: "Pluggable Authentication Modules" },
      { id: "T1556.004", name: "Network Device Authentication" },
      { id: "T1556.005", name: "Reversible Encryption" },
      { id: "T1556.006", name: "Multi-Factor Authentication" },
      { id: "T1556.007", name: "Hybrid Identity" },
      { id: "T1556.008", name: "Network Provider DLL" },
      { id: "T1556.009", name: "Conditional Access Policies" },
    ],
    T1578: [
      { id: "T1578.001", name: "Create Snapshot" },
      { id: "T1578.002", name: "Create Cloud Instance" },
      { id: "T1578.003", name: "Delete Cloud Instance" },
      { id: "T1578.004", name: "Revert Cloud Instance" },
      { id: "T1578.005", name: "Modify Cloud Compute Configurations" },
    ],
    T1596: [
      { id: "T1596.001", name: "DNS/Passive DNS" },
      { id: "T1596.002", name: "WHOIS" },
      { id: "T1596.003", name: "Digital Certificates" },
      { id: "T1596.004", name: "CDNs" },
      { id: "T1596.005", name: "Scan Databases" },
    ],
    T1056: [
      { id: "T1056.001", name: "Keylogging" },
      { id: "T1056.002", name: "GUI Input Capture" },
      { id: "T1056.003", name: "Web Portal Capture" },
      { id: "T1056.004", name: "Credential API Hooking" },
    ],
    T1564: [
      { id: "T1564.001", name: "Hidden Files and Directories" },
      { id: "T1564.002", name: "Hidden Users" },
      { id: "T1564.003", name: "Hidden Window" },
      { id: "T1564.004", name: "NTFS File Attributes" },
      { id: "T1564.005", name: "Hidden File System" },
      { id: "T1564.006", name: "Run Virtual Instance" },
      { id: "T1564.007", name: "VBA Stomping" },
      { id: "T1564.008", name: "Email Hiding Rules" },
      { id: "T1564.009", name: "Resource Forking" },
      { id: "T1564.010", name: "Process Argument Spoofing" },
      { id: "T1564.011", name: "Ignore Process Interrupts" },
      { id: "T1564.012", name: "File/Path Exclusions" },
      { id: "T1564.013", name: "Bind Mounts" },
      { id: "T1564.014", name: "Extended Attributes" },
    ],
    T1222: [
      { id: "T1222.001", name: "Windows Permissions" },
      { id: "T1222.002", name: "Linux and Mac Permissions" },
    ],
    T1110: [
      { id: "T1110.001", name: "Password Guessing" },
      { id: "T1110.002", name: "Password Cracking" },
      { id: "T1110.003", name: "Password Spraying" },
      { id: "T1110.004", name: "Credential Stuffing" },
    ],
    T1216: [
      { id: "T1216.001", name: "PubPrn" },
      { id: "T1216.002", name: "SyncAppvPublishingServer" },
    ],
    T1597: [
      { id: "T1597.001", name: "Threat Intel Vendors" },
      { id: "T1597.002", name: "Purchase Technical Data" },
    ],
    T1561: [
      { id: "T1561.001", name: "Disk Content Wipe" },
      { id: "T1561.002", name: "Disk Structure Wipe" },
    ],
    T1498: [
      { id: "T1498.001", name: "Direct Network Flood" },
      { id: "T1498.002", name: "Reflection Amplification" },
    ],
    T1574: [
      { id: "T1574.001", name: "DLL" },
      { id: "T1574.004", name: "Dylib Hijacking" },
      {
        id: "T1574.005",
        name: "Executable Installer File Permissions Weakness",
      },
      { id: "T1574.006", name: "Dynamic Linker Hijacking" },
      {
        id: "T1574.007",
        name: "Path Interception by PATH Environment Variable",
      },
      { id: "T1574.008", name: "Path Interception by Search Order Hijacking" },
      { id: "T1574.009", name: "Path Interception by Unquoted Path" },
      { id: "T1574.010", name: "Services File Permissions Weakness" },
      { id: "T1574.011", name: "Services Registry Permissions Weakness" },
      { id: "T1574.012", name: "COR_PROFILER" },
      { id: "T1574.013", name: "KernelCallbackTable" },
      { id: "T1574.014", name: "AppDomainManager" },
    ],
    T1213: [
      { id: "T1213.001", name: "Confluence" },
      { id: "T1213.002", name: "Sharepoint" },
      { id: "T1213.003", name: "Code Repositories" },
      { id: "T1213.004", name: "Customer Relationship Management Software" },
      { id: "T1213.005", name: "Messaging Applications" },
      { id: "T1213.006", name: "Databases" },
    ],
    T1588: [
      { id: "T1588.001", name: "Malware" },
      { id: "T1588.002", name: "Tool" },
      { id: "T1588.003", name: "Code Signing Certificates" },
      { id: "T1588.004", name: "Digital Certificates" },
      { id: "T1588.005", name: "Exploits" },
      { id: "T1588.006", name: "Vulnerabilities" },
      { id: "T1588.007", name: "Artificial Intelligence" },
    ],
    T1491: [
      { id: "T1491.001", name: "Internal Defacement" },
      { id: "T1491.002", name: "External Defacement" },
    ],
    T1590: [
      { id: "T1590.001", name: "Domain Properties" },
      { id: "T1590.002", name: "DNS" },
      { id: "T1590.003", name: "Network Trust Dependencies" },
      { id: "T1590.004", name: "Network Topology" },
      { id: "T1590.005", name: "IP Addresses" },
      { id: "T1590.006", name: "Network Security Appliances" },
    ],
    T1499: [
      { id: "T1499.001", name: "OS Exhaustion Flood" },
      { id: "T1499.002", name: "Service Exhaustion Flood" },
      { id: "T1499.003", name: "Application Exhaustion Flood" },
      { id: "T1499.004", name: "Application or System Exploitation" },
    ],
    T1546: [
      { id: "T1546.001", name: "Change Default File Association" },
      { id: "T1546.002", name: "Screensaver" },
      {
        id: "T1546.003",
        name: "Windows Management Instrumentation Event Subscription",
      },
      { id: "T1546.004", name: "Unix Shell Configuration Modification" },
      { id: "T1546.005", name: "Trap" },
      { id: "T1546.006", name: "LC_LOAD_DYLIB Addition" },
      { id: "T1546.007", name: "Netsh Helper DLL" },
      { id: "T1546.008", name: "Accessibility Features" },
      { id: "T1546.009", name: "AppCert DLLs" },
      { id: "T1546.010", name: "AppInit DLLs" },
      { id: "T1546.011", name: "Application Shimming" },
      { id: "T1546.012", name: "Image File Execution Options Injection" },
      { id: "T1546.013", name: "PowerShell Profile" },
      { id: "T1546.014", name: "Emond" },
      { id: "T1546.015", name: "Component Object Model Hijacking" },
      { id: "T1546.016", name: "Installer Packages" },
      { id: "T1546.017", name: "Udev Rules" },
      { id: "T1546.018", name: "Python Startup Hooks" },
    ],
    T1059: [
      { id: "T1059.001", name: "PowerShell" },
      { id: "T1059.002", name: "AppleScript" },
      { id: "T1059.003", name: "Windows Command Shell" },
      { id: "T1059.004", name: "Unix Shell" },
      { id: "T1059.005", name: "Visual Basic" },
      { id: "T1059.006", name: "Python" },
      { id: "T1059.007", name: "JavaScript" },
      { id: "T1059.008", name: "Network Device CLI" },
      { id: "T1059.009", name: "Cloud API" },
      { id: "T1059.010", name: "AutoHotKey & AutoIT" },
      { id: "T1059.011", name: "Lua" },
      { id: "T1059.012", name: "Hypervisor CLI" },
      { id: "T1059.013", name: "Container CLI/API" },
    ],
    T1685: [
      { id: "T1685.001", name: "Disable or Modify Windows Event Log" },
      { id: "T1685.002", name: "Disable or Modify Cloud Log" },
      { id: "T1685.003", name: "Modify or Spoof Tool UI" },
      { id: "T1685.004", name: "Disable or Modify Linux Audit System Log" },
      { id: "T1685.005", name: "Clear Windows Event Logs" },
      { id: "T1685.006", name: "Clear Linux or Mac System Logs" },
    ],
    T1485: [{ id: "T1485.001", name: "Lifecycle-Triggered Deletion" }],
    T1568: [
      { id: "T1568.001", name: "Fast Flux DNS" },
      { id: "T1568.002", name: "Domain Generation Algorithms" },
      { id: "T1568.003", name: "DNS Calculation" },
    ],
    T1036: [
      { id: "T1036.001", name: "Invalid Code Signature" },
      { id: "T1036.002", name: "Right-to-Left Override" },
      { id: "T1036.003", name: "Rename Legitimate Utilities" },
      { id: "T1036.004", name: "Masquerade Task or Service" },
      { id: "T1036.005", name: "Match Legitimate Resource Name or Location" },
      { id: "T1036.006", name: "Space after Filename" },
      { id: "T1036.007", name: "Double File Extension" },
      { id: "T1036.008", name: "Masquerade File Type" },
      { id: "T1036.009", name: "Break Process Trees" },
      { id: "T1036.010", name: "Masquerade Account Name" },
      { id: "T1036.011", name: "Overwrite Process Arguments" },
      { id: "T1036.012", name: "Browser Fingerprint" },
    ],
    T1548: [
      { id: "T1548.001", name: "Setuid and Setgid" },
      { id: "T1548.002", name: "Bypass User Account Control" },
      { id: "T1548.003", name: "Sudo and Sudo Caching" },
      { id: "T1548.004", name: "Elevated Execution with Prompt" },
      { id: "T1548.005", name: "Temporary Elevated Cloud Access" },
      { id: "T1548.006", name: "TCC Manipulation" },
    ],
    T1496: [
      { id: "T1496.001", name: "Compute Hijacking" },
      { id: "T1496.002", name: "Bandwidth Hijacking" },
      { id: "T1496.003", name: "SMS Pumping" },
      { id: "T1496.004", name: "Cloud Service Hijacking" },
    ],
    T1016: [
      { id: "T1016.001", name: "Internet Connection Discovery" },
      { id: "T1016.002", name: "Wi-Fi Discovery" },
    ],
    T1584: [
      { id: "T1584.001", name: "Domains" },
      { id: "T1584.002", name: "DNS Server" },
      { id: "T1584.003", name: "Virtual Private Server" },
      { id: "T1584.004", name: "Server" },
      { id: "T1584.005", name: "Botnet" },
      { id: "T1584.006", name: "Web Services" },
      { id: "T1584.007", name: "Serverless" },
      { id: "T1584.008", name: "Network Devices" },
    ],
    T1003: [
      { id: "T1003.001", name: "LSASS Memory" },
      { id: "T1003.002", name: "Security Account Manager" },
      { id: "T1003.003", name: "NTDS" },
      { id: "T1003.004", name: "LSA Secrets" },
      { id: "T1003.005", name: "Cached Domain Credentials" },
      { id: "T1003.006", name: "DCSync" },
      { id: "T1003.007", name: "Proc Filesystem" },
      { id: "T1003.008", name: "/etc/passwd and /etc/shadow" },
    ],
    T1542: [
      { id: "T1542.001", name: "System Firmware" },
      { id: "T1542.002", name: "Component Firmware" },
      { id: "T1542.003", name: "Bootkit" },
      { id: "T1542.004", name: "ROMMONkit" },
      { id: "T1542.005", name: "TFTP Boot" },
    ],
    T1069: [
      { id: "T1069.001", name: "Local Groups" },
      { id: "T1069.002", name: "Domain Groups" },
      { id: "T1069.003", name: "Cloud Groups" },
    ],
    T1195: [
      {
        id: "T1195.001",
        name: "Compromise Software Dependencies and Development Tools",
      },
      { id: "T1195.002", name: "Compromise Software Supply Chain" },
      { id: "T1195.003", name: "Compromise Hardware Supply Chain" },
    ],
    T1071: [
      { id: "T1071.001", name: "Web Protocols" },
      { id: "T1071.002", name: "File Transfer Protocols" },
      { id: "T1071.003", name: "Mail Protocols" },
      { id: "T1071.004", name: "DNS" },
      { id: "T1071.005", name: "Publish/Subscribe Protocols" },
    ],
    T1552: [
      { id: "T1552.001", name: "Credentials In Files" },
      { id: "T1552.002", name: "Credentials in Registry" },
      { id: "T1552.003", name: "Shell History" },
      { id: "T1552.004", name: "Private Keys" },
      { id: "T1552.005", name: "Cloud Instance Metadata API" },
      { id: "T1552.006", name: "Group Policy Preferences" },
      { id: "T1552.007", name: "Container API" },
      { id: "T1552.008", name: "Chat Messages" },
    ],
    T1555: [
      { id: "T1555.001", name: "Keychain" },
      { id: "T1555.002", name: "Securityd Memory" },
      { id: "T1555.003", name: "Credentials from Web Browsers" },
      { id: "T1555.004", name: "Windows Credential Manager" },
      { id: "T1555.005", name: "Password Managers" },
      { id: "T1555.006", name: "Cloud Secrets Management Stores" },
    ],
    T1074: [
      { id: "T1074.001", name: "Local Data Staging" },
      { id: "T1074.002", name: "Remote Data Staging" },
    ],
    T1587: [
      { id: "T1587.001", name: "Malware" },
      { id: "T1587.002", name: "Code Signing Certificates" },
      { id: "T1587.003", name: "Digital Certificates" },
      { id: "T1587.004", name: "Exploits" },
    ],
    T1565: [
      { id: "T1565.001", name: "Stored Data Manipulation" },
      { id: "T1565.002", name: "Transmitted Data Manipulation" },
      { id: "T1565.003", name: "Runtime Data Manipulation" },
    ],
    T1114: [
      { id: "T1114.001", name: "Local Email Collection" },
      { id: "T1114.002", name: "Remote Email Collection" },
      { id: "T1114.003", name: "Email Forwarding Rule" },
    ],
    T1606: [
      { id: "T1606.001", name: "Web Cookies" },
      { id: "T1606.002", name: "SAML Tokens" },
    ],
    T1087: [
      { id: "T1087.001", name: "Local Account" },
      { id: "T1087.002", name: "Domain Account" },
      { id: "T1087.003", name: "Email Account" },
      { id: "T1087.004", name: "Cloud Account" },
    ],
    T1547: [
      { id: "T1547.001", name: "Registry Run Keys / Startup Folder" },
      { id: "T1547.002", name: "Authentication Package" },
      { id: "T1547.003", name: "Time Providers" },
      { id: "T1547.004", name: "Winlogon Helper DLL" },
      { id: "T1547.005", name: "Security Support Provider" },
      { id: "T1547.006", name: "Kernel Modules and Extensions" },
      { id: "T1547.007", name: "Re-opened Applications" },
      { id: "T1547.008", name: "LSASS Driver" },
      { id: "T1547.009", name: "Shortcut Modification" },
      { id: "T1547.010", name: "Port Monitors" },
      { id: "T1547.012", name: "Print Processors" },
      { id: "T1547.013", name: "XDG Autostart Entries" },
      { id: "T1547.014", name: "Active Setup" },
      { id: "T1547.015", name: "Login Items" },
    ],
    T1559: [
      { id: "T1559.001", name: "Component Object Model" },
      { id: "T1559.002", name: "Dynamic Data Exchange" },
      { id: "T1559.003", name: "XPC Services" },
    ],
    T1204: [
      { id: "T1204.001", name: "Malicious Link" },
      { id: "T1204.002", name: "Malicious File" },
      { id: "T1204.003", name: "Malicious Image" },
      { id: "T1204.004", name: "Malicious Copy and Paste" },
      { id: "T1204.005", name: "Malicious Library" },
    ],
    T1591: [
      { id: "T1591.001", name: "Determine Physical Locations" },
      { id: "T1591.002", name: "Business Relationships" },
      { id: "T1591.003", name: "Identify Business Tempo" },
      { id: "T1591.004", name: "Identify Roles" },
    ],
    T1592: [
      { id: "T1592.001", name: "Hardware" },
      { id: "T1592.002", name: "Software" },
      { id: "T1592.003", name: "Firmware" },
      { id: "T1592.004", name: "Client Configurations" },
    ],
    T1484: [
      { id: "T1484.001", name: "Group Policy Modification" },
      { id: "T1484.002", name: "Trust Modification" },
    ],
    T1573: [
      { id: "T1573.001", name: "Symmetric Cryptography" },
      { id: "T1573.002", name: "Asymmetric Cryptography" },
    ],
    T1586: [
      { id: "T1586.001", name: "Social Media Accounts" },
      { id: "T1586.002", name: "Email Accounts" },
      { id: "T1586.003", name: "Cloud Accounts" },
    ],
    T1176: [
      { id: "T1176.001", name: "Browser Extensions" },
      { id: "T1176.002", name: "IDE Extensions" },
    ],
    T1686: [
      { id: "T1686.001", name: "Cloud Firewall" },
      { id: "T1686.002", name: "Network Device Firewall" },
      { id: "T1686.003", name: "Windows Host Firewall" },
    ],
    T1543: [
      { id: "T1543.001", name: "Launch Agent" },
      { id: "T1543.002", name: "Systemd Service" },
      { id: "T1543.003", name: "Windows Service" },
      { id: "T1543.004", name: "Launch Daemon" },
      { id: "T1543.005", name: "Container Service" },
    ],
    T1497: [
      { id: "T1497.001", name: "System Checks" },
      { id: "T1497.002", name: "User Activity Based Checks" },
      { id: "T1497.003", name: "Time Based Checks" },
    ],
    T1566: [
      { id: "T1566.001", name: "Spearphishing Attachment" },
      { id: "T1566.002", name: "Spearphishing Link" },
      { id: "T1566.003", name: "Spearphishing via Service" },
      { id: "T1566.004", name: "Spearphishing Voice" },
    ],
    T1598: [
      { id: "T1598.001", name: "Spearphishing Service" },
      { id: "T1598.002", name: "Spearphishing Attachment" },
      { id: "T1598.003", name: "Spearphishing Link" },
      { id: "T1598.004", name: "Spearphishing Voice" },
    ],
    T1098: [
      { id: "T1098.001", name: "Additional Cloud Credentials" },
      { id: "T1098.002", name: "Additional Email Delegate Permissions" },
      { id: "T1098.003", name: "Additional Cloud Roles" },
      { id: "T1098.004", name: "SSH Authorized Keys" },
      { id: "T1098.005", name: "Device Registration" },
      { id: "T1098.006", name: "Additional Container Cluster Roles" },
      { id: "T1098.007", name: "Additional Local or Domain Groups" },
    ],
    T1553: [
      { id: "T1553.001", name: "Gatekeeper Bypass" },
      { id: "T1553.002", name: "Code Signing" },
      { id: "T1553.003", name: "SIP and Trust Provider Hijacking" },
      { id: "T1553.004", name: "Install Root Certificate" },
      { id: "T1553.005", name: "Mark-of-the-Web Bypass" },
      { id: "T1553.006", name: "Code Signing Policy Modification" },
    ],
    T1608: [
      { id: "T1608.001", name: "Upload Malware" },
      { id: "T1608.002", name: "Upload Tool" },
      { id: "T1608.003", name: "Install Digital Certificate" },
      { id: "T1608.004", name: "Drive-by Target" },
      { id: "T1608.005", name: "Link Target" },
      { id: "T1608.006", name: "SEO Poisoning" },
    ],
    T1137: [
      { id: "T1137.001", name: "Office Template Macros" },
      { id: "T1137.002", name: "Office Test" },
      { id: "T1137.003", name: "Outlook Forms" },
      { id: "T1137.004", name: "Outlook Home Page" },
      { id: "T1137.005", name: "Outlook Rules" },
      { id: "T1137.006", name: "Add-ins" },
    ],
    T1505: [
      { id: "T1505.001", name: "SQL Stored Procedures" },
      { id: "T1505.002", name: "Transport Agent" },
      { id: "T1505.003", name: "Web Shell" },
      { id: "T1505.004", name: "IIS Components" },
      { id: "T1505.005", name: "Terminal Services DLL" },
      { id: "T1505.006", name: "vSphere Installation Bundles" },
    ],
    T1558: [
      { id: "T1558.001", name: "Golden Ticket" },
      { id: "T1558.002", name: "Silver Ticket" },
      { id: "T1558.003", name: "Kerberoasting" },
      { id: "T1558.004", name: "AS-REP Roasting" },
      { id: "T1558.005", name: "Ccache Files" },
    ],
    T1070: [
      { id: "T1070.003", name: "Clear Command History" },
      { id: "T1070.004", name: "File Deletion" },
      { id: "T1070.005", name: "Network Share Connection Removal" },
      { id: "T1070.006", name: "Timestomp" },
      {
        id: "T1070.007",
        name: "Clear Network Connection History and Configurations",
      },
      { id: "T1070.008", name: "Clear Mailbox Data" },
      { id: "T1070.009", name: "Clear Persistence" },
      { id: "T1070.010", name: "Relocate Malware" },
    ],
    T1600: [
      { id: "T1600.001", name: "Reduce Key Space" },
      { id: "T1600.002", name: "Disable Crypto Hardware" },
    ],
    T1037: [
      { id: "T1037.001", name: "Logon Script (Windows)" },
      { id: "T1037.002", name: "Login Hook" },
      { id: "T1037.003", name: "Network Logon Script" },
      { id: "T1037.004", name: "RC Scripts" },
      { id: "T1037.005", name: "Startup Items" },
    ],
    T1567: [
      { id: "T1567.001", name: "Exfiltration to Code Repository" },
      { id: "T1567.002", name: "Exfiltration to Cloud Storage" },
      { id: "T1567.003", name: "Exfiltration to Text Storage Sites" },
      { id: "T1567.004", name: "Exfiltration Over Webhook" },
    ],
    T1557: [
      { id: "T1557.001", name: "Name Resolution Poisoning and SMB Relay" },
      { id: "T1557.002", name: "ARP Cache Poisoning" },
      { id: "T1557.003", name: "DHCP Spoofing" },
      { id: "T1557.004", name: "Evil Twin" },
    ],
    T1480: [
      { id: "T1480.001", name: "Environmental Keying" },
      { id: "T1480.002", name: "Mutual Exclusion" },
    ],
    T1518: [
      { id: "T1518.001", name: "Security Software Discovery" },
      { id: "T1518.002", name: "Backup Software Discovery" },
    ],
    T1569: [
      { id: "T1569.001", name: "Launchctl" },
      { id: "T1569.002", name: "Service Execution" },
      { id: "T1569.003", name: "Systemctl" },
    ],
    T1563: [
      { id: "T1563.001", name: "SSH Hijacking" },
      { id: "T1563.002", name: "RDP Hijacking" },
    ],
    T1599: [{ id: "T1599.001", name: "Network Address Translation Traversal" }],
    T1602: [
      { id: "T1602.001", name: "SNMP (MIB Dump)" },
      { id: "T1602.002", name: "Network Device Configuration Dump" },
    ],
    T1595: [
      { id: "T1595.001", name: "Scanning IP Blocks" },
      { id: "T1595.002", name: "Vulnerability Scanning" },
      { id: "T1595.003", name: "Wordlist Scanning" },
    ],
    T1011: [{ id: "T1011.001", name: "Exfiltration Over Bluetooth" }],
    T1078: [
      { id: "T1078.001", name: "Default Accounts" },
      { id: "T1078.002", name: "Domain Accounts" },
      { id: "T1078.003", name: "Local Accounts" },
      { id: "T1078.004", name: "Cloud Accounts" },
    ],
    T1136: [
      { id: "T1136.001", name: "Local Account" },
      { id: "T1136.002", name: "Domain Account" },
      { id: "T1136.003", name: "Cloud Account" },
    ],
    T1585: [
      { id: "T1585.001", name: "Social Media Accounts" },
      { id: "T1585.002", name: "Email Accounts" },
      { id: "T1585.003", name: "Cloud Accounts" },
    ],
    T1134: [
      { id: "T1134.001", name: "Token Impersonation/Theft" },
      { id: "T1134.002", name: "Create Process with Token" },
      { id: "T1134.003", name: "Make and Impersonate Token" },
      { id: "T1134.004", name: "Parent PID Spoofing" },
      { id: "T1134.005", name: "SID-History Injection" },
    ],
    T1090: [
      { id: "T1090.001", name: "Internal Proxy" },
      { id: "T1090.002", name: "External Proxy" },
      { id: "T1090.003", name: "Multi-hop Proxy" },
      { id: "T1090.004", name: "Domain Fronting" },
    ],
    T1589: [
      { id: "T1589.001", name: "Credentials" },
      { id: "T1589.002", name: "Email Addresses" },
      { id: "T1589.003", name: "Employee Names" },
    ],
    T1683: [
      { id: "T1683.001", name: "Written Content" },
      { id: "T1683.002", name: "Audio-Visual Content" },
    ],
    T1593: [
      { id: "T1593.001", name: "Social Media" },
      { id: "T1593.002", name: "Search Engines" },
      { id: "T1593.003", name: "Code Repositories" },
    ],
    T1219: [
      { id: "T1219.001", name: "IDE Tunneling" },
      { id: "T1219.002", name: "Remote Desktop Software" },
      { id: "T1219.003", name: "Remote Access Hardware" },
    ],
    T1048: [
      {
        id: "T1048.001",
        name: "Exfiltration Over Symmetric Encrypted Non-C2 Protocol",
      },
      {
        id: "T1048.002",
        name: "Exfiltration Over Asymmetric Encrypted Non-C2 Protocol",
      },
      {
        id: "T1048.003",
        name: "Exfiltration Over Unencrypted Non-C2 Protocol",
      },
    ],
    T1550: [
      { id: "T1550.001", name: "Application Access Token" },
      { id: "T1550.002", name: "Pass the Hash" },
      { id: "T1550.003", name: "Pass the Ticket" },
      { id: "T1550.004", name: "Web Session Cookie" },
    ],
    T1020: [{ id: "T1020.001", name: "Traffic Duplication" }],
    T1127: [
      { id: "T1127.001", name: "MSBuild" },
      { id: "T1127.002", name: "ClickOnce" },
      { id: "T1127.003", name: "JamPlus" },
    ],
    T1102: [
      { id: "T1102.001", name: "Dead Drop Resolver" },
      { id: "T1102.002", name: "Bidirectional Communication" },
      { id: "T1102.003", name: "One-Way Communication" },
    ],
    T1052: [{ id: "T1052.001", name: "Exfiltration over USB" }],
    T1614: [{ id: "T1614.001", name: "System Language Discovery" }],
    T1001: [
      { id: "T1001.001", name: "Junk Data" },
      { id: "T1001.002", name: "Steganography" },
      { id: "T1001.003", name: "Protocol or Service Impersonation" },
    ],
    T1684: [
      { id: "T1684.001", name: "Impersonation" },
      { id: "T1684.002", name: "Email Spoofing" },
    ],
    T1601: [
      { id: "T1601.001", name: "Patch System Image" },
      { id: "T1601.002", name: "Downgrade System Image" },
    ],
  },
  procs: {
    T1016: [
      "2025 Poland Wiper Attacks (Campaign)",
      "Action RAT (Malware)",
      "AdFind (Tool)",
      "admin@338 (Group)",
      "Agent Tesla (Malware)",
      "Agent.btz (Malware)",
      "Amadey (Malware)",
      "Anchor (Malware)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "AppleSeed (Malware)",
      "APT1 (Group)",
      "APT19 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Aria-body (Malware)",
      "Arp (Tool)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Avaddon (Malware)",
      "Avenger (Malware)",
      "Azorult (Malware)",
      "BabyShark (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BADCALL (Malware)",
      "BADFLICK (Malware)",
      "Bandook (Malware)",
      "Bazar (Malware)",
      "Bisonal (Malware)",
      "BlackByte (Group)",
      "BlackEnergy (Malware)",
      "BLINDINGCAN (Malware)",
      "BLUELIGHT (Malware)",
      "BOLDMOVE (Malware)",
      "Bonadan (Malware)",
      "BoxCaon (Malware)",
      "Brave Prince (Malware)",
      "C0015 (Campaign)",
      "C0017 (Campaign)",
    ],
    "T1003.001": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "Bad Rabbit (Malware)",
      "Blue Mockingbird (Group)",
      "BRONZE BUTLER (Group)",
      "C0032 (Campaign)",
      "Cleaver (Group)",
      "Cobalt Strike (Malware)",
      "CozyCar (Malware)",
      "Cutting Edge (Campaign)",
      "Daserf (Malware)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "GALLIUM (Group)",
      "GreyEnergy (Malware)",
      "HAFNIUM (Group)",
      "HomeLand Justice (Campaign)",
      "Impacket (Tool)",
      "Indrik Spider (Group)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "LaZagne (Tool)",
      "Leafminer (Group)",
      "Leviathan (Group)",
    ],
    "T1573.002": [
      "adbupd (Malware)",
      "ADVSTORESHELL (Malware)",
      "APT41 DUST (Campaign)",
      "APT42 (Group)",
      "Attor (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BISCUIT (Malware)",
      "BOLDMOVE (Malware)",
      "BRICKSTORM (Malware)",
      "C0021 (Campaign)",
      "Carbon (Malware)",
      "CASTLETAP (Malware)",
      "CHOPSTICK (Malware)",
      "COATHANGER (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "ComRAT (Malware)",
      "Covenant (Tool)",
      "Cyclops Blink (Malware)",
      "DarkWatchman (Malware)",
      "DCRAT (Tool)",
      "Doki (Malware)",
      "Dridex (Malware)",
      "Empire (Tool)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "FRP (Tool)",
      "Gazer (Malware)",
      "GoldMax (Malware)",
      "Gomir (Malware)",
      "Grandoreiro (Malware)",
      "GreyEnergy (Malware)",
      "GrimAgent (Malware)",
      "Hi-Zor (Malware)",
      "HiddenFace (Malware)",
      "IcedID (Malware)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
      "J-magic (Malware)",
      "KEYPLUG (Malware)",
    ],
    "T1016.001": [
      "APT29 (Group)",
      "DarkTortilla (Malware)",
      "FIN13 (Group)",
      "FIN8 (Group)",
      "Gamaredon Group (Group)",
      "GoldFinder (Malware)",
      "HAFNIUM (Group)",
      "Havoc (Malware)",
      "HEXANE (Group)",
      "Lotus Blossom (Group)",
      "Magic Hound (Group)",
      "More_eggs (Malware)",
      "Neoichor (Malware)",
      "NKAbuse (Malware)",
      "Operation Wocao (Campaign)",
      "PUBLOAD (Malware)",
      "QakBot (Malware)",
      "QuietSieve (Malware)",
      "Rising Sun (Malware)",
      "SolarWinds Compromise (Campaign)",
      "SUGARUSH (Malware)",
      "SysUpdate (Malware)",
      "TA2541 (Group)",
      "Turla (Group)",
      "Volt Typhoon (Group)",
      "Woody RAT (Malware)",
    ],
    "T1090.004": [
      "APT29 (Group)",
      "Cobalt Strike (Malware)",
      "meek (Tool)",
      "Mythic (Tool)",
      "SMOKEDHAM (Malware)",
    ],
    T1124: [
      "Agent Tesla (Malware)",
      "AppleSeed (Malware)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "AvosLocker (Malware)",
      "Azorult (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BeaverTail (Malware)",
      "BendyBear (Malware)",
      "BISCUIT (Malware)",
      "Bisonal (Malware)",
      "BLUELIGHT (Malware)",
      "BRONZE BUTLER (Group)",
      "build_downer (Malware)",
      "C0015 (Campaign)",
      "Cannon (Malware)",
      "Carbon (Malware)",
      "ccf32 (Malware)",
      "Chimera (Group)",
      "Clambling (Malware)",
      "ComRAT (Malware)",
      "Conficker (Malware)",
      "Crimson (Malware)",
      "CURIUM (Group)",
      "DarkGate (Malware)",
      "Darkhotel (Group)",
      "DarkWatchman (Malware)",
      "DCSrv (Malware)",
      "DEADWOOD (Malware)",
      "DRATzarus (Malware)",
      "DUSTTRAP (Malware)",
      "Egregor (Malware)",
      "Epic (Malware)",
      "EvilBunny (Malware)",
      "FELIXROOT (Malware)",
      "FIN7 (Group)",
      "FunnyDream (Malware)",
      "GlassWorm (Malware)",
      "GoldMax (Malware)",
    ],
    "T1684.001": [
      "APT-C-36 (Group)",
      "APT28 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "C0027 (Campaign)",
      "Contagious Interview (Group)",
      "Kimsuky (Group)",
      "LAPSUS$ (Group)",
      "MirrorFace (Group)",
      "MuddyWater (Group)",
      "NPPSPY (Tool)",
      "Operation Dream Job (Campaign)",
      "RustyWater (Malware)",
      "Saint Bear (Group)",
      "Salesforce Data Exfiltration (Campaign)",
      "Scattered Spider (Group)",
      "Star Blizzard (Group)",
      "Storm-1811 (Group)",
      "VOID MANTICORE (Group)",
      "WIRTE (Group)",
    ],
    T1082: [
      "4H RAT (Malware)",
      "AcidPour (Malware)",
      "Action RAT (Malware)",
      "admin@338 (Group)",
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Akira (Malware)",
      "Amadey (Malware)",
      "Anchor (Malware)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT18 (Group)",
      "APT19 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Aquatic Panda (Group)",
      "ArcaneDoor (Campaign)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "AuTo Stealer (Malware)",
      "Avenger (Malware)",
      "Azorult (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BACKSPACE (Malware)",
      "BADCALL (Malware)",
      "BADFLICK (Malware)",
      "BADHATCH (Malware)",
      "BadPatch (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BeaverTail (Malware)",
      "BISCUIT (Malware)",
    ],
    T1572: [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "BRICKSTORM (Malware)",
      "Brute Ratel C4 (Tool)",
      "C0027 (Campaign)",
      "C0032 (Campaign)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "CostaRicto (Campaign)",
      "Cutting Edge (Campaign)",
      "Cyclops Blink (Malware)",
      "Duqu (Malware)",
      "Ember Bear (Group)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "FLIPSIDE (Malware)",
      "Fox Kitten (Group)",
      "FRP (Tool)",
      "FunnyDream (Malware)",
      "Heyoka Backdoor (Malware)",
      "HiddenFace (Malware)",
      "Industroyer (Malware)",
      "Kevin (Malware)",
      "Leviathan (Group)",
      "LunarWeb (Malware)",
      "Magic Hound (Group)",
      "Milan (Malware)",
      "Mustang Panda (Group)",
      "Mythic (Tool)",
      "Neo-reGeorg (Malware)",
      "ngrok (Tool)",
      "OilRig (Group)",
      "QakBot (Malware)",
      "reGeorg (Malware)",
      "Salt Typhoon (Group)",
      "Scattered Spider (Group)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "SPAWNCHIMERA (Malware)",
    ],
    T1539: [
      "APT42 (Group)",
      "BLUELIGHT (Malware)",
      "Chaes (Malware)",
      "CookieMiner (Malware)",
      "DarkGate (Malware)",
      "evilginx2 (Tool)",
      "Evilnum (Group)",
      "EVILNUM (Malware)",
      "GlassWorm (Malware)",
      "Grandoreiro (Malware)",
      "Kimsuky (Group)",
      "LODEINFO (Malware)",
      "Lotus Blossom (Group)",
      "LuminousMoth (Group)",
      "Lumma Stealer (Malware)",
      "MgBot (Malware)",
      "QakBot (Malware)",
      "Raccoon Stealer (Malware)",
      "RedLine Stealer (Malware)",
      "Sandworm Team (Group)",
      "Scattered Spider (Group)",
      "SolarWinds Compromise (Campaign)",
      "Spica (Malware)",
      "Star Blizzard (Group)",
      "TajMahal (Malware)",
      "TRANSLATEXT (Malware)",
      "XCSSET (Malware)",
      "XLoader (Malware)",
    ],
    T1490: [
      "2025 Poland Wiper Attacks (Campaign)",
      "Akira (Malware)",
      "Avaddon (Malware)",
      "Babuk (Malware)",
      "BFG Agonizer (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BlackByte Ransomware (Malware)",
      "BlackCat (Malware)",
      "Clop (Malware)",
      "Conficker (Malware)",
      "Conti (Malware)",
      "DarkGate (Malware)",
      "DarkWatchman (Malware)",
      "DEATHRANSOM (Malware)",
      "Diavol (Malware)",
      "EKANS (Malware)",
      "Embargo (Malware)",
      "FIVEHANDS (Malware)",
      "H1N1 (Malware)",
      "HELLOKITTY (Malware)",
      "HermeticWiper (Malware)",
      "INC Ransomware (Malware)",
      "InvisiMole (Malware)",
      "JCry (Malware)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "Maze (Malware)",
      "Medusa Group (Group)",
      "Medusa Ransomware (Malware)",
      "MegaCortex (Malware)",
      "Meteor (Malware)",
      "MultiLayer Wiper (Malware)",
      "Netwalker (Malware)",
      "Olympic Destroyer (Malware)",
      "Playcrypt (Malware)",
      "Prestige (Malware)",
      "ProLock (Malware)",
    ],
    T1012: [
      "ADVSTORESHELL (Malware)",
      "APT32 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Attor (Malware)",
      "Azorult (Malware)",
      "BabyShark (Malware)",
      "BACKSPACE (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BendyBear (Malware)",
      "Bisonal (Malware)",
      "BitPaymer (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "Brave Prince (Malware)",
      "Bumblebee (Malware)",
      "Carbanak (Malware)",
      "Carberp (Malware)",
      "Carbon (Malware)",
      "Cardinal RAT (Malware)",
      "CharmPower (Malware)",
      "Chimera (Group)",
      "CHOPSTICK (Malware)",
      "Clambling (Malware)",
      "Cobalt Strike (Malware)",
      "ComRAT (Malware)",
      "Crimson (Malware)",
      "Daggerfly (Group)",
      "DarkWatchman (Malware)",
      "Denis (Malware)",
      "Derusbi (Malware)",
      "DownPaper (Malware)",
      "Dragonfly (Group)",
      "Dtrack (Malware)",
      "DUSTTRAP (Malware)",
      "Epic (Malware)",
      "FatDuke (Malware)",
      "FELIXROOT (Malware)",
      "FinFisher (Malware)",
    ],
    "T1136.001": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT3 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Calisto (Malware)",
      "Carbanak (Malware)",
      "Daggerfly (Group)",
      "DarkGate (Malware)",
      "Dragonfly (Group)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "Flame (Malware)",
      "Fox Kitten (Group)",
      "GoldenSpy (Malware)",
      "HiddenWasp (Malware)",
      "Hildegard (Malware)",
      "Indrik Spider (Group)",
      "Kimsuky (Group)",
      "Leafminer (Group)",
      "Magic Hound (Group)",
      "Mis-Type (Malware)",
      "Net (Tool)",
      "Pupy (Tool)",
      "S-Type (Malware)",
      "ServHelper (Malware)",
      "SMOKEDHAM (Malware)",
      "TeamTNT (Group)",
      "Wizard Spider (Group)",
      "ZxShell (Malware)",
    ],
    T1135: [
      "Akira (Malware)",
      "APT1 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Avaddon (Malware)",
      "AvosLocker (Malware)",
      "Babuk (Malware)",
      "Bad Rabbit (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BitPaymer (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BlackByte Ransomware (Malware)",
      "BlackCat (Malware)",
      "C0015 (Campaign)",
      "Chimera (Group)",
      "Clambling (Malware)",
      "Clop (Malware)",
      "Cobalt Strike (Malware)",
      "Conti (Malware)",
      "CrackMapExec (Tool)",
      "Cuba (Malware)",
      "DarkVishnya (Group)",
      "DEATHRANSOM (Malware)",
      "Diavol (Malware)",
      "Dragonfly (Group)",
      "DUSTTRAP (Malware)",
      "Embargo (Malware)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "FIVEHANDS (Malware)",
      "Flagpro (Malware)",
      "HELLOKITTY (Malware)",
      "IcedID (Malware)",
      "INC Ransom (Group)",
      "INC Ransomware (Malware)",
    ],
    "T1547.009": [
      "APT39 (Group)",
      "Astaroth (Malware)",
      "BACKSPACE (Malware)",
      "Bazar (Malware)",
      "BlackEnergy (Malware)",
      "Comnie (Malware)",
      "Empire (Tool)",
      "FELIXROOT (Malware)",
      "Gazer (Malware)",
      "Gorgon Group (Group)",
      "Grandoreiro (Malware)",
      "Helminth (Malware)",
      "InvisiMole (Malware)",
      "Kazuar (Malware)",
      "KONNI (Malware)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "MarkiRAT (Malware)",
      "Micropsia (Malware)",
      "Okrum (Malware)",
      "Reaver (Malware)",
      "RedLeaves (Malware)",
      "RogueRobin (Malware)",
      "S-Type (Malware)",
      "SeaDuke (Malware)",
      "SHIPSHAPE (Malware)",
      "SPACESHIP (Malware)",
      "SslMM (Malware)",
      "TinyZBot (Malware)",
    ],
    "T1547.001": [
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Amadey (Malware)",
      "ANDROMEDA (Malware)",
      "AppleSeed (Malware)",
      "APT18 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Aria-body (Malware)",
      "Astaroth (Malware)",
      "AuTo Stealer (Malware)",
      "Avaddon (Malware)",
      "AvosLocker (Malware)",
      "BabyShark (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BACKSPACE (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
      "Bazar (Malware)",
      "BBSRAT (Malware)",
      "Bisonal (Malware)",
      "BitPaymer (Malware)",
      "BlackByte (Group)",
      "BlackEnergy (Malware)",
      "BoomBox (Malware)",
      "Briba (Malware)",
      "BRONZE BUTLER (Group)",
      "build_downer (Malware)",
      "Carbanak (Malware)",
      "Carberp (Malware)",
      "Cardinal RAT (Malware)",
      "Chaes (Malware)",
      "ChChes (Malware)",
    ],
    T1007: [
      "admin@338 (Group)",
      "APT1 (Group)",
      "Aquatic Panda (Group)",
      "Babuk (Malware)",
      "BBSRAT (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BRONZE BUTLER (Group)",
      "Caterpillar WebShell (Malware)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "Comnie (Malware)",
      "Cuba (Malware)",
      "DarkTortilla (Malware)",
      "Dyre (Malware)",
      "Earth Lusca (Group)",
      "Elise (Malware)",
      "Embargo (Malware)",
      "Emissary (Malware)",
      "Epic (Malware)",
      "GeminiDuke (Malware)",
      "GravityRAT (Malware)",
      "GreyEnergy (Malware)",
      "Heyoka Backdoor (Malware)",
      "HotCroissant (Malware)",
      "Hydraq (Malware)",
      "HyperBro (Malware)",
      "Indrik Spider (Group)",
      "InvisiMole (Malware)",
      "Ixeshe (Malware)",
      "JPIN (Malware)",
      "jRAT (Malware)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "Kwampirs (Malware)",
      "LAMEHUG (Malware)",
      "LookBack (Malware)",
      "Medusa Ransomware (Malware)",
      "MirrorFace (Group)",
      "Net (Tool)",
    ],
    "T1071.001": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "3CX Supply Chain Attack (Campaign)",
      "3PARA RAT (Malware)",
      "4H RAT (Malware)",
      "ABK (Malware)",
      "Action RAT (Malware)",
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Amadey (Malware)",
      "Anchor (Malware)",
      "ANDROMEDA (Malware)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT18 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "APT42 (Group)",
      "ArcaneDoor (Campaign)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "AuTo Stealer (Malware)",
      "Avenger (Malware)",
      "BackConfig (Malware)",
      "BACKSPACE (Malware)",
      "BADHATCH (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BBK (Malware)",
      "BBSRAT (Malware)",
      "BeaverTail (Malware)",
      "Bisonal (Malware)",
    ],
    "T1027.013": [
      "2025 Poland Wiper Attacks (Campaign)",
      "3CX Supply Chain Attack (Campaign)",
      "ANELLDR (Malware)",
      "APT-C-36 (Group)",
      "APT18 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT39 (Group)",
      "APT41 DUST (Campaign)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "Attor (Malware)",
      "AuditCred (Malware)",
      "Avenger (Malware)",
      "Bazar (Malware)",
      "BeaverTail (Malware)",
      "BendyBear (Malware)",
      "Bisonal (Malware)",
      "BitPaymer (Malware)",
      "BITTER (Group)",
      "BlackByte Ransomware (Malware)",
      "BLINDINGCAN (Malware)",
      "Blue Mockingbird (Group)",
      "BLUELIGHT (Malware)",
      "BOOKWORM (Malware)",
      "BOOSTWRITE (Malware)",
      "BRICKSTORM (Malware)",
      "Caminho (Malware)",
      "Carberp (Malware)",
      "Cardinal RAT (Malware)",
      "CARROTBAT (Malware)",
      "Chinoxy (Malware)",
      "Chrommme (Malware)",
      "Contagious Interview (Group)",
      "CorKLOG (Malware)",
      "CozyCar (Malware)",
      "Cuckoo Stealer (Malware)",
    ],
    "T1204.001": [
      "AppleJeus (Malware)",
      "APT-C-36 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "BackConfig (Malware)",
      "Bazar (Malware)",
      "BlackTech (Group)",
      "Bumblebee (Malware)",
      "C0011 (Campaign)",
      "C0021 (Campaign)",
      "Cobalt Group (Group)",
      "Confucius (Group)",
      "Contagious Interview (Group)",
      "Daggerfly (Group)",
      "Earth Lusca (Group)",
      "Elderwood (Group)",
      "Emotet (Malware)",
      "Evilnum (Group)",
      "EXOTIC LILY (Group)",
      "FIN4 (Group)",
      "FIN7 (Group)",
      "FIN8 (Group)",
      "Gamaredon Group (Group)",
      "Gootloader (Malware)",
      "Grandoreiro (Malware)",
      "GuLoader (Malware)",
      "Hancitor (Malware)",
      "Javali (Malware)",
      "Kerrdown (Malware)",
      "Kimsuky (Group)",
      "KOCTOPUS (Malware)",
      "Latrodectus (Malware)",
      "LazyScripter (Group)",
      "Leviathan (Group)",
      "LuminousMoth (Group)",
    ],
    "T1027.005": [
      "APT3 (Group)",
      "Cobalt Strike (Malware)",
      "Daserf (Malware)",
      "Deep Panda (Group)",
      "GALLIUM (Group)",
      "GravityRAT (Malware)",
      "InvisiMole (Malware)",
      "OilRig (Group)",
      "Operation Wocao (Campaign)",
      "Patchwork (Group)",
      "Penquin (Malware)",
      "PowerSploit (Tool)",
      "QakBot (Malware)",
      "SUNBURST (Malware)",
      "Triton Safety Instrumented System Attack (Campaign)",
      "Turla (Group)",
      "UNC3886 (Group)",
      "Waterbear (Malware)",
    ],
    "T1053.005": [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "Agent Tesla (Malware)",
      "Anchor (Malware)",
      "Apostle (Malware)",
      "AppleJeus (Malware)",
      "APT-C-36 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "AshTag (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "Bad Rabbit (Malware)",
      "BADHATCH (Malware)",
      "BADNEWS (Malware)",
      "Bazar (Malware)",
      "BITTER (Group)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "Blue Mockingbird (Group)",
      "BONDUPDATER (Malware)",
      "BRONZE BUTLER (Group)",
      "Bumblebee (Malware)",
      "C0017 (Campaign)",
      "C0032 (Campaign)",
      "Carbon (Malware)",
      "ccf32 (Malware)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
      "CLAIMLOADER (Malware)",
      "Cobalt Group (Group)",
      "ComRAT (Malware)",
    ],
    "T1070.004": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "AcidPour (Malware)",
      "ADVSTORESHELL (Malware)",
      "Anchor (Malware)",
      "Apostle (Malware)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT18 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "ArcaneDoor (Campaign)",
      "Aria-body (Malware)",
      "Attor (Malware)",
      "AuditCred (Malware)",
      "Azorult (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BADHATCH (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BBSRAT (Malware)",
      "BeaverTail (Malware)",
      "Bisonal (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BLACKCOFFEE (Malware)",
      "BLINDINGCAN (Malware)",
      "BLUELIGHT (Malware)",
      "BOLDMOVE (Malware)",
      "BPFDoor (Malware)",
    ],
    T1102: [
      "APT32 (Group)",
      "APT41 DUST (Campaign)",
      "APT42 (Group)",
      "AshTag (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BoomBox (Malware)",
      "BRICKSTORM (Malware)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "C0017 (Campaign)",
      "C0027 (Campaign)",
      "Carbon (Malware)",
      "CharmPower (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "DarkTortilla (Malware)",
      "Doki (Malware)",
      "DropBook (Malware)",
      "EXOTIC LILY (Group)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "Gamaredon Group (Group)",
      "GuLoader (Malware)",
      "Hildegard (Malware)",
      "Inception (Group)",
      "Latrodectus (Malware)",
      "LazyScripter (Group)",
      "MOPSLED (Malware)",
      "Mustang Panda (Group)",
      "NETWIRE (Malware)",
      "ngrok (Tool)",
      "Nightdoor (Malware)",
      "Operation Spalax (Campaign)",
      "PureCrypter (Malware)",
      "Raspberry Robin (Malware)",
      "RedCurl (Group)",
      "RedLine Stealer (Malware)",
      "Rocke (Group)",
      "SharpStage (Malware)",
    ],
    "T1059.001": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "2022 Ukraine Electric Power Attack (Campaign)",
      "AADInternals (Tool)",
      "Akira (Malware)",
      "Akira (Group)",
      "AppleSeed (Malware)",
      "APT-C-36 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "AutoIt backdoor (Malware)",
      "BADHATCH (Malware)",
      "Bandook (Malware)",
      "Bazar (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BloodHound (Tool)",
      "Blue Mockingbird (Group)",
      "BONDUPDATER (Malware)",
      "BRONZE BUTLER (Group)",
      "Bumblebee (Malware)",
      "C0018 (Campaign)",
      "C0021 (Campaign)",
      "C0032 (Campaign)",
      "CharmPower (Malware)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
      "Cinnamon Tempest (Group)",
      "Clambling (Malware)",
      "Cobalt Group (Group)",
    ],
    T1486: [
      "Akira (Malware)",
      "Akira (Group)",
      "Akira _v2 (Malware)",
      "Apostle (Malware)",
      "APT38 (Group)",
      "APT41 (Group)",
      "Avaddon (Malware)",
      "AvosLocker (Malware)",
      "Babuk (Malware)",
      "Bad Rabbit (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BlackByte Ransomware (Malware)",
      "BlackCat (Malware)",
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "Cheerscrypt (Malware)",
      "Clop (Malware)",
      "Conti (Malware)",
      "Cuba (Malware)",
      "DarkGate (Malware)",
      "DCSrv (Malware)",
      "DEATHRANSOM (Malware)",
      "Diavol (Malware)",
      "Egregor (Malware)",
      "EKANS (Malware)",
      "Embargo (Malware)",
      "FIN7 (Group)",
      "FIN8 (Group)",
      "FIVEHANDS (Malware)",
      "HELLOKITTY (Malware)",
      "HomeLand Justice (Campaign)",
      "INC Ransom (Group)",
      "INC Ransomware (Malware)",
      "Indrik Spider (Group)",
      "JCry (Malware)",
      "KillDisk (Malware)",
      "LockBit 2.0 (Malware)",
    ],
    "T1497.003": [
      "AppleJeus (Malware)",
      "BADFLICK (Malware)",
      "Bazar (Malware)",
      "BendyBear (Malware)",
      "Bisonal (Malware)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "Clambling (Malware)",
      "Clop (Malware)",
      "Crimson (Malware)",
      "DarkTortilla (Malware)",
      "DRATzarus (Malware)",
      "Egregor (Malware)",
      "EvilBunny (Malware)",
      "evilginx2 (Tool)",
      "FatDuke (Malware)",
      "GoldenSpy (Malware)",
      "GoldMax (Malware)",
      "Gootloader (Malware)",
      "GrimAgent (Malware)",
      "GuLoader (Malware)",
      "Havoc (Malware)",
      "HermeticWiper (Malware)",
      "HiddenFace (Malware)",
      "IPsec Helper (Malware)",
      "LiteDuke (Malware)",
      "Lokibot (Malware)",
      "LunarWeb (Malware)",
      "metaMain (Malware)",
      "Okrum (Malware)",
      "Operation Dream Job (Campaign)",
      "P8RAT (Malware)",
      "Pony (Malware)",
      "QakBot (Malware)",
      "Raindrop (Malware)",
      "RansomHub (Malware)",
      "Saint Bot (Malware)",
      "Snip3 (Malware)",
      "SodaMaster (Malware)",
      "StrifeWater (Malware)",
    ],
    T1571: [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT-C-36 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "BADCALL (Malware)",
      "Bankshot (Malware)",
      "BeaverTail (Malware)",
      "BendyBear (Malware)",
      "C0018 (Campaign)",
      "C0032 (Campaign)",
      "Contagious Interview (Group)",
      "Covenant (Tool)",
      "Cyclops Blink (Malware)",
      "DarkVishnya (Group)",
      "Derusbi (Malware)",
      "Ember Bear (Group)",
      "Emotet (Malware)",
      "FIN7 (Group)",
      "Gamaredon Group (Group)",
      "GlassWorm (Malware)",
      "GoldenSpy (Malware)",
      "GravityRAT (Malware)",
      "Hannotog (Malware)",
      "HARDRAIN (Malware)",
      "HiddenFace (Malware)",
      "HOPLIGHT (Malware)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
      "InvisibleFerret (Malware)",
      "KV Botnet Activity (Campaign)",
      "Lazarus Group (Group)",
      "MacMa (Malware)",
      "Magic Hound (Group)",
      "Metamorfo (Malware)",
      "MoonWind (Malware)",
      "MuddyWater (Group)",
      "njRAT (Malware)",
      "Operation Wocao (Campaign)",
      "OSX_OCEANLOTUS.D (Malware)",
      "Pikabot (Malware)",
      "PingPull (Malware)",
    ],
    "T1059.005": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "2016 Ukraine Electric Power Attack (Campaign)",
      "APT-C-36 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT42 (Group)",
      "Astaroth (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "Bandook (Malware)",
      "Bisonal (Malware)",
      "BRONZE BUTLER (Group)",
      "Bumblebee (Malware)",
      "C0011 (Campaign)",
      "C0015 (Campaign)",
      "Chaes (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Comnie (Malware)",
      "Confucius (Group)",
      "Contagious Interview (Group)",
      "DanBot (Malware)",
      "DarkGate (Malware)",
      "Donut (Tool)",
      "Earth Lusca (Group)",
      "Emotet (Malware)",
      "Exaramel for Windows (Malware)",
      "Ferocious (Malware)",
      "FIN13 (Group)",
      "FIN4 (Group)",
      "FIN7 (Group)",
      "Flagpro (Malware)",
      "Frankenstein (Campaign)",
      "FunnyDream (Campaign)",
      "Gamaredon Group (Group)",
      "Goopy (Malware)",
    ],
    "T1021.002": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Anchor (Malware)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BlackEnergy (Malware)",
      "Blue Mockingbird (Group)",
      "Brute Ratel C4 (Tool)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Cobalt Strike (Malware)",
      "Conficker (Malware)",
      "Conti (Malware)",
      "Cutting Edge (Campaign)",
      "Deep Panda (Group)",
      "Diavol (Malware)",
      "Duqu (Malware)",
      "Emotet (Malware)",
      "FIN13 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "HermeticWizard (Malware)",
      "HomeLand Justice (Campaign)",
      "Ke3chang (Group)",
      "Kwampirs (Malware)",
      "Lazarus Group (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "Lucifer (Malware)",
      "MirrorFace (Group)",
      "Moses Staff (Group)",
      "Net (Tool)",
      "Net Crawler (Malware)",
    ],
    T1083: [
      "2025 Poland Wiper Attacks (Campaign)",
      "3PARA RAT (Malware)",
      "4H RAT (Malware)",
      "AcidPour (Malware)",
      "AcidRain (Malware)",
      "Action RAT (Malware)",
      "admin@338 (Group)",
      "ADVSTORESHELL (Malware)",
      "Akira (Malware)",
      "Akira _v2 (Malware)",
      "Amadey (Malware)",
      "ANELLDR (Malware)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "Aoqin Dragon (Group)",
      "AppleSeed (Malware)",
      "APT18 (Group)",
      "APT28 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "Attor (Malware)",
      "AuditCred (Malware)",
      "AutoIt backdoor (Malware)",
      "Avaddon (Malware)",
      "Avenger (Malware)",
      "AvosLocker (Malware)",
      "Azorult (Malware)",
      "Babuk (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BACKSPACE (Malware)",
      "BADFLICK (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
    ],
    T1681: ["Contagious Interview (Group)", "UNC3886 (Group)"],
    "T1102.003": [
      "ArcaneDoor (Campaign)",
      "EVILNUM (Malware)",
      "Gamaredon Group (Group)",
      "HAMMERTOSS (Malware)",
      "Leviathan (Group)",
      "Metamorfo (Malware)",
      "OnionDuke (Malware)",
      "Sagerunex (Malware)",
      "UPSTYLE (Malware)",
    ],
    "T1569.002": [
      "Anchor (Malware)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "Attor (Malware)",
      "Bad Rabbit (Malware)",
      "BBSRAT (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "Blue Mockingbird (Group)",
      "Brute Ratel C4 (Tool)",
      "Chimera (Group)",
      "Clambling (Malware)",
      "Cobalt Strike (Malware)",
      "DarkGate (Malware)",
      "DEADWOOD (Malware)",
      "Embargo (Malware)",
      "Empire (Tool)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "gh0st RAT (Malware)",
      "HermeticWiper (Malware)",
      "HermeticWizard (Malware)",
      "HOPLIGHT (Malware)",
      "Hydraq (Malware)",
      "HyperBro (Malware)",
      "Impacket (Tool)",
      "INC Ransom (Group)",
      "InvisiMole (Malware)",
      "IPsec Helper (Malware)",
      "Ke3chang (Group)",
      "Koadic (Tool)",
      "LockBit 3.0 (Malware)",
      "LoudMiner (Malware)",
      "Mafalda (Malware)",
      "Medusa Group (Group)",
      "Moonstone Sleet (Group)",
      "Net (Tool)",
    ],
    T1560: [
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT32 (Group)",
      "Aria-body (Malware)",
      "Axiom (Group)",
      "Backdoor.Oldrea (Malware)",
      "BlackByte (Group)",
      "BloodHound (Tool)",
      "BLUELIGHT (Malware)",
      "Bumblebee (Malware)",
      "Cadelspy (Malware)",
      "Chrommme (Malware)",
      "Daserf (Malware)",
      "Dragonfly (Group)",
      "Dtrack (Malware)",
      "Ember Bear (Group)",
      "Empire (Tool)",
      "Epic (Malware)",
      "Exaramel for Windows (Malware)",
      "FELIXROOT (Malware)",
      "FIN6 (Group)",
      "Gold Dragon (Malware)",
      "JumbledPath (Malware)",
      "Ke3chang (Group)",
      "Kessel (Malware)",
      "KONNI (Malware)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "LightNeuron (Malware)",
      "Lizar (Malware)",
      "LoFiSe (Malware)",
      "LP-Notes (Malware)",
      "LuminousMoth (Group)",
      "Lurid (Malware)",
      "Machete (Malware)",
      "menuPass (Group)",
      "MuddyViper (Malware)",
      "NETWIRE (Malware)",
    ],
    "T1102.001": [
      "3CX Supply Chain Attack (Campaign)",
      "APT41 (Group)",
      "Astaroth (Malware)",
      "BADNEWS (Malware)",
      "BLACKCOFFEE (Malware)",
      "BRONZE BUTLER (Group)",
      "C0017 (Campaign)",
      "CharmPower (Malware)",
      "GlassWorm (Malware)",
      "Grandoreiro (Malware)",
      "Javali (Malware)",
      "KEYPLUG (Malware)",
      "Kimsuky (Group)",
      "Metamorfo (Malware)",
      "MiniDuke (Malware)",
      "MOPSLED (Malware)",
      "Patchwork (Group)",
      "PlugX (Malware)",
      "PolyglotDuke (Malware)",
      "Rocke (Group)",
      "RTM (Malware)",
      "RTM (Group)",
      "TRANSLATEXT (Malware)",
      "Tsundere Botnet (Malware)",
      "Xbash (Malware)",
    ],
    "T1548.003": [
      "Cobalt Strike (Malware)",
      "Dok (Malware)",
      "Proton (Malware)",
      "Shai-Hulud (Malware)",
    ],
    "T1588.003": [
      "APT41 DUST (Campaign)",
      "BlackTech (Group)",
      "FIN8 (Group)",
      "HomeLand Justice (Campaign)",
      "Kimsuky (Group)",
      "MegaCortex (Malware)",
      "Mustang Panda (Group)",
      "OilRig (Group)",
      "Operation Dream Job (Campaign)",
      "Threat Group-3390 (Group)",
      "Wizard Spider (Group)",
    ],
    "T1071.004": [
      "Anchor (Malware)",
      "APT18 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "BONDUPDATER (Malware)",
      "BRICKSTORM (Malware)",
      "Brute Ratel C4 (Tool)",
      "Chimera (Group)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Cobian RAT (Malware)",
      "Cutting Edge (Campaign)",
      "DanBot (Malware)",
      "DarkGate (Malware)",
      "Denis (Malware)",
      "DnsSystem (Malware)",
      "Ebury (Malware)",
      "Ember Bear (Group)",
      "FIN7 (Group)",
      "Gelsemium (Malware)",
      "Goopy (Malware)",
      "Green Lambert (Malware)",
      "Helminth (Malware)",
      "Heyoka Backdoor (Malware)",
      "HTTPBrowser (Malware)",
      "InvisiMole (Malware)",
      "Ke3chang (Group)",
      "Kevin (Malware)",
      "LazyScripter (Group)",
      "Matryoshka (Malware)",
      "Milan (Malware)",
      "Mori (Malware)",
      "Mythic (Tool)",
      "NanHaiShu (Malware)",
      "NightClub (Malware)",
      "OilRig (Group)",
      "Pisloader (Malware)",
      "PlugX (Malware)",
      "POWERSOURCE (Malware)",
      "POWRUNER (Malware)",
    ],
    T1025: [
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "Aria-body (Malware)",
      "BADNEWS (Malware)",
      "CosmicDuke (Malware)",
      "Crimson (Malware)",
      "Crutch (Malware)",
      "Explosive (Malware)",
      "FLASHFLOOD (Malware)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "GravityRAT (Malware)",
      "InvisiMole (Malware)",
      "Machete (Malware)",
      "MgBot (Malware)",
      "ObliqueRAT (Malware)",
      "OilRig (Group)",
      "Prikormka (Malware)",
      "Ramsay (Malware)",
      "Remsec (Malware)",
      "Rover (Malware)",
      "TajMahal (Malware)",
      "Turla (Group)",
      "USBStealer (Malware)",
    ],
    T1091: [
      "Agent.btz (Malware)",
      "ANDROMEDA (Malware)",
      "Aoqin Dragon (Group)",
      "APT28 (Group)",
      "CHOPSTICK (Malware)",
      "Conficker (Malware)",
      "Crimson (Malware)",
      "Darkhotel (Group)",
      "DustySky (Malware)",
      "FIN7 (Group)",
      "Flame (Malware)",
      "Gamaredon Group (Group)",
      "H1N1 (Malware)",
      "HIUPAN (Malware)",
      "LuminousMoth (Group)",
      "Mustang Panda (Group)",
      "njRAT (Malware)",
      "PlugX (Malware)",
      "QakBot (Malware)",
      "Ramsay (Malware)",
      "Raspberry Robin (Malware)",
      "SHIPSHAPE (Malware)",
      "Stuxnet (Malware)",
      "Tropic Trooper (Group)",
      "Unknown Logger (Malware)",
      "Ursnif (Malware)",
      "USBferry (Malware)",
      "USBStealer (Malware)",
    ],
    T1106: [
      "ADVSTORESHELL (Malware)",
      "Akira (Malware)",
      "Amadey (Malware)",
      "ANELLDR (Malware)",
      "AppleSeed (Malware)",
      "APT37 (Group)",
      "APT38 (Group)",
      "Aria-body (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "Avaddon (Malware)",
      "AvosLocker (Malware)",
      "Babuk (Malware)",
      "BackConfig (Malware)",
      "Bad Rabbit (Malware)",
      "BADHATCH (Malware)",
      "BADNEWS (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BBK (Malware)",
      "BendyBear (Malware)",
      "Bisonal (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BlackByte Ransomware (Malware)",
      "BlackTech (Group)",
      "BloodHound (Tool)",
      "BOOKWORM (Malware)",
      "BoxCaon (Malware)",
      "Brute Ratel C4 (Tool)",
      "build_downer (Malware)",
      "Bumblebee (Malware)",
      "CaddyWiper (Malware)",
      "Caminho (Malware)",
      "CANONSTAGER (Malware)",
      "Carberp (Malware)",
      "Chaes (Malware)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
    ],
    "T1564.005": [
      "BOOTRASH (Malware)",
      "ComRAT (Malware)",
      "Equation (Group)",
      "Regin (Malware)",
      "Strider (Group)",
      "Uroburos (Malware)",
    ],
    T1113: [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agent Tesla (Malware)",
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT39 (Group)",
      "APT42 (Group)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "Azorult (Malware)",
      "BADHATCH (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
      "Bandook (Malware)",
      "BISCUIT (Malware)",
      "BlackEnergy (Malware)",
      "BLUELIGHT (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "Cadelspy (Malware)",
      "Cannon (Malware)",
      "Carbanak (Malware)",
      "Carberp (Malware)",
      "Cardinal RAT (Malware)",
      "Catchamas (Malware)",
      "Chaes (Malware)",
      "CharmPower (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "CHOPSTICK (Malware)",
      "Chrommme (Malware)",
      "Clambling (Malware)",
      "Cobalt Strike (Malware)",
      "Cobian RAT (Malware)",
      "ConnectWise (Tool)",
      "CosmicDuke (Malware)",
      "Crimson (Malware)",
      "CrossRAT (Malware)",
      "Cuckoo Stealer (Malware)",
      "Dark Caracal (Group)",
    ],
    T1033: [
      "Action RAT (Malware)",
      "Agent Tesla (Malware)",
      "Agent.btz (Malware)",
      "Amadey (Malware)",
      "APT19 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "Aria-body (Malware)",
      "AsyncRAT (Tool)",
      "AuTo Stealer (Malware)",
      "Azorult (Malware)",
      "BabyShark (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BISCUIT (Malware)",
      "BlackCat (Malware)",
      "BloodHound (Tool)",
      "BLUELIGHT (Malware)",
      "Bonadan (Malware)",
      "BOOKWORM (Malware)",
      "BoomBox (Malware)",
      "Bumblebee (Malware)",
      "C0017 (Campaign)",
      "C0018 (Campaign)",
      "Cannon (Malware)",
      "Cardinal RAT (Malware)",
      "Caterpillar WebShell (Malware)",
      "Chaes (Malware)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
      "Chrommme (Malware)",
      "Clambling (Malware)",
      "CreepySnail (Malware)",
      "Crimson (Malware)",
    ],
    "T1134.002": [
      "Aria-body (Malware)",
      "Azorult (Malware)",
      "Bankshot (Malware)",
      "Empire (Tool)",
      "KONNI (Malware)",
      "Lazarus Group (Group)",
      "PipeMon (Malware)",
      "PoshC2 (Tool)",
      "REvil (Malware)",
      "TONESHELL (Malware)",
      "Turla (Group)",
      "WhisperGate (Malware)",
      "ZxShell (Malware)",
    ],
    T1105: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "ABK (Malware)",
      "Action RAT (Malware)",
      "Agent Tesla (Malware)",
      "Agent.btz (Malware)",
      "Ajax Security Team (Group)",
      "Amadey (Malware)",
      "Anchor (Malware)",
      "Andariel (Group)",
      "ANDROMEDA (Malware)",
      "APT-C-36 (Group)",
      "APT18 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "Aquatic Panda (Group)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "AuditCred (Malware)",
      "Avenger (Malware)",
      "Azorult (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADFLICK (Malware)",
      "BADHATCH (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
    ],
    "T1606.002": ["AADInternals (Tool)", "SolarWinds Compromise (Campaign)"],
    "T1553.002": [
      "3CX Supply Chain Attack (Campaign)",
      "Anchor (Malware)",
      "AppleJeus (Malware)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "BackConfig (Malware)",
      "Bandook (Malware)",
      "Bazar (Malware)",
      "Black Basta (Malware)",
      "BLINDINGCAN (Malware)",
      "BOOKWORM (Malware)",
      "BOOSTWRITE (Malware)",
      "C0015 (Campaign)",
      "ChChes (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Clop (Malware)",
      "Cobalt Strike (Malware)",
      "CopyKittens (Group)",
      "CorKLOG (Malware)",
      "CSPY Downloader (Tool)",
      "Daggerfly (Group)",
      "Darkhotel (Group)",
      "Daserf (Malware)",
      "Ebury (Malware)",
      "Ecipekac (Malware)",
      "Epic (Malware)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "GALLIUM (Group)",
      "Gazer (Malware)",
      "GoBear (Malware)",
      "GreyEnergy (Malware)",
      "Helminth (Malware)",
      "HermeticWiper (Malware)",
      "HermeticWizard (Malware)",
      "Janicab (Malware)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "LockerGoga (Malware)",
    ],
    T1614: [
      "Amadey (Malware)",
      "AshTag (Malware)",
      "Crimson (Malware)",
      "Cuckoo Stealer (Malware)",
      "DarkGate (Malware)",
      "DarkWatchman (Malware)",
      "GlassWorm (Malware)",
      "Gootloader (Malware)",
      "GrimAgent (Malware)",
      "HexEval Loader (Malware)",
      "InvisibleFerret (Malware)",
      "PlugX (Malware)",
      "PureCrypter (Malware)",
      "QuasarRAT (Tool)",
      "Raccoon Stealer (Malware)",
      "Ragnar Locker (Malware)",
      "RedLine Stealer (Malware)",
      "Remcos (Tool)",
      "Saint Bot (Malware)",
      "SameCoin (Malware)",
      "SDBbot (Malware)",
      "SideCopy (Group)",
      "SocGholish (Malware)",
      "Tsundere Botnet (Malware)",
      "Volt Typhoon (Group)",
      "XORIndex Loader (Malware)",
    ],
    T1059: [
      "APT19 (Group)",
      "APT32 (Group)",
      "APT37 (Group)",
      "APT39 (Group)",
      "ArcaneDoor (Campaign)",
      "Bandook (Malware)",
      "Bonadan (Malware)",
      "CHOPSTICK (Malware)",
      "Cutting Edge (Campaign)",
      "DarkComet (Malware)",
      "Donut (Tool)",
      "Dragonfly (Group)",
      "Empire (Tool)",
      "FIN5 (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "FIVEHANDS (Malware)",
      "FLORAHOX Activity (Campaign)",
      "Fox Kitten (Group)",
      "Get2 (Malware)",
      "gh0st RAT (Malware)",
      "Imminent Monitor (Tool)",
      "Ke3chang (Group)",
      "Kessel (Malware)",
      "Matryoshka (Malware)",
      "MuddyViper (Malware)",
      "Mustang Panda (Group)",
      "NICECURL (Malware)",
      "OilRig (Group)",
      "Operation Spalax (Campaign)",
      "P.A.S. Webshell (Malware)",
      "Raspberry Robin (Malware)",
      "Saint Bear (Group)",
      "SLIGHTPULSE (Malware)",
      "SpeakUp (Malware)",
      "StarProxy (Malware)",
      "Stealth Falcon (Group)",
      "VersaMem (Malware)",
      "Whitefly (Group)",
      "Windigo (Group)",
    ],
    "T1078.004": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT33 (Group)",
      "APT5 (Group)",
      "C0027 (Campaign)",
      "HAFNIUM (Group)",
      "Ke3chang (Group)",
      "LAPSUS$ (Group)",
      "Pacu (Tool)",
      "Peirates (Tool)",
      "ROADTools (Tool)",
      "Scattered Spider (Group)",
      "Shai-Hulud (Malware)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
      "TruffleHog (Tool)",
      "VOID MANTICORE (Group)",
    ],
    T1047: [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Action RAT (Malware)",
      "Agent Tesla (Malware)",
      "Akira (Malware)",
      "APT-C-36 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Aquatic Panda (Group)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "Avaddon (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackCat (Malware)",
      "BlackEnergy (Malware)",
      "Blue Mockingbird (Group)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "C0027 (Campaign)",
      "CharmPower (Malware)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Cobalt Strike (Malware)",
      "Covenant (Tool)",
      "CrackMapExec (Tool)",
      "DarkGate (Malware)",
      "DarkTortilla (Malware)",
      "DarkWatchman (Malware)",
      "DEATHRANSOM (Malware)",
      "Deep Panda (Group)",
      "DustySky (Malware)",
      "Earth Lusca (Group)",
      "EKANS (Malware)",
      "Ember Bear (Group)",
    ],
    "T1027.010": [
      "APT19 (Group)",
      "APT32 (Group)",
      "Aquatic Panda (Group)",
      "Astaroth (Malware)",
      "BackConfig (Malware)",
      "BADHATCH (Malware)",
      "C0018 (Campaign)",
      "C0021 (Campaign)",
      "CARROTBAT (Malware)",
      "Chimera (Group)",
      "Cobalt Group (Group)",
      "ComRAT (Malware)",
      "Contagious Interview (Group)",
      "CookieMiner (Malware)",
      "DarkWatchman (Malware)",
      "Denis (Malware)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "Frankenstein (Campaign)",
      "FruitFly (Malware)",
      "Gamaredon Group (Group)",
      "GOLD SOUTHFIELD (Group)",
      "Havoc (Malware)",
      "HEXANE (Group)",
      "IceApple (Malware)",
      "IronWind (Malware)",
      "Kimsuky (Group)",
      "KOCTOPUS (Malware)",
      "LazyScripter (Group)",
      "Leafminer (Group)",
      "LoudMiner (Malware)",
      "Machete (Malware)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "MuddyWater (Group)",
      "Netwalker (Malware)",
    ],
    "T1003.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT29 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "C0017 (Campaign)",
      "Cobalt Strike (Malware)",
      "CosmicDuke (Malware)",
      "CozyCar (Malware)",
      "CrackMapExec (Tool)",
      "Daggerfly (Group)",
      "Dragonfly (Group)",
      "Ember Bear (Group)",
      "Fgdump (Tool)",
      "FIN13 (Group)",
      "FrostyGoop Incident (Campaign)",
      "GALLIUM (Group)",
      "gsecdump (Tool)",
      "HOPLIGHT (Malware)",
      "IceApple (Malware)",
      "Impacket (Tool)",
      "Ke3chang (Group)",
      "Koadic (Tool)",
      "menuPass (Group)",
      "Mimikatz (Tool)",
      "MirrorFace (Group)",
      "Mivast (Malware)",
      "Night Dragon (Campaign)",
      "Operation CuckooBees (Campaign)",
      "Operation Digital Eye (Campaign)",
      "POWERTON (Malware)",
      "pwdump (Tool)",
      "Remsec (Malware)",
      "Threat Group-3390 (Group)",
      "Wizard Spider (Group)",
    ],
    T1041: [
      "ADVSTORESHELL (Malware)",
      "Agrius (Group)",
      "Amadey (Malware)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT39 (Group)",
      "ArcaneDoor (Campaign)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "Attor (Malware)",
      "AuTo Stealer (Malware)",
      "BACKSPACE (Malware)",
      "BADHATCH (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "BeaverTail (Malware)",
      "Bisonal (Malware)",
      "BlackByte (Group)",
      "BLINDINGCAN (Malware)",
      "BLUELIGHT (Malware)",
      "BoxCaon (Malware)",
      "BRICKSTORM (Malware)",
      "Bumblebee (Malware)",
      "C0017 (Campaign)",
      "CallMe (Malware)",
      "Cannon (Malware)",
      "Carberp (Malware)",
      "Caterpillar WebShell (Malware)",
      "CharmPower (Malware)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
      "Chrommme (Malware)",
      "Confucius (Group)",
      "Contagious Interview (Group)",
      "CreepySnail (Malware)",
      "Crimson (Malware)",
      "Crutch (Malware)",
      "Cuckoo Stealer (Malware)",
    ],
    "T1556.004": [
      "DRYHOOK (Malware)",
      "SLOWPULSE (Malware)",
      "SYNful Knock (Malware)",
    ],
    T1680: [
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "Avenger (Malware)",
      "Babuk (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "Black Basta (Malware)",
      "BlackCat (Malware)",
      "BlackMould (Malware)",
      "BLINDINGCAN (Malware)",
      "build_downer (Malware)",
      "C0017 (Campaign)",
      "Cannon (Malware)",
      "Chimera (Group)",
      "Chrommme (Malware)",
      "Confucius (Group)",
      "CORESHELL (Malware)",
      "CrackMapExec (Tool)",
      "Crimson (Malware)",
      "Cuba (Malware)",
      "DarkGate (Malware)",
      "DEATHRANSOM (Malware)",
      "down_new (Malware)",
      "DynoWiper (Malware)",
      "Epic (Malware)",
      "FALLCHILL (Malware)",
      "FELIXROOT (Malware)",
      "FunnyDream (Malware)",
      "HELLOKITTY (Malware)",
      "HermeticWiper (Malware)",
      "Heyoka Backdoor (Malware)",
      "Higaisa (Group)",
      "HOPLIGHT (Malware)",
      "INC Ransomware (Malware)",
      "InnaputRAT (Malware)",
      "InvisiMole (Malware)",
      "JHUHUGIT (Malware)",
      "Kazuar (Malware)",
    ],
    "T1560.001": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "Akira (Group)",
      "AppleSeed (Malware)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT3 (Group)",
      "APT33 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "BeaverTail (Malware)",
      "BRONZE BUTLER (Group)",
      "C0026 (Campaign)",
      "Calisto (Malware)",
      "ccf32 (Malware)",
      "certutil (Tool)",
      "Chimera (Group)",
      "CopyKittens (Group)",
      "CORALDECK (Malware)",
      "Crutch (Malware)",
      "Cutting Edge (Campaign)",
      "Daserf (Malware)",
      "DustySky (Malware)",
      "Earth Lusca (Group)",
      "FIN13 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "FunnyDream (Campaign)",
      "GALLIUM (Group)",
      "Gallmaker (Group)",
      "GlassWorm (Malware)",
      "HAFNIUM (Group)",
      "IceApple (Malware)",
      "iKitten (Malware)",
      "INC Ransom (Group)",
      "InvisibleFerret (Malware)",
    ],
    T1140: [
      "2025 Poland Wiper Attacks (Campaign)",
      "ABK (Malware)",
      "Action RAT (Malware)",
      "Agent Tesla (Malware)",
      "Agrius (Group)",
      "Amadey (Malware)",
      "ANELLDR (Malware)",
      "Apostle (Malware)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT38 (Group)",
      "APT39 (Group)",
      "ArcaneDoor (Campaign)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "AuditCred (Malware)",
      "Avaddon (Malware)",
      "Avenger (Malware)",
      "AvosLocker (Malware)",
      "Azorult (Malware)",
      "Babuk (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "BADFLICK (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BBK (Malware)",
      "BBSRAT (Malware)",
      "BendyBear (Malware)",
      "Bisonal (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BLINDINGCAN (Malware)",
      "BOOKWORM (Malware)",
      "BoomBox (Malware)",
    ],
    "T1087.002": [
      "AdFind (Tool)",
      "APT41 (Group)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BlackByte (Group)",
      "BlackCat (Malware)",
      "BloodHound (Tool)",
      "BoomBox (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "CrackMapExec (Tool)",
      "Dragonfly (Group)",
      "dsquery (Tool)",
      "DUSTTRAP (Malware)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "Fox Kitten (Group)",
      "IceApple (Malware)",
      "IcedID (Malware)",
      "INC Ransom (Group)",
      "Ke3chang (Group)",
      "LAMEHUG (Malware)",
      "LAPSUS$ (Group)",
      "Latrodectus (Malware)",
      "Lotus Blossom (Group)",
      "menuPass (Group)",
      "MgBot (Malware)",
      "MirrorFace (Group)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "Net (Tool)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "Operation Dream Job (Campaign)",
      "Operation Wocao (Campaign)",
      "OSInfo (Malware)",
    ],
    "T1566.002": [
      "AADInternals (Tool)",
      "AppleJeus (Malware)",
      "APT-C-36 (Group)",
      "APT1 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT39 (Group)",
      "APT42 (Group)",
      "Bazar (Malware)",
      "BlackTech (Group)",
      "Bumblebee (Malware)",
      "C0011 (Campaign)",
      "C0021 (Campaign)",
      "Cobalt Group (Group)",
      "Confucius (Group)",
      "DarkGate (Malware)",
      "Earth Lusca (Group)",
      "Elderwood (Group)",
      "Emotet (Malware)",
      "Evilnum (Group)",
      "EXOTIC LILY (Group)",
      "FIN4 (Group)",
      "FIN7 (Group)",
      "FIN8 (Group)",
      "Grandoreiro (Malware)",
      "GuLoader (Malware)",
      "Hancitor (Malware)",
      "Havoc (Malware)",
      "Javali (Malware)",
      "Kerrdown (Malware)",
      "Kimsuky (Group)",
      "KOCTOPUS (Malware)",
      "Latrodectus (Malware)",
      "Lazarus Group (Group)",
      "LazyScripter (Group)",
      "Leviathan (Group)",
      "LuminousMoth (Group)",
      "Lumma Stealer (Malware)",
    ],
    T1111: [
      "APT42 (Group)",
      "Chimera (Group)",
      "evilginx2 (Tool)",
      "Kimsuky (Group)",
      "LAPSUS$ (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Operation Wocao (Campaign)",
      "SLOWPULSE (Malware)",
      "Sykipot (Malware)",
    ],
    "T1027.009": [
      "3CX Supply Chain Attack (Campaign)",
      "BADHATCH (Malware)",
      "C0021 (Campaign)",
      "CHIMNEYSWEEP (Malware)",
      "ComRAT (Malware)",
      "DEADEYE (Malware)",
      "DEADWOOD (Malware)",
      "Dtrack (Malware)",
      "DUSTPAN (Malware)",
      "DUSTTRAP (Malware)",
      "Emotet (Malware)",
      "IcedID (Malware)",
      "Invoke-PSImage (Tool)",
      "Lazarus Group (Group)",
      "macOS.OSAMiner (Malware)",
      "Moneybird (Malware)",
      "Moonstone Sleet (Group)",
      "MultiLayer Wiper (Malware)",
      "Netwalker (Malware)",
      "Pikabot (Malware)",
      "SMOKEDHAM (Malware)",
      "TA577 (Group)",
      "Uroburos (Malware)",
    ],
    T1027: [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "3CX Supply Chain Attack (Campaign)",
      "Action RAT (Malware)",
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Amadey (Malware)",
      "Anchor (Malware)",
      "ANELLDR (Malware)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT-C-36 (Group)",
      "APT3 (Group)",
      "APT37 (Group)",
      "APT41 (Group)",
      "Avaddon (Malware)",
      "AvosLocker (Malware)",
      "BackdoorDiplomacy (Group)",
      "BlackOasis (Group)",
      "BOOKWORM (Malware)",
      "BoomBox (Malware)",
      "BoxCaon (Malware)",
      "BPFDoor (Malware)",
      "BRICKSTORM (Malware)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "Bundlore (Malware)",
      "BUSHWALK (Malware)",
      "C0015 (Campaign)",
      "C0017 (Campaign)",
      "Carbanak (Malware)",
      "Carbon (Malware)",
      "CARROTBALL (Tool)",
      "CHIMNEYSWEEP (Malware)",
      "Clambling (Malware)",
      "COATHANGER (Malware)",
      "Cobalt Strike (Malware)",
      "CoinTicker (Malware)",
      "Comnie (Malware)",
      "ComRAT (Malware)",
      "Conficker (Malware)",
    ],
    T1686: [
      "APT38 (Group)",
      "BACKSPACE (Malware)",
      "BlackByte (Group)",
      "BPFDoor (Malware)",
      "Carbanak (Group)",
      "CookieMiner (Malware)",
      "Dragonfly (Group)",
      "FIN7 (Group)",
      "Grandoreiro (Malware)",
      "Hannotog (Malware)",
      "HOPLIGHT (Malware)",
      "InvisiMole (Malware)",
      "Kasidet (Malware)",
      "Kimsuky (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Medusa Group (Group)",
      "NanoCore (Malware)",
      "netsh (Tool)",
      "PlugX (Malware)",
      "PyDCrypt (Malware)",
      "Rocke (Group)",
      "Salt Typhoon (Group)",
      "ShrinkLocker (Malware)",
      "SolarWinds Compromise (Campaign)",
      "TeamTNT (Group)",
      "THINCRUST (Malware)",
      "ToddyCat (Group)",
      "UNC3886 (Group)",
      "Velvet Ant (Group)",
      "ZxShell (Malware)",
    ],
    "T1204.002": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "admin@338 (Group)",
      "Agent Tesla (Malware)",
      "Ajax Security Team (Group)",
      "Andariel (Group)",
      "Aoqin Dragon (Group)",
      "AppleJeus (Malware)",
      "AppleSeed (Malware)",
      "APT-C-36 (Group)",
      "APT12 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT30 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Bad Rabbit (Malware)",
      "BADFLICK (Malware)",
      "Bandook (Malware)",
      "BeaverTail (Malware)",
      "Bisonal (Malware)",
      "BITTER (Group)",
      "Black Basta (Malware)",
      "BlackTech (Group)",
      "BLINDINGCAN (Malware)",
      "BoomBox (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "Bundlore (Malware)",
      "C0011 (Campaign)",
      "C0015 (Campaign)",
      "Cardinal RAT (Malware)",
      "CARROTBALL (Tool)",
    ],
    "T1583.006": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT-C-36 (Group)",
      "APT17 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "ArcaneDoor (Campaign)",
      "Confucius (Group)",
      "Contagious Interview (Group)",
      "Earth Lusca (Group)",
      "FIN7 (Group)",
      "Gamaredon Group (Group)",
      "HAFNIUM (Group)",
      "IndigoZebra (Group)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "LazyScripter (Group)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "Operation Dream Job (Campaign)",
      "Operation Sharpshooter (Campaign)",
      "POLONIUM (Group)",
      "Saint Bear (Group)",
      "TA2541 (Group)",
      "TA578 (Group)",
      "Turla (Group)",
      "VOID MANTICORE (Group)",
      "ZIRCONIUM (Group)",
    ],
    T1112: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "AADInternals (Tool)",
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Amadey (Malware)",
      "APT19 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Aquatic Panda (Group)",
      "Attor (Malware)",
      "Avaddon (Malware)",
      "BACKSPACE (Malware)",
      "BADCALL (Malware)",
      "Bankshot (Malware)",
      "Bisonal (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BlackByte Ransomware (Malware)",
      "BlackCat (Malware)",
      "Blue Mockingbird (Group)",
      "BOOKWORM (Malware)",
      "Cardinal RAT (Malware)",
      "Catchamas (Malware)",
      "Caterpillar WebShell (Malware)",
      "Chaes (Malware)",
      "CharmPower (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "CHOPSTICK (Malware)",
      "Clambling (Malware)",
      "Clop (Malware)",
      "Cobalt Strike (Malware)",
      "ComRAT (Malware)",
      "Conficker (Malware)",
      "CrackMapExec (Tool)",
      "Crimson (Malware)",
      "CSPY Downloader (Tool)",
    ],
    T1678: [
      "3CX Supply Chain Attack (Campaign)",
      "AshTag (Malware)",
      "BRICKSTORM (Malware)",
      "DynoWiper (Malware)",
      "Fooder (Malware)",
      "GlassWorm (Malware)",
      "HIUPAN (Malware)",
      "Kimsuky (Group)",
      "MuddyViper (Malware)",
      "Mustang Panda (Group)",
      "PHASEJAM (Malware)",
      "PureCrypter (Malware)",
      "Qilin (Malware)",
      "RustyWater (Malware)",
      "Shai-Hulud (Malware)",
      "SPAWNCHIMERA (Malware)",
      "SystemBC (Malware)",
      "TONESHELL (Malware)",
      "UPPERCUT (Malware)",
    ],
    T1030: [
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT41 (Group)",
      "C0015 (Campaign)",
      "C0026 (Campaign)",
      "Carbanak (Malware)",
      "Cobalt Strike (Malware)",
      "Helminth (Malware)",
      "Kessel (Malware)",
      "Kevin (Malware)",
      "LuminousMoth (Group)",
      "LunarWeb (Malware)",
      "Mythic (Tool)",
      "ObliqueRAT (Malware)",
      "OopsIE (Malware)",
      "Play (Group)",
      "POSHSPY (Malware)",
      "Rclone (Tool)",
      "RDAT (Malware)",
      "StealBit (Malware)",
      "Threat Group-3390 (Group)",
    ],
    T1037: [
      "APT29 (Group)",
      "APT41 (Group)",
      "ArcaneDoor (Campaign)",
      "Rocke (Group)",
      "RotaJakiro (Malware)",
      "SPAWNCHIMERA (Malware)",
      "UNC3886 (Group)",
      "VIRTUALPITA (Malware)",
    ],
    "T1608.001": [
      "APT-C-36 (Group)",
      "APT32 (Group)",
      "APT42 (Group)",
      "BITTER (Group)",
      "BlackByte (Group)",
      "C0010 (Campaign)",
      "C0011 (Campaign)",
      "C0021 (Campaign)",
      "Contagious Interview (Group)",
      "Earth Lusca (Group)",
      "EXOTIC LILY (Group)",
      "FIN7 (Group)",
      "Gamaredon Group (Group)",
      "HEXANE (Group)",
      "Kimsuky (Group)",
      "LazyScripter (Group)",
      "LuminousMoth (Group)",
      "Moonstone Sleet (Group)",
      "Mustang Panda (Group)",
      "Mustard Tempest (Group)",
      "Night Dragon (Campaign)",
      "OilRig (Group)",
      "Operation Dream Job (Campaign)",
      "Operation Sharpshooter (Campaign)",
      "Operation Spalax (Campaign)",
      "RedDelta Modified PlugX Infection Chain Operations (Campaign)",
      "Saint Bear (Group)",
      "Sandworm Team (Group)",
      "Shai-Hulud (Malware)",
      "SideCopy (Group)",
      "Star Blizzard (Group)",
      "TA2541 (Group)",
      "TA505 (Group)",
      "TeamTNT (Group)",
      "Threat Group-3390 (Group)",
      "WIRTE (Group)",
    ],
    T1685: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "Agent Tesla (Malware)",
      "Agrius (Group)",
      "Akira (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "ArcaneDoor (Campaign)",
      "Avaddon (Malware)",
      "Babuk (Malware)",
      "Bazar (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BOLDMOVE (Malware)",
      "Brave Prince (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "Bundlore (Malware)",
      "Carberp (Malware)",
      "ChChes (Malware)",
      "Clop (Malware)",
      "Cobalt Strike (Malware)",
      "Conficker (Malware)",
      "Contagious Interview (Group)",
      "Cutting Edge (Campaign)",
      "DarkComet (Malware)",
      "DarkGate (Malware)",
      "DCRAT (Tool)",
      "Diavol (Malware)",
      "Donut (Tool)",
      "DRYHOOK (Malware)",
      "Ebury (Malware)",
      "Egregor (Malware)",
      "EKANS (Malware)",
      "FIN6 (Group)",
      "Gamaredon Group (Group)",
      "Gold Dragon (Malware)",
      "Goopy (Malware)",
      "Gorgon Group (Group)",
    ],
    "T1059.003": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "4H RAT (Malware)",
      "ABK (Malware)",
      "Action RAT (Malware)",
      "adbupd (Malware)",
      "admin@338 (Group)",
      "ADVSTORESHELL (Malware)",
      "Agrius (Group)",
      "Akira (Malware)",
      "Anchor (Malware)",
      "APT1 (Group)",
      "APT18 (Group)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "AuditCred (Malware)",
      "AuTo Stealer (Malware)",
      "Babuk (Malware)",
      "BabyShark (Malware)",
      "BackConfig (Malware)",
      "BACKSPACE (Malware)",
      "BADHATCH (Malware)",
      "BADNEWS (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BBK (Malware)",
      "BISCUIT (Malware)",
      "Bisonal (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
    ],
    "T1547.008": ["Pasam (Malware)", "Wingbird (Malware)"],
    T1046: [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT32 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Backdoor.Oldrea (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADHATCH (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BlackEnergy (Malware)",
      "BlackTech (Group)",
      "Brute Ratel C4 (Tool)",
      "C0018 (Campaign)",
      "C0027 (Campaign)",
      "Caterpillar WebShell (Malware)",
      "Chimera (Group)",
      "China Chopper (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Conficker (Malware)",
      "CostaRicto (Campaign)",
      "DarkVishnya (Group)",
      "Ember Bear (Group)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "Fox Kitten (Group)",
      "FRP (Tool)",
      "HDoor (Malware)",
      "HermeticWizard (Malware)",
      "Hildegard (Malware)",
      "HomeLand Justice (Campaign)",
      "INC Ransom (Group)",
      "Industroyer (Malware)",
      "InvisiMole (Malware)",
      "Koadic (Tool)",
      "Lazarus Group (Group)",
      "Leafminer (Group)",
    ],
    "T1036.005": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "admin@338 (Group)",
      "Akira (Group)",
      "ANDROMEDA (Malware)",
      "AppleSeed (Malware)",
      "APT-C-36 (Group)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "AshTag (Malware)",
      "BackConfig (Malware)",
      "BackdoorDiplomacy (Group)",
      "Bad Rabbit (Malware)",
      "BADNEWS (Malware)",
      "Bazar (Malware)",
      "Bisonal (Malware)",
      "Black Basta (Malware)",
      "BLINDINGCAN (Malware)",
      "Blue Mockingbird (Group)",
      "BRICKSTORM (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "Bundlore (Malware)",
      "C0017 (Campaign)",
      "C0018 (Campaign)",
      "C0032 (Campaign)",
      "Calisto (Malware)",
      "CANONSTAGER (Malware)",
      "Carbanak (Group)",
      "Carberp (Malware)",
      "Chaes (Malware)",
      "ChChes (Malware)",
    ],
    T1615: [
      "BloodHound (Tool)",
      "DUSTTRAP (Malware)",
      "Emissary (Malware)",
      "Empire (Tool)",
      "Leviathan Australian Intrusions (Campaign)",
      "LunarWeb (Malware)",
      "Turla (Group)",
    ],
    "T1584.006": [
      "CURIUM (Group)",
      "Earth Lusca (Group)",
      "Gootloader (Malware)",
      "Operation MidnightEclipse (Campaign)",
      "Turla (Group)",
      "Winter Vivern (Group)",
    ],
    T1018: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "2016 Ukraine Electric Power Attack (Campaign)",
      "AdFind (Tool)",
      "Agrius (Group)",
      "Akira (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Arp (Tool)",
      "Backdoor.Oldrea (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackCat (Malware)",
      "BloodHound (Tool)",
      "BRONZE BUTLER (Group)",
      "C0015 (Campaign)",
      "Carbon (Malware)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "Comnie (Malware)",
      "Conti (Malware)",
      "CrackMapExec (Tool)",
      "Deep Panda (Group)",
      "Diavol (Malware)",
      "Dragonfly (Group)",
      "DRATzarus (Malware)",
      "DUSTTRAP (Malware)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "Epic (Malware)",
      "FIN5 (Group)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "Flagpro (Malware)",
      "Fox Kitten (Group)",
      "FunnyDream (Campaign)",
    ],
    "T1543.003": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Agrius (Group)",
      "Anchor (Malware)",
      "AppleJeus (Malware)",
      "APT19 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "Aquatic Panda (Group)",
      "Attor (Malware)",
      "AuditCred (Malware)",
      "Bankshot (Malware)",
      "BBSRAT (Malware)",
      "Bisonal (Malware)",
      "BitPaymer (Malware)",
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackEnergy (Malware)",
      "Blue Mockingbird (Group)",
      "BOOKWORM (Malware)",
      "Briba (Malware)",
      "Carbanak (Group)",
      "Carbon (Malware)",
      "Catchamas (Malware)",
      "Cinnamon Tempest (Group)",
      "Clambling (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Conficker (Malware)",
      "CorKLOG (Malware)",
      "CosmicDuke (Malware)",
      "CozyCar (Malware)",
      "Cuba (Malware)",
      "DarkVishnya (Group)",
      "DCSrv (Malware)",
      "Dtrack (Malware)",
      "Duqu (Malware)",
      "DUSTPAN (Malware)",
    ],
    T1133: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "Akira (Group)",
      "APT-C-36 (Group)",
      "APT18 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT41 (Group)",
      "ArcaneDoor (Campaign)",
      "C0027 (Campaign)",
      "C0032 (Campaign)",
      "Chimera (Group)",
      "CostaRicto (Campaign)",
      "Doki (Malware)",
      "Dragonfly (Group)",
      "Ember Bear (Group)",
      "FIN13 (Group)",
      "FIN5 (Group)",
      "GALLIUM (Group)",
      "GOLD SOUTHFIELD (Group)",
      "Hildegard (Malware)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "Kinsing (Malware)",
      "LAPSUS$ (Group)",
      "Leviathan (Group)",
      "Linux Rabbit (Malware)",
      "Mafalda (Malware)",
      "Night Dragon (Campaign)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "Operation Wocao (Campaign)",
      "Play (Group)",
      "Sandworm Team (Group)",
      "Scattered Spider (Group)",
      "Sea Turtle (Group)",
      "SolarWinds Compromise (Campaign)",
      "TeamTNT (Group)",
      "Threat Group-3390 (Group)",
      "Velvet Ant (Group)",
    ],
    "T1003.003": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT41 (Group)",
      "Chimera (Group)",
      "CrackMapExec (Tool)",
      "Cutting Edge (Campaign)",
      "Dragonfly (Group)",
      "esentutl (Tool)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "Fox Kitten (Group)",
      "HAFNIUM (Group)",
      "Impacket (Tool)",
      "Ke3chang (Group)",
      "Koadic (Tool)",
      "LAPSUS$ (Group)",
      "Medusa Group (Group)",
      "menuPass (Group)",
      "MirrorFace (Group)",
      "Mustang Panda (Group)",
      "Operation MidnightEclipse (Campaign)",
      "Sandworm Team (Group)",
      "Scattered Spider (Group)",
      "Volt Typhoon (Group)",
      "Wizard Spider (Group)",
    ],
    "T1056.004": [
      "Carberp (Malware)",
      "Empire (Tool)",
      "FinFisher (Malware)",
      "NOKKI (Malware)",
      "PLATINUM (Group)",
      "RDFSNIFFER (Malware)",
      "TrickBot (Malware)",
      "Ursnif (Malware)",
      "VersaMem (Malware)",
      "Zebrocy (Malware)",
      "Zeus Panda (Malware)",
      "ZxShell (Malware)",
    ],
    T1057: [
      "2025 Poland Wiper Attacks (Campaign)",
      "4H RAT (Malware)",
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Akira (Malware)",
      "Andariel (Group)",
      "Apostle (Malware)",
      "AppleSeed (Malware)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT3 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT5 (Group)",
      "Aria-body (Malware)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Avaddon (Malware)",
      "Avenger (Malware)",
      "AvosLocker (Malware)",
      "Azorult (Malware)",
      "Babuk (Malware)",
      "BabyShark (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BACKSPACE (Malware)",
      "Bad Rabbit (Malware)",
      "BADHATCH (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BBSRAT (Malware)",
      "BISCUIT (Malware)",
      "Bisonal (Malware)",
      "BLACKCOFFEE (Malware)",
      "BlackEnergy (Malware)",
      "BLUELIGHT (Malware)",
      "Bonadan (Malware)",
      "Brave Prince (Malware)",
      "BRICKSTORM (Malware)",
      "Brute Ratel C4 (Tool)",
    ],
    T1055: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "3CX Supply Chain Attack (Campaign)",
      "ABK (Malware)",
      "Agent Tesla (Malware)",
      "ANDROMEDA (Malware)",
      "APT32 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "ArcaneDoor (Campaign)",
      "Attor (Malware)",
      "AuditCred (Malware)",
      "Avenger (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BBK (Malware)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "Bumblebee (Malware)",
      "Cardinal RAT (Malware)",
      "Clambling (Malware)",
      "COATHANGER (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "CostaBricks (Malware)",
      "Cutting Edge (Campaign)",
      "Donut (Tool)",
      "DOWNIISSA (Malware)",
      "DUSTTRAP (Malware)",
      "Dyre (Malware)",
      "Egregor (Malware)",
      "Empire (Tool)",
      "Gamaredon Group (Group)",
      "Gazer (Malware)",
      "gh0st RAT (Malware)",
      "GuLoader (Malware)",
      "HiddenFace (Malware)",
      "HOPLIGHT (Malware)",
    ],
    "T1518.001": [
      "ABK (Malware)",
      "Action RAT (Malware)",
      "Amadey (Malware)",
      "APT38 (Group)",
      "APT42 (Group)",
      "Aquatic Panda (Group)",
      "Astaroth (Malware)",
      "AuTo Stealer (Malware)",
      "Avenger (Malware)",
      "BadPatch (Malware)",
      "Bazar (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BLUELIGHT (Malware)",
      "Brute Ratel C4 (Tool)",
      "build_downer (Malware)",
      "Bumblebee (Malware)",
      "Carberp (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "CHOPSTICK (Malware)",
      "Clop (Malware)",
      "Cobalt Group (Group)",
      "Comnie (Malware)",
      "CookieMiner (Malware)",
      "CozyCar (Malware)",
      "Crimson (Malware)",
      "DarkGate (Malware)",
      "Darkhotel (Group)",
      "DarkTortilla (Malware)",
      "DarkWatchman (Malware)",
      "down_new (Malware)",
      "DUSTTRAP (Malware)",
      "DustySky (Malware)",
      "Empire (Tool)",
      "Epic (Malware)",
      "EvilBunny (Malware)",
      "EVILNUM (Malware)",
      "Exbyte (Malware)",
      "Felismus (Malware)",
      "FELIXROOT (Malware)",
    ],
    "T1003.006": [
      "C0027 (Campaign)",
      "Earth Lusca (Group)",
      "LAPSUS$ (Group)",
      "Mimikatz (Tool)",
      "Mustang Panda (Group)",
      "Operation Wocao (Campaign)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
    ],
    "T1114.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "Chimera (Group)",
      "Dragonfly (Group)",
      "FIN4 (Group)",
      "HAFNIUM (Group)",
      "HomeLand Justice (Campaign)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "Leafminer (Group)",
      "LightNeuron (Malware)",
      "Magic Hound (Group)",
      "MailSniper (Tool)",
      "SeaDuke (Malware)",
      "SolarWinds Compromise (Campaign)",
      "Star Blizzard (Group)",
      "Valak (Malware)",
      "VOID MANTICORE (Group)",
    ],
    T1090: [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT41 (Group)",
      "Aria-body (Malware)",
      "AuditCred (Malware)",
      "BADCALL (Malware)",
      "BADHATCH (Malware)",
      "Bisonal (Malware)",
      "Blue Mockingbird (Group)",
      "C0017 (Campaign)",
      "C0027 (Campaign)",
      "Cardinal RAT (Malware)",
      "Cinnamon Tempest (Group)",
      "Contagious Interview (Group)",
      "CopyKittens (Group)",
      "Dridex (Malware)",
      "Earth Lusca (Group)",
      "Fox Kitten (Group)",
      "FRP (Tool)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "GoBear (Malware)",
      "Green Lambert (Malware)",
      "HARDRAIN (Malware)",
      "Havoc (Malware)",
      "HOPLIGHT (Malware)",
      "HTRAN (Tool)",
      "jRAT (Malware)",
      "Kapeka (Malware)",
      "Kessel (Malware)",
      "KEYPLUG (Malware)",
      "KOCTOPUS (Malware)",
      "LAPSUS$ (Group)",
      "LITTLELAMB.WOOLTEA (Malware)",
      "LunarWeb (Malware)",
      "Magic Hound (Group)",
      "MirrorFace (Group)",
      "MoustachedBouncer (Group)",
      "MuddyWater (Group)",
      "Neo-reGeorg (Malware)",
      "netsh (Tool)",
    ],
    T1201: [
      "Chimera (Group)",
      "CrackMapExec (Tool)",
      "Kwampirs (Malware)",
      "Net (Tool)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "PoshC2 (Tool)",
      "Turla (Group)",
    ],
    T1120: [
      "AcidPour (Malware)",
      "ADVSTORESHELL (Malware)",
      "APT28 (Group)",
      "APT37 (Group)",
      "Attor (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADNEWS (Malware)",
      "Bandook (Malware)",
      "BlackEnergy (Malware)",
      "Cadelspy (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Crimson (Malware)",
      "Crutch (Malware)",
      "DarkWatchman (Malware)",
      "DustySky (Malware)",
      "DynoWiper (Malware)",
      "Equation (Group)",
      "Ferocious (Malware)",
      "FlawedAmmyy (Malware)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "Heyoka Backdoor (Malware)",
      "HIUPAN (Malware)",
      "INC Ransomware (Malware)",
      "jRAT (Malware)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "Machete (Malware)",
      "Mongall (Malware)",
      "MoonWind (Malware)",
      "NightClub (Malware)",
      "njRAT (Malware)",
      "ObliqueRAT (Malware)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "Operation Wocao (Campaign)",
      "PlugX (Malware)",
      "Prikormka (Malware)",
      "QakBot (Malware)",
      "QuietSieve (Malware)",
    ],
    "T1056.001": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "ADVSTORESHELL (Malware)",
      "Agent Tesla (Malware)",
      "Ajax Security Team (Group)",
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "APT5 (Group)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "BabyShark (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
      "Bandook (Malware)",
      "BISCUIT (Malware)",
      "BlackEnergy (Malware)",
      "BOOKWORM (Malware)",
      "Cadelspy (Malware)",
      "Carbanak (Malware)",
      "Cardinal RAT (Malware)",
      "Catchamas (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "CHOPSTICK (Malware)",
      "Clambling (Malware)",
      "Cobalt Strike (Malware)",
      "Cobian RAT (Malware)",
      "CorKLOG (Malware)",
      "CosmicDuke (Malware)",
      "Crimson (Malware)",
      "Cuba (Malware)",
      "Cutting Edge (Campaign)",
      "DarkComet (Malware)",
      "DarkGate (Malware)",
      "Darkhotel (Group)",
    ],
    "T1573.001": [
      "3CX Supply Chain Attack (Campaign)",
      "3PARA RAT (Malware)",
      "4H RAT (Malware)",
      "ADVSTORESHELL (Malware)",
      "APT28 (Group)",
      "APT33 (Group)",
      "Attor (Malware)",
      "Azorult (Malware)",
      "BADCALL (Malware)",
      "BADNEWS (Malware)",
      "Bandook (Malware)",
      "Bazar (Malware)",
      "BBSRAT (Malware)",
      "BendyBear (Malware)",
      "Bisonal (Malware)",
      "BLINDINGCAN (Malware)",
      "Bonadan (Malware)",
      "BOOKWORM (Malware)",
      "BRONZE BUTLER (Group)",
      "Bumblebee (Malware)",
      "CallMe (Malware)",
      "Carbanak (Malware)",
      "Cardinal RAT (Malware)",
      "CASTLETAP (Malware)",
      "Chaos (Malware)",
      "CharmPower (Malware)",
      "ChChes (Malware)",
      "CHOPSTICK (Malware)",
      "Cobalt Strike (Malware)",
      "Comnie (Malware)",
      "Contagious Interview (Group)",
      "CORESHELL (Malware)",
      "CosmicDuke (Malware)",
      "Darkhotel (Group)",
      "Daserf (Malware)",
      "Derusbi (Malware)",
      "Dipsind (Malware)",
      "down_new (Malware)",
      "Downdelph (Malware)",
      "Dridex (Malware)",
    ],
    "T1555.004": [
      "Juicy Mix (Campaign)",
      "KGH_SPY (Malware)",
      "LaZagne (Tool)",
      "Lizar (Malware)",
      "Mimikatz (Tool)",
      "OilRig (Group)",
      "PowerSploit (Tool)",
      "RainyDay (Malware)",
      "ROKRAT (Malware)",
      "SILENTTRINITY (Tool)",
      "Stealth Falcon (Group)",
      "Turla (Group)",
      "Valak (Malware)",
      "Wizard Spider (Group)",
    ],
    "T1558.003": [
      "Brute Ratel C4 (Tool)",
      "Empire (Tool)",
      "FIN7 (Group)",
      "Impacket (Tool)",
      "Indrik Spider (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Operation Wocao (Campaign)",
      "PowerSploit (Tool)",
      "Rubeus (Tool)",
      "SILENTTRINITY (Tool)",
      "SolarWinds Compromise (Campaign)",
      "Wizard Spider (Group)",
    ],
    T1095: [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "Anchor (Malware)",
      "APT3 (Group)",
      "Aria-body (Malware)",
      "AuTo Stealer (Malware)",
      "BackdoorDiplomacy (Group)",
      "Bandook (Malware)",
      "Bisonal (Malware)",
      "BITTER (Group)",
      "Brute Ratel C4 (Tool)",
      "BUBBLEWRAP (Malware)",
      "C0021 (Campaign)",
      "Carbon (Malware)",
      "cd00r (Malware)",
      "Clambling (Malware)",
      "COATHANGER (Malware)",
      "Cobalt Strike (Malware)",
      "Crimson (Malware)",
      "Cryptoistic (Malware)",
      "Cuckoo Stealer (Malware)",
      "Cutting Edge (Campaign)",
      "Derusbi (Malware)",
      "Drovorub (Malware)",
      "Ember Bear (Group)",
      "FakeM (Malware)",
      "FIN6 (Group)",
      "FRP (Tool)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "Gelsemium (Malware)",
      "gh0st RAT (Malware)",
      "HAFNIUM (Group)",
      "HiddenFace (Malware)",
      "HiddenWasp (Malware)",
      "InvisibleFerret (Malware)",
      "InvisiMole (Malware)",
      "J-magic (Malware)",
      "KEYPLUG (Malware)",
      "KV Botnet Activity (Campaign)",
      "LITTLELAMB.WOOLTEA (Malware)",
    ],
    "T1588.006": [
      "Leviathan Australian Intrusions (Campaign)",
      "Sandworm Team (Group)",
      "Storm-0501 (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1585.002": [
      "APT1 (Group)",
      "APT42 (Group)",
      "Contagious Interview (Group)",
      "CURIUM (Group)",
      "EXOTIC LILY (Group)",
      "FunnyDream (Campaign)",
      "HEXANE (Group)",
      "Indrik Spider (Group)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "Moonstone Sleet (Group)",
      "Mustang Panda (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Operation Dream Job (Campaign)",
      "Operation Dust Storm (Campaign)",
      "Operation Honeybee (Campaign)",
      "Operation Wocao (Campaign)",
      "Salesforce Data Exfiltration (Campaign)",
      "Sandworm Team (Group)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "Silent Librarian (Group)",
      "Star Blizzard (Group)",
      "VOID MANTICORE (Group)",
      "Wizard Spider (Group)",
    ],
    "T1566.001": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "admin@338 (Group)",
      "Agent Tesla (Malware)",
      "Ajax Security Team (Group)",
      "Andariel (Group)",
      "AppleSeed (Malware)",
      "APT-C-36 (Group)",
      "APT1 (Group)",
      "APT12 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT30 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "BADFLICK (Malware)",
      "Bandook (Malware)",
      "Bisonal (Malware)",
      "BITTER (Group)",
      "BlackTech (Group)",
      "BLINDINGCAN (Malware)",
      "BRONZE BUTLER (Group)",
      "Bumblebee (Malware)",
      "C0011 (Campaign)",
      "C0015 (Campaign)",
      "Chaes (Malware)",
      "Clambling (Malware)",
      "Cobalt Group (Group)",
      "Confucius (Group)",
      "CURIUM (Group)",
      "DanBot (Malware)",
      "DarkGate (Malware)",
      "Darkhotel (Group)",
      "DarkHydrus (Group)",
    ],
    T1497: [
      "Agent Tesla (Malware)",
      "Bazar (Malware)",
      "Bisonal (Malware)",
      "Black Basta (Malware)",
      "Bumblebee (Malware)",
      "Carberp (Malware)",
      "CHOPSTICK (Malware)",
      "Contagious Interview (Group)",
      "CozyCar (Malware)",
      "Darkhotel (Group)",
      "Egregor (Malware)",
      "Gelsemium (Malware)",
      "Hancitor (Malware)",
      "IcedID (Malware)",
      "Kevin (Malware)",
      "Metamorfo (Malware)",
      "Operation Spalax (Campaign)",
      "Pteranodon (Malware)",
      "Raspberry Robin (Malware)",
      "RedLine Stealer (Malware)",
      "RTM (Malware)",
      "Saint Bear (Group)",
      "Squirrelwaffle (Malware)",
      "StoneDrill (Malware)",
      "StrelaStealer (Malware)",
      "XLoader (Malware)",
    ],
    "T1686.003": [
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "BADCALL (Malware)",
      "BlackByte 2.0 Ransomware (Malware)",
      "DarkComet (Malware)",
      "H1N1 (Malware)",
      "HARDRAIN (Malware)",
      "HiddenFace (Malware)",
      "Lazarus Group (Group)",
      "Magic Hound (Group)",
      "MirrorFace (Group)",
      "Moses Staff (Group)",
      "njRAT (Malware)",
      "OilRig (Group)",
      "Operation Wocao (Campaign)",
      "Remsec (Malware)",
      "TYPEFRAME (Malware)",
      "VOID MANTICORE (Group)",
    ],
    "T1550.003": [
      "APT29 (Group)",
      "APT32 (Group)",
      "BRONZE BUTLER (Group)",
      "Mimikatz (Tool)",
      "Pupy (Tool)",
      "SeaDuke (Malware)",
    ],
    T1087: [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "Aquatic Panda (Group)",
      "FIN13 (Group)",
      "Havoc (Malware)",
      "Scattered Spider (Group)",
      "ShimRatReporter (Tool)",
      "SolarWinds Compromise (Campaign)",
      "TONESHELL (Malware)",
      "Woody RAT (Malware)",
      "XCSSET (Malware)",
    ],
    T1622: [
      "ANELLDR (Malware)",
      "AsyncRAT (Tool)",
      "Black Basta (Malware)",
      "Bumblebee (Malware)",
      "DarkGate (Malware)",
      "DarkTortilla (Malware)",
      "DRATzarus (Malware)",
      "Latrodectus (Malware)",
      "LockBit 3.0 (Malware)",
      "Lumma Stealer (Malware)",
      "Mafalda (Malware)",
      "Mustang Panda (Group)",
      "Operation Dream Job (Campaign)",
      "Pikabot (Malware)",
      "PlugX (Malware)",
      "PUBLOAD (Malware)",
      "PureCrypter (Malware)",
      "Raspberry Robin (Malware)",
      "ROKRAT (Malware)",
      "RustyWater (Malware)",
      "Saint Bot (Malware)",
      "StealBit (Malware)",
      "StrelaStealer (Malware)",
      "ThiefQuest (Malware)",
      "TONESHELL (Malware)",
      "XLoader (Malware)",
    ],
    "T1542.003": [
      "APT28 (Group)",
      "APT41 (Group)",
      "BOOTRASH (Malware)",
      "Carberp (Malware)",
      "FinFisher (Malware)",
      "Lazarus Group (Group)",
      "ROCKBOOT (Malware)",
      "TrickBot (Malware)",
      "WhisperGate (Malware)",
    ],
    "T1592.004": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "HAFNIUM (Group)",
    ],
    "T1087.003": [
      "Backdoor.Oldrea (Malware)",
      "BoomBox (Malware)",
      "C0027 (Campaign)",
      "Emotet (Malware)",
      "Grandoreiro (Malware)",
      "HomeLand Justice (Campaign)",
      "Lizar (Malware)",
      "Magic Hound (Group)",
      "MailSniper (Tool)",
      "RedCurl (Group)",
      "Ruler (Tool)",
      "Sandworm Team (Group)",
      "TA505 (Group)",
      "TrickBot (Malware)",
    ],
    T1005: [
      "Action RAT (Malware)",
      "Agrius (Group)",
      "Amadey (Malware)",
      "Andariel (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "AppleSeed (Malware)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "AuTo Stealer (Malware)",
      "Axiom (Group)",
      "BADFLICK (Malware)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
      "Bandook (Malware)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BeaverTail (Malware)",
      "Bisonal (Malware)",
      "BlackMould (Malware)",
      "BLINDINGCAN (Malware)",
      "BoxCaon (Malware)",
      "BRICKSTORM (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "Bumblebee (Malware)",
      "C0015 (Campaign)",
      "C0017 (Campaign)",
      "C0026 (Campaign)",
      "Calisto (Malware)",
      "CASTLETAP (Malware)",
      "Caterpillar WebShell (Malware)",
      "ccf32 (Malware)",
      "CharmPower (Malware)",
    ],
    T1129: [
      "Astaroth (Malware)",
      "Attor (Malware)",
      "BLINDINGCAN (Malware)",
      "BOOSTWRITE (Malware)",
      "Bumblebee (Malware)",
      "DarkWatchman (Malware)",
      "Dtrack (Malware)",
      "Ebury (Malware)",
      "FoggyWeb (Malware)",
      "gh0st RAT (Malware)",
      "Hydraq (Malware)",
      "KillDisk (Malware)",
      "LightSpy (Malware)",
      "Metamorfo (Malware)",
      "Mustang Panda (Group)",
      "OSX_OCEANLOTUS.D (Malware)",
      "PipeMon (Malware)",
      "PUNCHBUGGY (Malware)",
      "RotaJakiro (Malware)",
      "Stuxnet (Malware)",
      "TajMahal (Malware)",
      "VersaMem (Malware)",
    ],
    "T1543.001": [
      "Bundlore (Malware)",
      "Calisto (Malware)",
      "CoinTicker (Malware)",
      "Contagious Interview (Group)",
      "CookieMiner (Malware)",
      "CrossRAT (Malware)",
      "Cuckoo Stealer (Malware)",
      "Dacls (Malware)",
      "Dok (Malware)",
      "FruitFly (Malware)",
      "GlassWorm (Malware)",
      "Green Lambert (Malware)",
      "InvisibleFerret (Malware)",
      "Keydnap (Malware)",
      "Komplex (Malware)",
      "MacMa (Malware)",
      "macOS.OSAMiner (Malware)",
      "MacSpy (Malware)",
      "NETWIRE (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "Proton (Malware)",
      "ThiefQuest (Malware)",
    ],
    "T1055.004": [
      "Attor (Malware)",
      "BADHATCH (Malware)",
      "Bumblebee (Malware)",
      "Carberp (Malware)",
      "FIN8 (Group)",
      "HeartCrypt (Malware)",
      "IcedID (Malware)",
      "InvisiMole (Malware)",
      "Pillowmint (Malware)",
      "Saint Bot (Malware)",
      "Sardonic (Malware)",
      "TURNEDUP (Malware)",
      "XLoader (Malware)",
    ],
    "T1090.003": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT28 (Group)",
      "APT29 (Group)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "BOLDMOVE (Malware)",
      "CostaRicto (Campaign)",
      "Cyclops Blink (Malware)",
      "Dok (Malware)",
      "Dridex (Malware)",
      "Ember Bear (Group)",
      "FIN4 (Group)",
      "FLORAHOX Activity (Campaign)",
      "FRP (Tool)",
      "Gamaredon Group (Group)",
      "GreyEnergy (Malware)",
      "Inception (Group)",
      "Industroyer (Malware)",
      "Keydnap (Malware)",
      "Kobalos (Malware)",
      "Leviathan (Group)",
      "Lotus Blossom (Group)",
      "MacSpy (Malware)",
      "Medusa Group (Group)",
      "NGLite (Malware)",
      "Ninja (Malware)",
      "NKAbuse (Malware)",
      "Operation Wocao (Campaign)",
      "Quad7 Activity (Campaign)",
      "RedPenguin (Campaign)",
      "Salesforce Data Exfiltration (Campaign)",
      "Siloscape (Malware)",
      "SPACEHOP Activity (Campaign)",
      "StrongPity (Malware)",
      "SystemBC (Malware)",
      "Tor (Tool)",
      "Uroburos (Malware)",
      "Ursnif (Malware)",
      "Volt Typhoon (Group)",
      "WannaCry (Malware)",
    ],
    "T1059.010": [
      "APT39 (Group)",
      "DarkGate (Malware)",
      "Lumma Stealer (Malware)",
      "Melcoz (Malware)",
      "OutSteel (Malware)",
      "XLoader (Malware)",
    ],
    "T1059.006": [
      "APT29 (Group)",
      "APT37 (Group)",
      "APT39 (Group)",
      "Bandook (Malware)",
      "BRONZE BUTLER (Group)",
      "Bundlore (Malware)",
      "Chaes (Malware)",
      "Cinnamon Tempest (Group)",
      "Cobalt Strike (Malware)",
      "CoinTicker (Malware)",
      "Contagious Interview (Group)",
      "CookieMiner (Malware)",
      "Cutting Edge (Campaign)",
      "Donut (Tool)",
      "Dragonfly (Group)",
      "DropBook (Malware)",
      "DRYHOOK (Malware)",
      "Earth Lusca (Group)",
      "Ebury (Malware)",
      "FRAMESTING (Malware)",
      "InvisibleFerret (Malware)",
      "IronNetInjector (Tool)",
      "KeyBoy (Malware)",
      "Keydnap (Malware)",
      "Kimsuky (Group)",
      "LAMEHUG (Malware)",
      "Lizar (Malware)",
      "Lumma Stealer (Malware)",
      "Machete (Group)",
      "Machete (Malware)",
      "MechaFlounder (Malware)",
      "MuddyWater (Group)",
      "Neo-reGeorg (Malware)",
      "Operation Wocao (Campaign)",
      "PoetRAT (Malware)",
      "PUNCHBUGGY (Malware)",
      "Pupy (Tool)",
      "PyDCrypt (Malware)",
      "Pysa (Malware)",
      "RedCurl (Group)",
    ],
    T1189: [
      "3CX Supply Chain Attack (Campaign)",
      "Andariel (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT32 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "Axiom (Group)",
      "Bad Rabbit (Malware)",
      "BRONZE BUTLER (Group)",
      "Bundlore (Malware)",
      "C0010 (Campaign)",
      "CURIUM (Group)",
      "Daggerfly (Group)",
      "Dark Caracal (Group)",
      "Darkhotel (Group)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "Elderwood (Group)",
      "Grandoreiro (Malware)",
      "IcedID (Malware)",
      "KARAE (Malware)",
      "Lazarus Group (Group)",
      "Leafminer (Group)",
      "Leviathan (Group)",
      "LoudMiner (Malware)",
      "Machete (Group)",
      "Magic Hound (Group)",
      "Mustard Tempest (Group)",
      "Operation Dust Storm (Campaign)",
      "Patchwork (Group)",
      "PLATINUM (Group)",
      "POORAIM (Malware)",
      "PROMETHIUM (Group)",
      "REvil (Malware)",
      "RTM (Group)",
      "Snip3 (Malware)",
      "SocGholish (Malware)",
      "Threat Group-3390 (Group)",
      "Transparent Tribe (Group)",
    ],
    "T1114.001": [
      "APT1 (Group)",
      "Carbanak (Malware)",
      "Chimera (Group)",
      "CosmicDuke (Malware)",
      "Crimson (Malware)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "KGH_SPY (Malware)",
      "LunarMail (Malware)",
      "Magic Hound (Group)",
      "MirrorFace (Group)",
      "Night Dragon (Campaign)",
      "Out1 (Tool)",
      "Pupy (Tool)",
      "QakBot (Malware)",
      "RedCurl (Group)",
      "Sea Turtle (Group)",
      "Smoke Loader (Malware)",
      "Winter Vivern (Group)",
      "WIRTE (Group)",
    ],
    T1003: [
      "APT28 (Group)",
      "APT32 (Group)",
      "APT39 (Group)",
      "Axiom (Group)",
      "BlackByte (Group)",
      "Carbanak (Malware)",
      "Ember Bear (Group)",
      "HOMEFRY (Malware)",
      "Leviathan (Group)",
      "MgBot (Malware)",
      "Mustang Panda (Group)",
      "OnionDuke (Malware)",
      "PinchDuke (Malware)",
      "Poseidon Group (Group)",
      "Revenge RAT (Malware)",
      "Sowbug (Group)",
      "Storm-0501 (Group)",
      "Suckfly (Group)",
      "Tonto Team (Group)",
      "Trojan.Karagany (Malware)",
    ],
    "T1557.001": [
      "Empire (Tool)",
      "Impacket (Tool)",
      "Lazarus Group (Group)",
      "PoshC2 (Tool)",
      "Pupy (Tool)",
      "Responder (Tool)",
      "Wizard Spider (Group)",
    ],
    "T1102.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT12 (Group)",
      "APT28 (Group)",
      "APT37 (Group)",
      "APT39 (Group)",
      "BADNEWS (Malware)",
      "BLACKCOFFEE (Malware)",
      "BLUELIGHT (Malware)",
      "BoxCaon (Malware)",
      "CALENDAR (Malware)",
      "Carbanak (Group)",
      "Clambling (Malware)",
      "CloudDuke (Malware)",
      "Comnie (Malware)",
      "ComRAT (Malware)",
      "CozyCar (Malware)",
      "CreepyDrive (Malware)",
      "Crutch (Malware)",
      "DOGCALL (Malware)",
      "Empire (Tool)",
      "FIN7 (Group)",
      "Gamaredon Group (Group)",
      "GLOOXMAIL (Malware)",
      "Grandoreiro (Malware)",
      "HEXANE (Group)",
      "KARAE (Malware)",
      "Kazuar (Malware)",
      "Kimsuky (Group)",
      "LAMEHUG (Malware)",
      "Lazarus Group (Group)",
      "LOWBALL (Malware)",
      "Magic Hound (Group)",
      "MuddyWater (Group)",
      "ODAgent (Malware)",
      "OilBooster (Malware)",
      "OilCheck (Malware)",
      "Operation Ghost (Campaign)",
      "Orz (Malware)",
      "POLONIUM (Group)",
      "POORAIM (Malware)",
    ],
    T1219: [
      "Akira (Group)",
      "BlackByte (Group)",
      "Carbanak (Malware)",
      "Carbanak (Group)",
      "Cobalt Group (Group)",
      "DarkVishnya (Group)",
      "Dridex (Malware)",
      "Egregor (Malware)",
      "FIN7 (Group)",
      "GOLD SOUTHFIELD (Group)",
      "Hildegard (Malware)",
      "INC Ransom (Group)",
      "InvisibleFerret (Malware)",
      "Medusa Group (Group)",
      "Night Dragon (Campaign)",
      "OilRig (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "RTM (Malware)",
      "Sandworm Team (Group)",
      "TeamTNT (Group)",
      "TrickBot (Malware)",
    ],
    "T1685.005": [
      "Apostle (Malware)",
      "APT28 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "BlackCat (Malware)",
      "BlackEnergy (Malware)",
      "Chimera (Group)",
      "Dragonfly (Group)",
      "DUSTTRAP (Malware)",
      "FIN5 (Group)",
      "FIN8 (Group)",
      "FinFisher (Malware)",
      "gh0st RAT (Malware)",
      "HAFNIUM (Group)",
      "HermeticWiper (Malware)",
      "HermeticWizard (Malware)",
      "Hydraq (Malware)",
      "Indrik Spider (Group)",
      "KillDisk (Malware)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "Lucifer (Malware)",
      "Mafalda (Malware)",
      "Meteor (Malware)",
      "MirrorFace (Group)",
      "MultiLayer Wiper (Malware)",
      "NotPetya (Malware)",
      "Olympic Destroyer (Malware)",
      "Operation AkaiRy\u016b (Campaign)",
      "Operation Wocao (Campaign)",
      "Play (Group)",
      "Pupy (Tool)",
      "Qilin (Malware)",
      "RansomHub (Malware)",
      "RunningRAT (Malware)",
      "ShrinkLocker (Malware)",
      "SynAck (Malware)",
      "Volt Typhoon (Group)",
    ],
    "T1567.002": [
      "Akira (Group)",
      "APT41 DUST (Campaign)",
      "BoomBox (Malware)",
      "BoxCaon (Malware)",
      "C0015 (Campaign)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Clambling (Malware)",
      "Confucius (Group)",
      "Contagious Interview (Group)",
      "CreepyDrive (Malware)",
      "Crutch (Malware)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "Empire (Tool)",
      "FIN7 (Group)",
      "HAFNIUM (Group)",
      "HAMMERTOSS (Malware)",
      "HEXANE (Group)",
      "Indrik Spider (Group)",
      "Kimsuky (Group)",
      "Leviathan (Group)",
      "LuminousMoth (Group)",
      "Medusa Group (Group)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "Octopus (Malware)",
      "ODAgent (Malware)",
      "OilBooster (Malware)",
      "Operation Dream Job (Campaign)",
      "Pcexter (Malware)",
      "POLONIUM (Group)",
      "RainyDay (Malware)",
      "Rclone (Tool)",
      "RIFLESPINE (Malware)",
      "ROKRAT (Malware)",
      "Scattered Spider (Group)",
      "Storm-0501 (Group)",
      "Threat Group-3390 (Group)",
      "ToddyCat (Group)",
    ],
    T1190: [
      "Agrius (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "ArcaneDoor (Campaign)",
      "Axiom (Group)",
      "BackdoorDiplomacy (Group)",
      "BlackByte (Group)",
      "BlackTech (Group)",
      "Blue Mockingbird (Group)",
      "BOLDMOVE (Malware)",
      "C0017 (Campaign)",
      "C0018 (Campaign)",
      "C0027 (Campaign)",
      "Cinnamon Tempest (Group)",
      "COATHANGER (Malware)",
      "Cutting Edge (Campaign)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "FIN13 (Group)",
      "FIN7 (Group)",
      "FLORAHOX Activity (Campaign)",
      "Fox Kitten (Group)",
      "FrostyGoop Incident (Campaign)",
      "GALLIUM (Group)",
      "GOLD SOUTHFIELD (Group)",
      "HAFNIUM (Group)",
      "Havij (Tool)",
      "HomeLand Justice (Campaign)",
      "INC Ransom (Group)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "Leviathan (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
    ],
    "T1218.010": [
      "AppleSeed (Malware)",
      "APT19 (Group)",
      "APT32 (Group)",
      "Astaroth (Malware)",
      "Blue Mockingbird (Group)",
      "C0015 (Campaign)",
      "Cobalt Group (Group)",
      "Covenant (Tool)",
      "Deep Panda (Group)",
      "Derusbi (Malware)",
      "Dridex (Malware)",
      "Egregor (Malware)",
      "Emotet (Malware)",
      "EVILNUM (Malware)",
      "HermeticWizard (Malware)",
      "Hi-Zor (Malware)",
      "Inception (Group)",
      "Kimsuky (Group)",
      "Koadic (Tool)",
      "Leviathan (Group)",
      "More_eggs (Malware)",
      "Mori (Malware)",
      "Operation Dream Job (Campaign)",
      "Orz (Malware)",
      "QakBot (Malware)",
      "Ragnar Locker (Malware)",
      "Raspberry Robin (Malware)",
      "RogueRobin (Malware)",
      "Saint Bot (Malware)",
      "Squirrelwaffle (Malware)",
      "Storm-0501 (Group)",
      "TA551 (Group)",
      "TONESHELL (Malware)",
      "Valak (Malware)",
      "WIRTE (Group)",
      "Xbash (Malware)",
    ],
    T1589: [
      "APT32 (Group)",
      "Contagious Interview (Group)",
      "FIN13 (Group)",
      "HEXANE (Group)",
      "LAPSUS$ (Group)",
      "Magic Hound (Group)",
      "Operation Dream Job (Campaign)",
      "Operation Wocao (Campaign)",
      "Scattered Spider (Group)",
      "Star Blizzard (Group)",
      "VOID MANTICORE (Group)",
      "Volt Typhoon (Group)",
    ],
    T1070: [
      "APT42 (Group)",
      "APT5 (Group)",
      "Bankshot (Malware)",
      "BlackEnergy (Malware)",
      "BPFDoor (Malware)",
      "CSPY Downloader (Tool)",
      "Cutting Edge (Campaign)",
      "DarkWatchman (Malware)",
      "Donut (Tool)",
      "DUSTTRAP (Malware)",
      "EVILNUM (Malware)",
      "Flagpro (Malware)",
      "FunnyDream (Malware)",
      "HermeticWiper (Malware)",
      "IPsec Helper (Malware)",
      "IronWind (Malware)",
      "Lazarus Group (Group)",
      "Maze (Malware)",
      "Metamorfo (Malware)",
      "MultiLayer Wiper (Malware)",
      "Mustang Panda (Group)",
      "Neoichor (Malware)",
      "Orz (Malware)",
      "Remcos (Tool)",
      "Rising Sun (Malware)",
      "Sardonic (Malware)",
      "SDBbot (Malware)",
      "ShadowPad (Malware)",
      "Sibot (Malware)",
      "SILENTTRINITY (Tool)",
      "SolarWinds Compromise (Campaign)",
      "Stuxnet (Malware)",
      "SUNBURST (Malware)",
    ],
    "T1574.001": [
      "3CX Supply Chain Attack (Campaign)",
      "ANELLDR (Malware)",
      "APT-C-36 (Group)",
      "APT19 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "Aquatic Panda (Group)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADNEWS (Malware)",
      "BBSRAT (Malware)",
      "BlackTech (Group)",
      "BOOKWORM (Malware)",
      "BOOSTWRITE (Malware)",
      "BRONZE BUTLER (Group)",
      "Brute Ratel C4 (Tool)",
      "CANONSTAGER (Malware)",
      "Chaes (Malware)",
      "Chimera (Group)",
      "Chinoxy (Malware)",
      "Cinnamon Tempest (Group)",
      "CLAIMLOADER (Malware)",
      "Clambling (Malware)",
      "CorKLOG (Malware)",
      "Crutch (Malware)",
      "Daggerfly (Group)",
      "DarkGate (Malware)",
      "Denis (Malware)",
      "Downdelph (Malware)",
      "Dridex (Malware)",
      "Earth Lusca (Group)",
      "Ecipekac (Malware)",
      "Egregor (Malware)",
      "Empire (Tool)",
      "Evilnum (Group)",
      "FIN13 (Group)",
      "FinFisher (Malware)",
    ],
    "T1036.008": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "ANDROMEDA (Malware)",
      "AvosLocker (Malware)",
      "BlackByte (Group)",
      "Brute Ratel C4 (Tool)",
      "HeartCrypt (Malware)",
      "Kapeka (Malware)",
      "Lumma Stealer (Malware)",
      "MagicRAT (Malware)",
      "MirrorFace (Group)",
      "Mustang Panda (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Operation Dream Job (Campaign)",
      "OSX_OCEANLOTUS.D (Malware)",
      "PureCrypter (Malware)",
      "QakBot (Malware)",
      "Raspberry Robin (Malware)",
      "STATICPLUGIN (Malware)",
      "StrelaStealer (Malware)",
      "Volt Typhoon (Group)",
    ],
    "T1078.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "APT3 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "BlackByte (Group)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Cobalt Strike (Malware)",
      "CreepySnail (Malware)",
      "Cutting Edge (Campaign)",
      "Indrik Spider (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Magic Hound (Group)",
      "Naikon (Group)",
      "Night Dragon (Campaign)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "Operation Ghost (Campaign)",
      "Operation MidnightEclipse (Campaign)",
      "Operation Wocao (Campaign)",
      "Play (Group)",
      "Ryuk (Malware)",
      "Salesforce Data Exfiltration (Campaign)",
      "Sandworm Team (Group)",
      "Shamoon (Malware)",
      "SolarWinds Compromise (Campaign)",
      "Stuxnet (Malware)",
      "TA505 (Group)",
      "Threat Group-1314 (Group)",
      "ToddyCat (Group)",
      "VOID MANTICORE (Group)",
      "Volt Typhoon (Group)",
      "Wizard Spider (Group)",
    ],
    T1480: [
      "Akira _v2 (Malware)",
      "Anchor (Malware)",
      "Apostle (Malware)",
      "APT-C-36 (Group)",
      "BitPaymer (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BOLDMOVE (Malware)",
      "BoomBox (Malware)",
      "BPFDoor (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Contagious Interview (Group)",
      "DarkGate (Malware)",
      "DEADEYE (Malware)",
      "EnvyScout (Malware)",
      "evilginx2 (Tool)",
      "Exbyte (Malware)",
      "Gamaredon Group (Group)",
      "GlassWorm (Malware)",
      "HiddenFace (Malware)",
      "LazyWiper (Malware)",
      "LightSpy (Malware)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "LODEINFO (Malware)",
      "LunarLoader (Malware)",
      "NativeZone (Malware)",
      "PureCrypter (Malware)",
      "Qilin (Malware)",
      "RansomHub (Malware)",
      "Raspberry Robin (Malware)",
      "RedDelta Modified PlugX Infection Chain Operations (Campaign)",
      "RedLine Stealer (Malware)",
      "ROADSWEEP (Malware)",
      "ROAMINGHOUSE (Malware)",
      "Sagerunex (Malware)",
      "ShrinkLocker (Malware)",
      "Small Sieve (Malware)",
      "StealBit (Malware)",
      "StrelaStealer (Malware)",
    ],
    T1125: [
      "Agent Tesla (Malware)",
      "AsyncRAT (Tool)",
      "Bandook (Malware)",
      "Clambling (Malware)",
      "Cobian RAT (Malware)",
      "ConnectWise (Tool)",
      "Crimson (Malware)",
      "DarkComet (Malware)",
      "Derusbi (Malware)",
      "Ember Bear (Group)",
      "Empire (Tool)",
      "EvilGrab (Malware)",
      "FIN7 (Group)",
      "Imminent Monitor (Tool)",
      "InvisiMole (Malware)",
      "jRAT (Malware)",
      "Kazuar (Malware)",
      "Machete (Malware)",
      "NanoCore (Malware)",
      "njRAT (Malware)",
      "ObliqueRAT (Malware)",
      "PcShare (Tool)",
      "PoetRAT (Malware)",
      "Pupy (Tool)",
      "QuasarRAT (Tool)",
      "Quick Assist (Tool)",
      "Remcos (Tool)",
      "Revenge RAT (Malware)",
      "SDBbot (Malware)",
      "Silence (Group)",
      "T9000 (Malware)",
      "TajMahal (Malware)",
      "VOID MANTICORE (Group)",
      "WarzoneRAT (Malware)",
      "ZxShell (Malware)",
    ],
    T1040: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "APT28 (Group)",
      "APT33 (Group)",
      "ArcaneDoor (Campaign)",
      "CASTLETAP (Malware)",
      "cd00r (Malware)",
      "DarkVishnya (Group)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FoggyWeb (Malware)",
      "Impacket (Tool)",
      "J-magic (Malware)",
      "JumbledPath (Malware)",
      "Kimsuky (Group)",
      "Line Dancer (Malware)",
      "MESSAGETAP (Malware)",
      "NBTscan (Tool)",
      "Penquin (Malware)",
      "PoshC2 (Tool)",
      "RedPenguin (Campaign)",
      "Regin (Malware)",
      "Responder (Tool)",
      "Salt Typhoon (Group)",
      "Sandworm Team (Group)",
      "SPAWNCHIMERA (Malware)",
      "UNC3886 (Group)",
      "Velvet Ant (Group)",
      "VersaMem (Malware)",
    ],
    T1568: [
      "APT-C-36 (Group)",
      "APT29 (Group)",
      "AsyncRAT (Tool)",
      "Bisonal (Malware)",
      "BITTER (Group)",
      "BRICKSTORM (Malware)",
      "C0026 (Campaign)",
      "Gamaredon Group (Group)",
      "Gelsemium (Malware)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
      "Kimsuky (Group)",
      "Maze (Malware)",
      "NETEAGLE (Malware)",
      "Night Dragon (Campaign)",
      "Operation Dust Storm (Campaign)",
      "Operation Spalax (Campaign)",
      "RedEcho (Group)",
      "Remcos (Tool)",
      "RTM (Malware)",
      "SolarWinds Compromise (Campaign)",
      "SUNBURST (Malware)",
      "TA2541 (Group)",
      "Tomiris (Malware)",
      "Transparent Tribe (Group)",
    ],
    "T1069.002": [
      "AdFind (Tool)",
      "BADHATCH (Malware)",
      "BlackCat (Malware)",
      "BloodHound (Tool)",
      "Brute Ratel C4 (Tool)",
      "C0015 (Campaign)",
      "Cobalt Strike (Malware)",
      "CrackMapExec (Tool)",
      "Dragonfly (Group)",
      "dsquery (Tool)",
      "Egregor (Malware)",
      "FIN7 (Group)",
      "Gootloader (Malware)",
      "GRIFFON (Malware)",
      "Helminth (Malware)",
      "INC Ransom (Group)",
      "Inception (Group)",
      "Ke3chang (Group)",
      "Kwampirs (Malware)",
      "LAMEHUG (Malware)",
      "LAPSUS$ (Group)",
      "Latrodectus (Malware)",
      "Medusa Group (Group)",
      "Mustang Panda (Group)",
      "Net (Tool)",
      "OilRig (Group)",
      "OSInfo (Malware)",
      "POWRUNER (Malware)",
      "Qilin (Malware)",
      "REvil (Malware)",
      "Scattered Spider (Group)",
      "SILENTTRINITY (Tool)",
      "SolarWinds Compromise (Campaign)",
      "SoreFang (Malware)",
      "ToddyCat (Group)",
      "Turla (Group)",
      "Volt Typhoon (Group)",
      "WellMess (Malware)",
    ],
    "T1583.008": ["Mustard Tempest (Group)", "Raspberry Robin (Malware)"],
    T1570: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "2016 Ukraine Electric Power Attack (Campaign)",
      "2022 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "Aoqin Dragon (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "BITSAdmin (Tool)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "BlackCat (Malware)",
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "Chimera (Group)",
      "cmd (Tool)",
      "DustySky (Malware)",
      "Ember Bear (Group)",
      "Emotet (Malware)",
      "esentutl (Tool)",
      "Expand (Tool)",
      "FIN10 (Group)",
      "ftp (Tool)",
      "GALLIUM (Group)",
      "Havoc (Malware)",
      "HermeticWizard (Malware)",
      "HomeLand Justice (Campaign)",
      "Impacket (Tool)",
      "INC Ransom (Group)",
      "INC Ransomware (Malware)",
      "IPsec Helper (Malware)",
      "LockerGoga (Malware)",
      "Lucifer (Malware)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "Netwalker (Malware)",
      "Olympic Destroyer (Malware)",
      "Operation Wocao (Campaign)",
      "OutSteel (Malware)",
      "PsExec (Tool)",
    ],
    T1567: [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "BlackByte (Group)",
      "C0017 (Campaign)",
      "Contagious Interview (Group)",
      "DropBook (Malware)",
      "Exbyte (Malware)",
      "InvisibleFerret (Malware)",
      "Magic Hound (Group)",
      "ngrok (Tool)",
      "OilCheck (Malware)",
      "Salesforce Data Exfiltration (Campaign)",
      "SampleCheck5000 (Malware)",
    ],
    "T1552.001": [
      "AADInternals (Tool)",
      "Agent Tesla (Malware)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT3 (Group)",
      "APT33 (Group)",
      "Azorult (Malware)",
      "BlackEnergy (Malware)",
      "Ember Bear (Group)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "Fox Kitten (Group)",
      "Hildegard (Malware)",
      "Indrik Spider (Group)",
      "jRAT (Malware)",
      "Kimsuky (Group)",
      "LaZagne (Tool)",
      "Leafminer (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "MuddyWater (Group)",
      "OilRig (Group)",
      "pngdowner (Malware)",
      "PoshC2 (Tool)",
      "Pupy (Tool)",
      "Pysa (Malware)",
      "QuasarRAT (Tool)",
      "RedCurl (Group)",
      "Scattered Spider (Group)",
      "Shai-Hulud (Malware)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "Smoke Loader (Malware)",
      "StrelaStealer (Malware)",
      "TA505 (Group)",
      "TeamTNT (Group)",
      "TrickBot (Malware)",
      "TruffleHog (Tool)",
      "XTunnel (Malware)",
    ],
    "T1218.007": [
      "3CX Supply Chain Attack (Campaign)",
      "AppleJeus (Malware)",
      "APT38 (Group)",
      "Chaes (Malware)",
      "Clop (Malware)",
      "DEADEYE (Malware)",
      "DOWNIISSA (Malware)",
      "Duqu (Malware)",
      "FlawedAmmyy (Malware)",
      "Grandoreiro (Malware)",
      "IcedID (Malware)",
      "Javali (Malware)",
      "Latrodectus (Malware)",
      "LoudMiner (Malware)",
      "Machete (Group)",
      "Maze (Malware)",
      "Melcoz (Malware)",
      "Metamorfo (Malware)",
      "Mispadu (Malware)",
      "Molerats (Group)",
      "QakBot (Malware)",
      "Ragnar Locker (Malware)",
      "Rancor (Group)",
      "Raspberry Robin (Malware)",
      "RCSession (Malware)",
      "RedDelta Modified PlugX Infection Chain Operations (Campaign)",
      "RedLine Stealer (Malware)",
      "RemoteUtilities (Tool)",
      "TA505 (Group)",
      "Tsundere Botnet (Malware)",
      "ZIRCONIUM (Group)",
    ],
    "T1110.001": [
      "APT28 (Group)",
      "APT29 (Group)",
      "China Chopper (Malware)",
      "CrackMapExec (Tool)",
      "Emotet (Malware)",
      "HermeticWizard (Malware)",
      "Lucifer (Malware)",
      "P.A.S. Webshell (Malware)",
      "Pony (Malware)",
      "SpeakUp (Malware)",
      "VOID MANTICORE (Group)",
      "Xbash (Malware)",
    ],
    "T1564.001": [
      "Agent Tesla (Malware)",
      "AppleJeus (Malware)",
      "APT28 (Group)",
      "APT32 (Group)",
      "Attor (Malware)",
      "attrib (Tool)",
      "BackConfig (Malware)",
      "Calisto (Malware)",
      "Carberp (Malware)",
      "ccf32 (Malware)",
      "CLAIMLOADER (Malware)",
      "Clambling (Malware)",
      "COATHANGER (Malware)",
      "CoinTicker (Malware)",
      "Cuckoo Stealer (Malware)",
      "Dacls (Malware)",
      "DarkGate (Malware)",
      "EnvyScout (Malware)",
      "Explosive (Malware)",
      "FIN13 (Group)",
      "FIN7 (Group)",
      "FruitFly (Malware)",
      "HAFNIUM (Group)",
      "HIUPAN (Malware)",
      "iKitten (Malware)",
      "Imminent Monitor (Tool)",
      "InvisiMole (Malware)",
      "Ixeshe (Malware)",
      "Komplex (Malware)",
      "Lazarus Group (Group)",
      "Lokibot (Malware)",
      "LoudMiner (Malware)",
      "LuminousMoth (Group)",
      "Machete (Malware)",
      "MacSpy (Malware)",
      "Micropsia (Malware)",
      "Mustang Panda (Group)",
      "NETWIRE (Malware)",
      "Okrum (Malware)",
      "OSX/Shlayer (Malware)",
    ],
    "T1614.001": [
      "Avaddon (Malware)",
      "Bazar (Malware)",
      "BlackByte (Group)",
      "BlackByte Ransomware (Malware)",
      "Clop (Malware)",
      "Cuba (Malware)",
      "Cuckoo Stealer (Malware)",
      "DEATHRANSOM (Malware)",
      "DropBook (Malware)",
      "Flagpro (Malware)",
      "GlassWorm (Malware)",
      "Gootloader (Malware)",
      "GrimAgent (Malware)",
      "IcedID (Malware)",
      "Ke3chang (Group)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "LODEINFO (Malware)",
      "Malteiro (Group)",
      "MarkiRAT (Malware)",
      "Maze (Malware)",
      "MirrorFace (Group)",
      "Misdat (Malware)",
      "Mispadu (Malware)",
      "Neoichor (Malware)",
      "Operation Digital Eye (Campaign)",
      "Operation Dream Job (Campaign)",
      "PUBLOAD (Malware)",
      "RedLine Stealer (Malware)",
      "REvil (Malware)",
      "Ryuk (Malware)",
      "S-Type (Malware)",
      "SharpStage (Malware)",
      "Spark (Malware)",
      "StealBit (Malware)",
      "Storm-0501 (Group)",
      "StrelaStealer (Malware)",
      "SynAck (Malware)",
      "XCSSET (Malware)",
      "Zeus Panda (Malware)",
    ],
    "T1021.003": [
      "Cobalt Strike (Malware)",
      "Empire (Tool)",
      "SILENTTRINITY (Tool)",
    ],
    "T1584.008": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT28 (Group)",
      "Cutting Edge (Campaign)",
      "FLORAHOX Activity (Campaign)",
      "KV Botnet Activity (Campaign)",
      "Leviathan (Group)",
      "Quad7 Activity (Campaign)",
      "Versa Director Zero Day Exploitation (Campaign)",
      "Volt Typhoon (Group)",
      "ZIRCONIUM (Group)",
    ],
    "T1559.001": [
      "Bumblebee (Malware)",
      "CLAIMLOADER (Malware)",
      "DarkTortilla (Malware)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "Gelsemium (Malware)",
      "HermeticWizard (Malware)",
      "InvisiMole (Malware)",
      "Kimsuky (Group)",
      "Latrodectus (Malware)",
      "Medusa Group (Group)",
      "Milan (Malware)",
      "MuddyWater (Group)",
      "Neoichor (Malware)",
      "POWERSTATS (Malware)",
      "Ramsay (Malware)",
      "Raspberry Robin (Malware)",
      "RustyWater (Malware)",
      "SILENTTRINITY (Tool)",
      "STATICPLUGIN (Malware)",
      "TrickBot (Malware)",
      "Ursnif (Malware)",
    ],
    "T1496.001": [
      "APT41 (Group)",
      "Blue Mockingbird (Group)",
      "Bonadan (Malware)",
      "CookieMiner (Malware)",
      "DarkGate (Malware)",
      "Hildegard (Malware)",
      "Imminent Monitor (Tool)",
      "Kinsing (Malware)",
      "LoudMiner (Malware)",
      "Lucifer (Malware)",
      "Rocke (Group)",
      "ShadowRay (Campaign)",
      "Skidmap (Malware)",
      "TeamTNT (Group)",
    ],
    T1652: [
      "HOPLIGHT (Malware)",
      "INC Ransomware (Malware)",
      "Medusa Group (Group)",
      "Remsec (Malware)",
    ],
    T1620: [
      "3CX Supply Chain Attack (Campaign)",
      "BADHATCH (Malware)",
      "BRUSHFIRE (Malware)",
      "Brute Ratel C4 (Tool)",
      "Cobalt Strike (Malware)",
      "Cuba (Malware)",
      "Donut (Tool)",
      "Emotet (Malware)",
      "FIN7 (Group)",
      "FoggyWeb (Malware)",
      "Fooder (Malware)",
      "Gamaredon Group (Group)",
      "Gelsemium (Malware)",
      "IceApple (Malware)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "Lizar (Malware)",
      "Lokibot (Malware)",
      "Lumma Stealer (Malware)",
      "LunarLoader (Malware)",
      "metaMain (Malware)",
      "MuddyViper (Malware)",
      "Pikabot (Malware)",
      "PlugX (Malware)",
      "PowerSploit (Tool)",
      "Sardonic (Malware)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "SILENTTRINITY (Tool)",
      "SystemBC (Malware)",
      "ThiefQuest (Malware)",
      "Uroburos (Malware)",
      "WhisperGate (Malware)",
    ],
    "T1491.001": [
      "Black Basta (Malware)",
      "BlackByte (Group)",
      "BlackCat (Malware)",
      "Diavol (Malware)",
      "Gamaredon Group (Group)",
      "INC Ransomware (Malware)",
      "Lazarus Group (Group)",
      "Meteor (Malware)",
      "Qilin (Malware)",
      "RansomHub (Malware)",
      "Remcos (Tool)",
      "ROADSWEEP (Malware)",
      "SameCoin (Malware)",
      "ShrinkLocker (Malware)",
    ],
    "T1001.001": [
      "APT28 (Group)",
      "BeaverTail (Malware)",
      "BendyBear (Malware)",
      "Downdelph (Malware)",
      "GoldMax (Malware)",
      "GrimAgent (Malware)",
      "Kevin (Malware)",
      "LODEINFO (Malware)",
      "Mori (Malware)",
      "P2P ZeuS (Malware)",
      "P8RAT (Malware)",
      "PLEAD (Malware)",
      "SUNBURST (Malware)",
      "TrailBlazer (Malware)",
      "Turian (Malware)",
      "UPSTYLE (Malware)",
      "Uroburos (Malware)",
      "WellMess (Malware)",
    ],
    T1200: ["DarkVishnya (Group)"],
    "T1213.006": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT41 DUST (Campaign)",
      "FIN6 (Group)",
      "GlassWorm (Malware)",
      "Leviathan Australian Intrusions (Campaign)",
      "MgBot (Malware)",
      "P.A.S. Webshell (Malware)",
      "Sandworm Team (Group)",
      "Sea Turtle (Group)",
      "Turla (Group)",
    ],
    "T1052.001": [
      "Agent.btz (Malware)",
      "Machete (Malware)",
      "Mustang Panda (Group)",
      "Remsec (Malware)",
      "SPACESHIP (Malware)",
      "Tropic Trooper (Group)",
      "USBStealer (Malware)",
    ],
    T1648: ["Pacu (Tool)"],
    "T1110.003": [
      "Agrius (Group)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT29 (Group)",
      "APT33 (Group)",
      "Bad Rabbit (Malware)",
      "Chimera (Group)",
      "CrackMapExec (Tool)",
      "Ember Bear (Group)",
      "HAFNIUM (Group)",
      "HEXANE (Group)",
      "Lazarus Group (Group)",
      "Leafminer (Group)",
      "Linux Rabbit (Malware)",
      "MailSniper (Tool)",
      "Quad7 Activity (Campaign)",
      "Silent Librarian (Group)",
    ],
    "T1087.004": [
      "AADInternals (Tool)",
      "APT29 (Group)",
      "C0027 (Campaign)",
      "Pacu (Tool)",
      "ROADTools (Tool)",
      "Storm-0501 (Group)",
    ],
    "T1543.004": [
      "3CX Supply Chain Attack (Campaign)",
      "AppleJeus (Malware)",
      "Bundlore (Malware)",
      "COATHANGER (Malware)",
      "Dacls (Malware)",
      "Green Lambert (Malware)",
      "LoudMiner (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "REPTILE (Malware)",
      "ThiefQuest (Malware)",
      "XCSSET (Malware)",
    ],
    T1078: [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "3CX Supply Chain Attack (Campaign)",
      "Akira (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT18 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT33 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Axiom (Group)",
      "BlackByte (Group)",
      "C0032 (Campaign)",
      "Carbanak (Group)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Dragonfly (Group)",
      "Dtrack (Malware)",
      "Duqu (Malware)",
      "FIN10 (Group)",
      "FIN4 (Group)",
      "FIN5 (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "GALLIUM (Group)",
      "HomeLand Justice (Campaign)",
      "INC Ransom (Group)",
      "Indrik Spider (Group)",
      "Industroyer (Malware)",
      "Ke3chang (Group)",
      "Kinsing (Malware)",
      "LAPSUS$ (Group)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Linux Rabbit (Malware)",
      "LP-Notes (Malware)",
      "Medusa Group (Group)",
    ],
    T1210: [
      "APT28 (Group)",
      "Bad Rabbit (Malware)",
      "Conficker (Malware)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FIN7 (Group)",
      "Flame (Malware)",
      "Fox Kitten (Group)",
      "InvisiMole (Malware)",
      "Lucifer (Malware)",
      "menuPass (Group)",
      "MuddyWater (Group)",
      "NotPetya (Malware)",
      "PoshC2 (Tool)",
      "QakBot (Malware)",
      "Stuxnet (Malware)",
      "Threat Group-3390 (Group)",
      "Tonto Team (Group)",
      "TrickBot (Malware)",
      "WannaCry (Malware)",
      "Wizard Spider (Group)",
    ],
    T1555: [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agent Tesla (Malware)",
      "APT33 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Astaroth (Malware)",
      "BeaverTail (Malware)",
      "Carberp (Malware)",
      "CosmicDuke (Malware)",
      "DarkGate (Malware)",
      "Evilnum (Group)",
      "FIN6 (Group)",
      "HEXANE (Group)",
      "KGH_SPY (Malware)",
      "LaZagne (Tool)",
      "Leafminer (Group)",
      "Lokibot (Malware)",
      "Malteiro (Group)",
      "Manjusaka (Malware)",
      "Matryoshka (Malware)",
      "MgBot (Malware)",
      "Mimikatz (Tool)",
      "MirrorStealer (Malware)",
      "Mispadu (Malware)",
      "MuddyWater (Group)",
      "NETWIRE (Malware)",
      "OilRig (Group)",
      "OLDBAIT (Malware)",
      "PinchDuke (Malware)",
      "PLEAD (Malware)",
      "PoshC2 (Tool)",
      "Prikormka (Malware)",
      "Pupy (Tool)",
      "QuasarRAT (Tool)",
      "RedLine Stealer (Malware)",
      "SolarWinds Compromise (Campaign)",
      "Stealth Falcon (Group)",
      "Volt Typhoon (Group)",
      "XLoader (Malware)",
    ],
    "T1564.003": [
      "Agent Tesla (Malware)",
      "APT-C-36 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "AvosLocker (Malware)",
      "BONDUPDATER (Malware)",
      "BOOKWORM (Malware)",
      "CANONSTAGER (Malware)",
      "CopyKittens (Group)",
      "Cuba (Malware)",
      "DarkHydrus (Group)",
      "Deep Panda (Group)",
      "FIN7 (Group)",
      "Gamaredon Group (Group)",
      "GlassWorm (Malware)",
      "Gorgon Group (Group)",
      "HAMMERTOSS (Malware)",
      "Higaisa (Group)",
      "HotCroissant (Malware)",
      "IMAPLoader (Malware)",
      "InvisibleFerret (Malware)",
      "InvisiMole (Malware)",
      "Kevin (Malware)",
      "KeyBoy (Malware)",
      "Kimsuky (Group)",
      "Kivars (Malware)",
      "Koadic (Tool)",
      "KOCTOPUS (Malware)",
      "LockBit 2.0 (Malware)",
      "Lumma Stealer (Malware)",
      "Magic Hound (Group)",
      "MCMD (Tool)",
      "Medusa Group (Group)",
      "Medusa Ransomware (Malware)",
      "Metamorfo (Malware)",
      "Meteor (Malware)",
    ],
    "T1548.002": [
      "AppleJeus (Malware)",
      "APT29 (Group)",
      "APT37 (Group)",
      "APT38 (Group)",
      "AutoIt backdoor (Malware)",
      "Avaddon (Malware)",
      "Bad Rabbit (Malware)",
      "BADHATCH (Malware)",
      "BitPaymer (Malware)",
      "BlackCat (Malware)",
      "BlackEnergy (Malware)",
      "BRONZE BUTLER (Group)",
      "Bumblebee (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Clambling (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "CSPY Downloader (Tool)",
      "DarkGate (Malware)",
      "Downdelph (Malware)",
      "Earth Lusca (Group)",
      "Empire (Tool)",
      "Evilnum (Group)",
      "FinFisher (Malware)",
      "Gelsemium (Malware)",
      "Grandoreiro (Malware)",
      "H1N1 (Malware)",
      "HTTPTroy (Malware)",
      "InvisiMole (Malware)",
      "Koadic (Tool)",
      "KOCTOPUS (Malware)",
      "KONNI (Malware)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "Lokibot (Malware)",
      "Medusa Group (Group)",
      "MuddyWater (Group)",
      "Operation Honeybee (Campaign)",
      "Patchwork (Group)",
      "PipeMon (Malware)",
    ],
    "T1059.004": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Anchor (Malware)",
      "AppleJeus (Malware)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "BOLDMOVE (Malware)",
      "BPFDoor (Malware)",
      "BRICKSTORM (Malware)",
      "Bundlore (Malware)",
      "CallMe (Malware)",
      "CASTLETAP (Malware)",
      "Chaos (Malware)",
      "COATHANGER (Malware)",
      "CoinTicker (Malware)",
      "Contagious Interview (Group)",
      "CookieMiner (Malware)",
      "Cuckoo Stealer (Malware)",
      "Derusbi (Malware)",
      "Doki (Malware)",
      "Drovorub (Malware)",
      "Ebury (Malware)",
      "Exaramel for Linux (Malware)",
      "FLORAHOX Activity (Campaign)",
      "Fysbis (Malware)",
      "Gomir (Malware)",
      "Green Lambert (Malware)",
      "Hildegard (Malware)",
      "J-magic (Malware)",
      "Kazuar (Malware)",
      "Kinsing (Malware)",
      "Kobalos (Malware)",
      "KV Botnet Activity (Campaign)",
      "LoudMiner (Malware)",
      "MacMa (Malware)",
      "NETWIRE (Malware)",
      "NKAbuse (Malware)",
      "Operation MidnightEclipse (Campaign)",
      "OSX/Shlayer (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "PACEMAKER (Malware)",
    ],
    "T1588.001": [
      "Andariel (Group)",
      "APT-C-36 (Group)",
      "APT1 (Group)",
      "Aquatic Panda (Group)",
      "BackdoorDiplomacy (Group)",
      "C0015 (Campaign)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "FunnyDream (Campaign)",
      "J-magic Campaign (Campaign)",
      "LAPSUS$ (Group)",
      "LazyScripter (Group)",
      "LuminousMoth (Group)",
      "Metador (Group)",
      "MuddyWater (Group)",
      "Night Dragon (Campaign)",
      "Operation Spalax (Campaign)",
      "Scattered Spider (Group)",
      "TA2541 (Group)",
      "TA505 (Group)",
      "Turla (Group)",
      "UNC3886 (Group)",
      "VOID MANTICORE (Group)",
    ],
    "T1569.003": ["TeamTNT (Group)"],
    "T1585.003": [
      "Operation AkaiRy\u016b (Campaign)",
      "Outer Space (Campaign)",
      "Storm-1811 (Group)",
    ],
    T1529: [
      "2025 Poland Wiper Attacks (Campaign)",
      "AcidPour (Malware)",
      "AcidRain (Malware)",
      "Apostle (Malware)",
      "APT37 (Group)",
      "APT38 (Group)",
      "AvosLocker (Malware)",
      "BFG Agonizer (Malware)",
      "Black Basta (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "DarkGate (Malware)",
      "DCSrv (Malware)",
      "DynoWiper (Malware)",
      "HermeticWiper (Malware)",
      "KillDisk (Malware)",
      "Latrodectus (Malware)",
      "Lazarus Group (Group)",
      "LockerGoga (Malware)",
      "LookBack (Malware)",
      "Maze (Malware)",
      "Medusa Group (Group)",
      "MultiLayer Wiper (Malware)",
      "NotPetya (Malware)",
      "Olympic Destroyer (Malware)",
      "Qilin (Malware)",
      "Remcos (Tool)",
      "Shamoon (Malware)",
      "ShrinkLocker (Malware)",
      "WhisperGate (Malware)",
      "XLoader (Malware)",
    ],
    "T1074.001": [
      "2025 Poland Wiper Attacks (Campaign)",
      "ADVSTORESHELL (Malware)",
      "Agrius (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT3 (Group)",
      "APT39 (Group)",
      "APT41 DUST (Campaign)",
      "APT5 (Group)",
      "Astaroth (Malware)",
      "Attor (Malware)",
      "AuTo Stealer (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADNEWS (Malware)",
      "BadPatch (Malware)",
      "BeaverTail (Malware)",
      "BoxCaon (Malware)",
      "C0015 (Campaign)",
      "C0017 (Campaign)",
      "C0032 (Campaign)",
      "Calisto (Malware)",
      "Carbon (Malware)",
      "Catchamas (Malware)",
      "ccf32 (Malware)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
      "Chrommme (Malware)",
      "CorKLOG (Malware)",
      "Crutch (Malware)",
      "Cuckoo Stealer (Malware)",
      "DarkWatchman (Malware)",
      "Dragonfly (Group)",
      "DRYHOOK (Malware)",
      "Dtrack (Malware)",
      "Duqu (Malware)",
      "DustySky (Malware)",
      "Dyre (Malware)",
      "ECCENTRICBANDWAGON (Malware)",
    ],
    T1489: [
      "Akira _v2 (Malware)",
      "Avaddon (Malware)",
      "AvosLocker (Malware)",
      "Babuk (Malware)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BlackCat (Malware)",
      "BRICKSTORM (Malware)",
      "Cheerscrypt (Malware)",
      "Clop (Malware)",
      "Conti (Malware)",
      "Cuba (Malware)",
      "Diavol (Malware)",
      "DRYHOOK (Malware)",
      "EKANS (Malware)",
      "Embargo (Malware)",
      "Hannotog (Malware)",
      "HermeticWiper (Malware)",
      "HotCroissant (Malware)",
      "INC Ransomware (Malware)",
      "Indrik Spider (Group)",
      "Industroyer (Malware)",
      "InvisibleFerret (Malware)",
      "KillDisk (Malware)",
      "Kimsuky (Group)",
      "LAPSUS$ (Group)",
      "Lazarus Group (Group)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "LookBack (Malware)",
      "Maze (Malware)",
      "Medusa Group (Group)",
      "Medusa Ransomware (Malware)",
      "MegaCortex (Malware)",
      "Megazord (Malware)",
      "Meteor (Malware)",
      "Netwalker (Malware)",
      "Olympic Destroyer (Malware)",
      "Pay2Key (Malware)",
      "PHASEJAM (Malware)",
      "Prestige (Malware)",
    ],
    T1667: ["Storm-1811 (Group)"],
    "T1069.001": [
      "admin@338 (Group)",
      "BloodHound (Tool)",
      "C0015 (Campaign)",
      "Caterpillar WebShell (Malware)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "Emissary (Malware)",
      "Epic (Malware)",
      "Exbyte (Malware)",
      "Flagpro (Malware)",
      "FlawedAmmyy (Malware)",
      "Gomir (Malware)",
      "Helminth (Malware)",
      "HEXANE (Group)",
      "JPIN (Malware)",
      "Kazuar (Malware)",
      "Kwampirs (Malware)",
      "LunarWeb (Malware)",
      "Net (Tool)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "Operation Digital Eye (Campaign)",
      "Operation Wocao (Campaign)",
      "OSInfo (Malware)",
      "PoshC2 (Tool)",
      "POWRUNER (Malware)",
      "QakBot (Malware)",
      "SILENTTRINITY (Tool)",
      "Sys10 (Malware)",
      "Tonto Team (Group)",
      "Turla (Group)",
      "Volt Typhoon (Group)",
    ],
    T1014: [
      "APT28 (Group)",
      "APT41 (Group)",
      "ArcaneDoor (Campaign)",
      "Carberp (Malware)",
      "Caterpillar WebShell (Malware)",
      "COATHANGER (Malware)",
      "Drovorub (Malware)",
      "Ebury (Malware)",
      "Hacking Team UEFI Rootkit (Malware)",
      "HiddenWasp (Malware)",
      "HIDEDRV (Malware)",
      "Hikit (Malware)",
      "Hildegard (Malware)",
      "HTRAN (Tool)",
      "Line Dancer (Malware)",
      "LoJax (Malware)",
      "MEDUSA (Malware)",
      "PoisonIvy (Malware)",
      "Ramsay (Malware)",
      "RedPenguin (Campaign)",
      "REPTILE (Malware)",
      "Rocke (Group)",
      "Skidmap (Malware)",
      "Stuxnet (Malware)",
      "TeamTNT (Group)",
      "Umbreon (Malware)",
      "UNC3886 (Group)",
      "Uroburos (Malware)",
      "WarzoneRAT (Malware)",
      "Winnti for Linux (Malware)",
      "Winnti Group (Group)",
      "Zeroaccess (Malware)",
    ],
    "T1497.001": [
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Attor (Malware)",
      "BadPatch (Malware)",
      "Black Basta (Malware)",
      "BlackByte Ransomware (Malware)",
      "BLUELIGHT (Malware)",
      "Bumblebee (Malware)",
      "CSPY Downloader (Tool)",
      "DarkGate (Malware)",
      "Darkhotel (Group)",
      "DarkTortilla (Malware)",
      "Denis (Malware)",
      "DUSTTRAP (Malware)",
      "Dyre (Malware)",
      "EvilBunny (Malware)",
      "Evilnum (Group)",
      "Exbyte (Malware)",
      "Ferocious (Malware)",
      "FinFisher (Malware)",
      "Frankenstein (Campaign)",
      "Gamaredon Group (Group)",
      "GoldMax (Malware)",
      "Grandoreiro (Malware)",
      "GravityRAT (Malware)",
      "GuLoader (Malware)",
      "HeartCrypt (Malware)",
      "InvisiMole (Malware)",
      "Kimsuky (Group)",
      "Latrodectus (Malware)",
      "Lucifer (Malware)",
      "Lumma Stealer (Malware)",
      "macOS.OSAMiner (Malware)",
      "MegaCortex (Malware)",
      "Mispadu (Malware)",
      "NativeZone (Malware)",
      "Nightdoor (Malware)",
      "ObliqueRAT (Malware)",
      "OilRig (Group)",
      "Okrum (Malware)",
    ],
    "T1589.001": [
      "APT28 (Group)",
      "C0027 (Campaign)",
      "Chimera (Group)",
      "LAPSUS$ (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
      "SolarWinds Compromise (Campaign)",
    ],
    "T1003.005": [
      "APT33 (Group)",
      "Cachedump (Tool)",
      "LaZagne (Tool)",
      "Leafminer (Group)",
      "MuddyWater (Group)",
      "OilRig (Group)",
      "Okrum (Malware)",
      "Pupy (Tool)",
    ],
    "T1587.001": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Aoqin Dragon (Group)",
      "APT-C-36 (Group)",
      "APT29 (Group)",
      "ArcaneDoor (Campaign)",
      "C0010 (Campaign)",
      "Cleaver (Group)",
      "Contagious Interview (Group)",
      "CostaRicto (Campaign)",
      "FIN13 (Group)",
      "FIN7 (Group)",
      "Indrik Spider (Group)",
      "Juicy Mix (Campaign)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "LuminousMoth (Group)",
      "MirrorFace (Group)",
      "Moonstone Sleet (Group)",
      "Moses Staff (Group)",
      "Mustang Panda (Group)",
      "OilRig (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Operation Dream Job (Campaign)",
      "Operation Ghost (Campaign)",
      "Operation Sharpshooter (Campaign)",
      "Operation Wocao (Campaign)",
      "Outer Space (Campaign)",
      "Play (Group)",
      "RedCurl (Group)",
      "RedPenguin (Campaign)",
      "Salesforce Data Exfiltration (Campaign)",
      "Salt Typhoon (Group)",
      "Sandworm Team (Group)",
      "SolarWinds Compromise (Campaign)",
      "TeamTNT (Group)",
      "Triton Safety Instrumented System Attack (Campaign)",
      "Turla (Group)",
      "UNC3886 (Group)",
      "Versa Director Zero Day Exploitation (Campaign)",
    ],
    T1485: [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "AcidPour (Malware)",
      "AcidRain (Malware)",
      "Apostle (Malware)",
      "APT38 (Group)",
      "BlackEnergy (Malware)",
      "CaddyWiper (Malware)",
      "DEADWOOD (Malware)",
      "Diavol (Malware)",
      "DynoWiper (Malware)",
      "HermeticWiper (Malware)",
      "Industroyer (Malware)",
      "Kazuar (Malware)",
      "KillDisk (Malware)",
      "LAPSUS$ (Group)",
      "Lazarus Group (Group)",
      "LazyWiper (Malware)",
      "Meteor (Malware)",
      "MultiLayer Wiper (Malware)",
      "Olympic Destroyer (Malware)",
      "PowerDuke (Malware)",
      "Proxysvc (Malware)",
      "RawDisk (Tool)",
      "REvil (Malware)",
      "SameCoin (Malware)",
      "Sandworm Team (Group)",
      "SDelete (Tool)",
      "Shai-Hulud (Malware)",
      "Shamoon (Malware)",
      "ShrinkLocker (Malware)",
      "StoneDrill (Malware)",
      "Storm-0501 (Group)",
      "VOID MANTICORE (Group)",
      "WhisperGate (Malware)",
      "Xbash (Malware)",
    ],
    "T1055.001": [
      "Aria-body (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADHATCH (Malware)",
      "BlackEnergy (Malware)",
      "Bumblebee (Malware)",
      "C0015 (Campaign)",
      "Carberp (Malware)",
      "Carbon (Malware)",
      "Cobalt Strike (Malware)",
      "ComRAT (Malware)",
      "Conti (Malware)",
      "DarkTortilla (Malware)",
      "Derusbi (Malware)",
      "Duqu (Malware)",
      "Dyre (Malware)",
      "Elise (Malware)",
      "Emissary (Malware)",
      "Emotet (Malware)",
      "FinFisher (Malware)",
      "FunnyDream (Malware)",
      "Gelsemium (Malware)",
      "Get2 (Malware)",
      "Havoc (Malware)",
      "Heyoka Backdoor (Malware)",
      "HIDEDRV (Malware)",
      "IronNetInjector (Tool)",
      "Kazuar (Malware)",
      "Kimsuky (Group)",
      "Koadic (Tool)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Lizar (Malware)",
      "Malteiro (Group)",
      "Matryoshka (Malware)",
      "Maze (Malware)",
      "MegaCortex (Malware)",
      "Metamorfo (Malware)",
      "Mongall (Malware)",
      "Netwalker (Malware)",
      "PipeMon (Malware)",
    ],
    "T1090.002": [
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT39 (Group)",
      "evilginx2 (Tool)",
      "FIN5 (Group)",
      "GALLIUM (Group)",
      "InvisiMole (Malware)",
      "Lazarus Group (Group)",
      "menuPass (Group)",
      "MuddyWater (Group)",
      "Mythic (Tool)",
      "Okrum (Malware)",
      "POWERSTATS (Malware)",
      "QakBot (Malware)",
      "Quad7 Activity (Campaign)",
      "QUIETEXIT (Malware)",
      "Regin (Malware)",
      "ShimRat (Malware)",
      "Silence (Group)",
      "Tonto Team (Group)",
      "TrickBot (Malware)",
      "Winnti for Windows (Malware)",
    ],
    "T1137.005": ["Ruler (Tool)"],
    T1583: [
      "Agrius (Group)",
      "Contagious Interview (Group)",
      "Ember Bear (Group)",
      "Indrik Spider (Group)",
      "Kimsuky (Group)",
      "Sandworm Team (Group)",
      "Sea Turtle (Group)",
      "Star Blizzard (Group)",
    ],
    T1053: ["2025 Poland Wiper Attacks (Campaign)", "Lokibot (Malware)"],
    T1598: [
      "APT28 (Group)",
      "Kimsuky (Group)",
      "Moonstone Sleet (Group)",
      "Scattered Spider (Group)",
      "ZIRCONIUM (Group)",
    ],
    T1591: [
      "APT28 (Group)",
      "FIN7 (Group)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "MirrorFace (Group)",
      "Moonstone Sleet (Group)",
      "Operation Digital Eye (Campaign)",
      "Operation Dream Job (Campaign)",
      "Volt Typhoon (Group)",
    ],
    "T1566.003": [
      "Ajax Security Team (Group)",
      "APT29 (Group)",
      "Contagious Interview (Group)",
      "CURIUM (Group)",
      "Dark Caracal (Group)",
      "EXOTIC LILY (Group)",
      "FIN6 (Group)",
      "Lazarus Group (Group)",
      "Magic Hound (Group)",
      "Moonstone Sleet (Group)",
      "Ninja (Malware)",
      "OilRig (Group)",
      "Operation Dream Job (Campaign)",
      "Storm-1811 (Group)",
      "ToddyCat (Group)",
      "Windshift (Group)",
    ],
    "T1059.007": [
      "AppleSeed (Malware)",
      "APT-C-36 (Group)",
      "APT32 (Group)",
      "AshTag (Malware)",
      "Astaroth (Malware)",
      "Avaddon (Malware)",
      "BeaverTail (Malware)",
      "BlackByte Ransomware (Malware)",
      "Bundlore (Malware)",
      "C0015 (Campaign)",
      "C0017 (Campaign)",
      "Chaes (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Contagious Interview (Group)",
      "DarkWatchman (Malware)",
      "Donut (Tool)",
      "Earth Lusca (Group)",
      "EnvyScout (Malware)",
      "evilginx2 (Tool)",
      "Evilnum (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "FRP (Tool)",
      "GlassWorm (Malware)",
      "Gootloader (Malware)",
      "GRIFFON (Malware)",
      "HexEval Loader (Malware)",
      "Higaisa (Group)",
      "Indrik Spider (Group)",
      "InvisiMole (Malware)",
      "jRAT (Malware)",
      "JSS Loader (Malware)",
      "Kimsuky (Group)",
      "KONNI (Malware)",
      "KOPILUWAK (Malware)",
      "Latrodectus (Malware)",
      "LazyScripter (Group)",
      "Leafminer (Group)",
      "Metamorfo (Malware)",
    ],
    T1036: [
      "Agrius (Group)",
      "Aoqin Dragon (Group)",
      "AppleSeed (Malware)",
      "APT28 (Group)",
      "APT32 (Group)",
      "ArcaneDoor (Campaign)",
      "BeaverTail (Malware)",
      "Bisonal (Malware)",
      "BoomBox (Malware)",
      "BRONZE BUTLER (Group)",
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "Contagious Interview (Group)",
      "Dacls (Malware)",
      "DarkGate (Malware)",
      "DarkTortilla (Malware)",
      "DarkWatchman (Malware)",
      "DynoWiper (Malware)",
      "Ember Bear (Group)",
      "EnvyScout (Malware)",
      "FIN13 (Group)",
      "Flagpro (Malware)",
      "FoggyWeb (Malware)",
      "GlassWorm (Malware)",
      "KV Botnet Activity (Campaign)",
      "LazyScripter (Group)",
      "menuPass (Group)",
      "Milan (Malware)",
      "NativeZone (Malware)",
      "Nomadic Octopus (Group)",
      "NotPetya (Malware)",
      "OilRig (Group)",
      "Operation Dust Storm (Campaign)",
      "Operation Honeybee (Campaign)",
      "PLATINUM (Group)",
      "Pony (Malware)",
      "PowGoop (Malware)",
      "Raindrop (Malware)",
      "Ramsay (Malware)",
      "RCSession (Malware)",
    ],
    T1115: [
      "Agent Tesla (Malware)",
      "APT38 (Group)",
      "APT39 (Group)",
      "Astaroth (Malware)",
      "Attor (Malware)",
      "BOOKWORM (Malware)",
      "Cadelspy (Malware)",
      "Catchamas (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Clambling (Malware)",
      "CosmicDuke (Malware)",
      "DarkComet (Malware)",
      "DarkGate (Malware)",
      "DarkTortilla (Malware)",
      "Empire (Tool)",
      "Explosive (Malware)",
      "FlawedAmmyy (Malware)",
      "Grandoreiro (Malware)",
      "Helminth (Malware)",
      "InvisibleFerret (Malware)",
      "JHUHUGIT (Malware)",
      "jRAT (Malware)",
      "Kimsuky (Group)",
      "Koadic (Tool)",
      "KONNI (Malware)",
      "Machete (Malware)",
      "MacSpy (Malware)",
      "MarkiRAT (Malware)",
      "Melcoz (Malware)",
      "Metamorfo (Malware)",
      "MgBot (Malware)",
      "Mispadu (Malware)",
      "OilRig (Group)",
      "Operation Wocao (Campaign)",
      "PAKLOG (Malware)",
      "Remcos (Tool)",
      "Remexi (Malware)",
      "ROKRAT (Malware)",
      "RTM (Malware)",
      "RunningRAT (Malware)",
    ],
    "T1055.002": [
      "3CX Supply Chain Attack (Campaign)",
      "Brute Ratel C4 (Tool)",
      "Carbanak (Malware)",
      "DUSTPAN (Malware)",
      "Gootloader (Malware)",
      "Gorgon Group (Group)",
      "GreyEnergy (Malware)",
      "Havoc (Malware)",
      "InvisiMole (Malware)",
      "Lizar (Malware)",
      "Pikabot (Malware)",
      "Rocke (Group)",
      "RustyWater (Malware)",
      "SPAWNCHIMERA (Malware)",
      "Zeus Panda (Malware)",
    ],
    "T1213.002": [
      "Akira (Group)",
      "APT28 (Group)",
      "C0027 (Campaign)",
      "Chimera (Group)",
      "HAFNIUM (Group)",
      "Ke3chang (Group)",
      "LAPSUS$ (Group)",
      "spwebmember (Tool)",
      "TruffleHog (Tool)",
      "VOID MANTICORE (Group)",
    ],
    "T1001.002": [
      "Axiom (Group)",
      "Daserf (Malware)",
      "Duqu (Malware)",
      "HAMMERTOSS (Malware)",
      "LightNeuron (Malware)",
      "LunarMail (Malware)",
      "LunarWeb (Malware)",
      "Operation Ghost (Campaign)",
      "RDAT (Malware)",
      "Sliver (Tool)",
      "SUNBURST (Malware)",
      "ZeroT (Malware)",
      "Zox (Malware)",
    ],
    "T1036.004": [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "APT-C-36 (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "Aquatic Panda (Group)",
      "Attor (Malware)",
      "BackdoorDiplomacy (Group)",
      "Bazar (Malware)",
      "BITTER (Group)",
      "Black Basta (Malware)",
      "BOOKWORM (Malware)",
      "build_downer (Malware)",
      "C0017 (Campaign)",
      "Carbanak (Group)",
      "Catchamas (Malware)",
      "ComRAT (Malware)",
      "Crutch (Malware)",
      "CSPY Downloader (Tool)",
      "DCSrv (Malware)",
      "DEADEYE (Malware)",
      "DEADWOOD (Malware)",
      "Egregor (Malware)",
      "Emotet (Malware)",
      "Exaramel for Windows (Malware)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "Fox Kitten (Group)",
      "Frankenstein (Campaign)",
      "FunnyDream (Malware)",
      "Fysbis (Malware)",
      "GoldMax (Malware)",
      "Green Lambert (Malware)",
      "Heyoka Backdoor (Malware)",
      "Higaisa (Group)",
      "Hildegard (Malware)",
      "InnaputRAT (Malware)",
      "InvisiMole (Malware)",
      "IronNetInjector (Tool)",
    ],
    "T1559.002": [
      "APT28 (Group)",
      "APT37 (Group)",
      "BITTER (Group)",
      "Cobalt Group (Group)",
      "FIN7 (Group)",
      "Gallmaker (Group)",
      "GravityRAT (Malware)",
      "HAWKBALL (Malware)",
      "KeyBoy (Malware)",
      "Leviathan (Group)",
      "MuddyWater (Group)",
      "Operation Sharpshooter (Campaign)",
      "Patchwork (Group)",
      "PoetRAT (Malware)",
      "POWERSTATS (Malware)",
      "Ramsay (Malware)",
      "RTM (Malware)",
      "Sidewinder (Group)",
      "TA505 (Group)",
      "Valak (Malware)",
    ],
    "T1059.012": [
      "Cheerscrypt (Malware)",
      "Royal (Malware)",
      "UNC3886 (Group)",
      "VIRTUALPIE (Malware)",
    ],
    "T1550.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "BADHATCH (Malware)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "CrackMapExec (Tool)",
      "Ember Bear (Group)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "GALLIUM (Group)",
      "HOPLIGHT (Malware)",
      "Kimsuky (Group)",
      "Mimikatz (Tool)",
      "Night Dragon (Campaign)",
      "Operation Digital Eye (Campaign)",
      "Pass-The-Hash Toolkit (Tool)",
      "PoshC2 (Tool)",
      "Wizard Spider (Group)",
    ],
    "T1546.015": [
      "ADVSTORESHELL (Malware)",
      "APT28 (Group)",
      "BBSRAT (Malware)",
      "ComRAT (Malware)",
      "Ferocious (Malware)",
      "JHUHUGIT (Malware)",
      "KONNI (Malware)",
      "Mosquito (Malware)",
      "PcShare (Tool)",
      "SILENTTRINITY (Tool)",
      "SVCReady (Malware)",
      "WarzoneRAT (Malware)",
    ],
    "T1555.003": [
      "Agent Tesla (Malware)",
      "Ajax Security Team (Group)",
      "APT3 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Azorult (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BeaverTail (Malware)",
      "BlackEnergy (Malware)",
      "BLUELIGHT (Malware)",
      "Carberp (Malware)",
      "Chaes (Malware)",
      "ChChes (Malware)",
      "CookieMiner (Malware)",
      "CosmicDuke (Malware)",
      "Crimson (Malware)",
      "Emotet (Malware)",
      "Empire (Tool)",
      "FIN6 (Group)",
      "GlassWorm (Malware)",
      "Grandoreiro (Malware)",
      "H1N1 (Malware)",
      "HEXANE (Group)",
      "Imminent Monitor (Tool)",
      "Inception (Group)",
      "InvisibleFerret (Malware)",
      "Javali (Malware)",
      "jRAT (Malware)",
      "Juicy Mix (Campaign)",
      "KeyBoy (Malware)",
      "KGH_SPY (Malware)",
      "Kimsuky (Group)",
      "KONNI (Malware)",
      "LAPSUS$ (Group)",
      "LaZagne (Tool)",
      "Leafminer (Group)",
      "Lizar (Malware)",
      "Lokibot (Malware)",
    ],
    "T1218.011": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "ADVSTORESHELL (Malware)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "Attor (Malware)",
      "Backdoor.Oldrea (Malware)",
      "Bad Rabbit (Malware)",
      "Bisonal (Malware)",
      "BLINDINGCAN (Malware)",
      "Blue Mockingbird (Group)",
      "BoomBox (Malware)",
      "Briba (Malware)",
      "Bumblebee (Malware)",
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "C0021 (Campaign)",
      "Carbanak (Group)",
      "Cobalt Strike (Malware)",
      "Comnie (Malware)",
      "CopyKittens (Group)",
      "CORESHELL (Malware)",
      "CozyCar (Malware)",
      "Daggerfly (Group)",
      "DDKONG (Malware)",
      "DEADEYE (Malware)",
      "Egregor (Malware)",
      "Elise (Malware)",
      "Emissary (Malware)",
      "EnvyScout (Malware)",
      "EVILNUM (Malware)",
      "FatDuke (Malware)",
      "FELIXROOT (Malware)",
      "FIN7 (Group)",
      "Flame (Malware)",
      "FlawedAmmyy (Malware)",
    ],
    "T1560.003": [
      "ADVSTORESHELL (Malware)",
      "Agent.btz (Malware)",
      "Attor (Malware)",
      "BLUELIGHT (Malware)",
      "C0017 (Campaign)",
      "CopyKittens (Group)",
      "Duqu (Malware)",
      "FIN6 (Group)",
      "FLASHFLOOD (Malware)",
      "FoggyWeb (Malware)",
      "FrameworkPOS (Malware)",
      "FunnyDream (Malware)",
      "HAWKBALL (Malware)",
      "InvisiMole (Malware)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "Lotus Blossom (Group)",
      "Machete (Malware)",
      "MESSAGETAP (Malware)",
      "metaMain (Malware)",
      "Mustang Panda (Group)",
      "NETWIRE (Malware)",
      "Okrum (Malware)",
      "OopsIE (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "OwaAuth (Malware)",
      "Ramsay (Malware)",
      "RawPOS (Malware)",
      "Reaver (Malware)",
      "RGDoor (Malware)",
      "Rising Sun (Malware)",
      "SombRAT (Malware)",
      "SPACESHIP (Malware)",
      "Squirrelwaffle (Malware)",
      "StrongPity (Malware)",
      "Stuxnet (Malware)",
      "SUGARDUMP (Malware)",
      "T9000 (Malware)",
      "UNC3886 (Group)",
    ],
    "T1137.001": [
      "BackConfig (Malware)",
      "Cobalt Strike (Malware)",
      "MuddyWater (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "ROAMINGHOUSE (Malware)",
    ],
    T1123: [
      "APT37 (Group)",
      "Attor (Malware)",
      "Bandook (Malware)",
      "Cadelspy (Malware)",
      "Cobian RAT (Malware)",
      "Crimson (Malware)",
      "DarkComet (Malware)",
      "Derusbi (Malware)",
      "DOGCALL (Malware)",
      "EvilGrab (Malware)",
      "Flame (Malware)",
      "Imminent Monitor (Tool)",
      "InvisiMole (Malware)",
      "Janicab (Malware)",
      "jRAT (Malware)",
      "LightSpy (Malware)",
      "Machete (Malware)",
      "MacMa (Malware)",
      "MacSpy (Malware)",
      "MgBot (Malware)",
      "Micropsia (Malware)",
      "NanoCore (Malware)",
      "NightClub (Malware)",
      "PowerSploit (Tool)",
      "Pupy (Tool)",
      "Remcos (Tool)",
      "Revenge RAT (Malware)",
      "ROKRAT (Malware)",
      "T9000 (Malware)",
      "TajMahal (Malware)",
      "VERMIN (Malware)",
      "VOID MANTICORE (Group)",
    ],
    "T1555.001": [
      "BeaverTail (Malware)",
      "Calisto (Malware)",
      "Contagious Interview (Group)",
      "Cuckoo Stealer (Malware)",
      "Empire (Tool)",
      "GlassWorm (Malware)",
      "Green Lambert (Malware)",
      "iKitten (Malware)",
      "LaZagne (Tool)",
      "LightSpy (Malware)",
      "MacMa (Malware)",
      "Proton (Malware)",
    ],
    "T1055.012": [
      "Agent Tesla (Malware)",
      "APT-C-36 (Group)",
      "Astaroth (Malware)",
      "Azorult (Malware)",
      "BADNEWS (Malware)",
      "Bandook (Malware)",
      "Bazar (Malware)",
      "BBSRAT (Malware)",
      "BlackByte (Group)",
      "Caminho (Malware)",
      "Clambling (Malware)",
      "Cobalt Strike (Malware)",
      "DarkGate (Malware)",
      "Denis (Malware)",
      "Dtrack (Malware)",
      "Duqu (Malware)",
      "Emotet (Malware)",
      "Gootloader (Malware)",
      "Gorgon Group (Group)",
      "HeartCrypt (Malware)",
      "IcedID (Malware)",
      "ISMInjector (Malware)",
      "Kimsuky (Group)",
      "Lokibot (Malware)",
      "Lumma Stealer (Malware)",
      "menuPass (Group)",
      "NETWIRE (Malware)",
      "Orz (Malware)",
      "Patchwork (Group)",
      "QakBot (Malware)",
      "Raspberry Robin (Malware)",
      "RCSession (Malware)",
      "Saint Bot (Malware)",
      "Smoke Loader (Malware)",
      "Snip3 (Malware)",
      "TA2541 (Group)",
      "Threat Group-3390 (Group)",
      "TRAILBLAZE (Malware)",
      "TrickBot (Malware)",
      "Ursnif (Malware)",
    ],
    "T1583.001": [
      "APT-C-36 (Group)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT42 (Group)",
      "BITTER (Group)",
      "C0010 (Campaign)",
      "C0011 (Campaign)",
      "C0021 (Campaign)",
      "C0026 (Campaign)",
      "Contagious Interview (Group)",
      "CostaRicto (Campaign)",
      "CURIUM (Group)",
      "DarkGate (Malware)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "EXOTIC LILY (Group)",
      "Ferocious Kitten (Group)",
      "FIN7 (Group)",
      "FunnyDream (Campaign)",
      "Gamaredon Group (Group)",
      "HEXANE (Group)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
      "IndigoZebra (Group)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "LazyScripter (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
      "menuPass (Group)",
      "Moonstone Sleet (Group)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "OilRig (Group)",
      "Operation Dream Job (Campaign)",
      "Operation Dust Storm (Campaign)",
      "Operation Ghost (Campaign)",
      "Operation Honeybee (Campaign)",
      "Operation Spalax (Campaign)",
    ],
    "T1547.004": [
      "Bazar (Malware)",
      "Cannon (Malware)",
      "DarkTortilla (Malware)",
      "Dipsind (Malware)",
      "Gazer (Malware)",
      "KeyBoy (Malware)",
      "LockBit 3.0 (Malware)",
      "Qilin (Malware)",
      "Remexi (Malware)",
      "Revenge RAT (Malware)",
      "Tropic Trooper (Group)",
      "Turla (Group)",
      "Wizard Spider (Group)",
    ],
    T1554: [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "APT5 (Group)",
      "BFG Agonizer (Malware)",
      "BOLDMOVE (Malware)",
      "Bonadan (Malware)",
      "BUSHWALK (Malware)",
      "Cutting Edge (Campaign)",
      "Ebury (Malware)",
      "FRAMESTING (Malware)",
      "GlassWorm (Malware)",
      "Industroyer (Malware)",
      "Kessel (Malware)",
      "Kobalos (Malware)",
      "LIGHTWIRE (Malware)",
      "LITTLELAMB.WOOLTEA (Malware)",
      "PHASEJAM (Malware)",
      "RedPenguin (Campaign)",
      "SLOWPULSE (Malware)",
      "ThiefQuest (Malware)",
      "UNC3886 (Group)",
      "WARPWIRE (Malware)",
      "WIREFIRE (Malware)",
      "XCSSET (Malware)",
    ],
    T1518: [
      "Bazar (Malware)",
      "BRONZE BUTLER (Group)",
      "Bundlore (Malware)",
      "CharmPower (Malware)",
      "Cobalt Strike (Malware)",
      "ComRAT (Malware)",
      "Cuckoo Stealer (Malware)",
      "down_new (Malware)",
      "Dridex (Malware)",
      "DustySky (Malware)",
      "Dyre (Malware)",
      "GlassWorm (Malware)",
      "HEXANE (Group)",
      "HotCroissant (Malware)",
      "Inception (Group)",
      "InvisibleFerret (Malware)",
      "InvisiMole (Malware)",
      "IronWind (Malware)",
      "Juicy Mix (Campaign)",
      "KGH_SPY (Malware)",
      "LightSpy (Malware)",
      "LunarWeb (Malware)",
      "MarkiRAT (Malware)",
      "Metamorfo (Malware)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "Operation Dust Storm (Campaign)",
      "Operation Wocao (Campaign)",
      "Orz (Malware)",
      "P.A.S. Webshell (Malware)",
      "PUBLOAD (Malware)",
      "QakBot (Malware)",
      "Raccoon Stealer (Malware)",
      "RedLine Stealer (Malware)",
      "RTM (Malware)",
      "Samurai (Malware)",
      "ShimRatReporter (Tool)",
      "SideCopy (Group)",
      "Sidewinder (Group)",
      "Siloscape (Malware)",
    ],
    T1195: [
      "Ember Bear (Group)",
      "Lumma Stealer (Malware)",
      "OilRig (Group)",
      "Raccoon Stealer (Malware)",
      "Sandworm Team (Group)",
    ],
    T1203: [
      "3CX Supply Chain Attack (Campaign)",
      "admin@338 (Group)",
      "Agent Tesla (Malware)",
      "Andariel (Group)",
      "Aoqin Dragon (Group)",
      "APT12 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT37 (Group)",
      "APT41 (Group)",
      "Axiom (Group)",
      "Bankshot (Malware)",
      "BITTER (Group)",
      "BlackTech (Group)",
      "BRONZE BUTLER (Group)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Confucius (Group)",
      "Darkhotel (Group)",
      "DealersChoice (Malware)",
      "Dragonfly (Group)",
      "Elderwood (Group)",
      "Ember Bear (Group)",
      "EvilBunny (Malware)",
      "EXOTIC LILY (Group)",
      "Frankenstein (Campaign)",
      "HAWKBALL (Malware)",
      "Higaisa (Group)",
      "Inception (Group)",
      "InvisiMole (Malware)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "OilRig (Group)",
      "Operation Dust Storm (Campaign)",
      "Patchwork (Group)",
    ],
    "T1021.001": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agrius (Group)",
      "Akira (Group)",
      "APT1 (Group)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT3 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "Axiom (Group)",
      "BlackByte (Group)",
      "Blue Mockingbird (Group)",
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "C0032 (Campaign)",
      "Carbanak (Malware)",
      "Chimera (Group)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "Cutting Edge (Campaign)",
      "DarkComet (Malware)",
      "Dragonfly (Group)",
      "FIN10 (Group)",
      "FIN13 (Group)",
      "FIN6 (Group)",
      "FIN7 (Group)",
      "FIN8 (Group)",
      "Fox Kitten (Group)",
      "HEXANE (Group)",
      "HomeLand Justice (Campaign)",
      "Imminent Monitor (Tool)",
      "INC Ransom (Group)",
      "Indrik Spider (Group)",
      "jRAT (Malware)",
      "Kimsuky (Group)",
      "Koadic (Tool)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
    ],
    "T1484.001": [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "2025 Poland Wiper Attacks (Campaign)",
      "APT41 (Group)",
      "Cinnamon Tempest (Group)",
      "Egregor (Malware)",
      "Empire (Tool)",
      "HermeticWiper (Malware)",
      "Indrik Spider (Group)",
      "LockBit 2.0 (Malware)",
      "LockBit 3.0 (Malware)",
      "Meteor (Malware)",
      "Prestige (Malware)",
      "Qilin (Malware)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "Storm-0501 (Group)",
      "VOID MANTICORE (Group)",
    ],
    T1566: [
      "AppleJeus (Group)",
      "Axiom (Group)",
      "GOLD SOUTHFIELD (Group)",
      "Hikit (Malware)",
      "INC Ransom (Group)",
      "INC Ransomware (Malware)",
      "Kimsuky (Group)",
      "MuddyWater (Group)",
      "Royal (Malware)",
      "Sea Turtle (Group)",
      "VOID MANTICORE (Group)",
    ],
    "T1608.004": [
      "APT32 (Group)",
      "C0010 (Campaign)",
      "CURIUM (Group)",
      "Dragonfly (Group)",
      "FIN7 (Group)",
      "LuminousMoth (Group)",
      "Mustard Tempest (Group)",
      "Threat Group-3390 (Group)",
      "Transparent Tribe (Group)",
    ],
    "T1574.007": [
      "BRICKSTORM (Malware)",
      "DarkGate (Malware)",
      "Empire (Tool)",
      "PowerSploit (Tool)",
    ],
    "T1222.002": [
      "APT32 (Group)",
      "Black Basta (Malware)",
      "Bundlore (Malware)",
      "COATHANGER (Malware)",
      "Dok (Malware)",
      "DRYHOOK (Malware)",
      "Kinsing (Malware)",
      "KV Botnet Activity (Campaign)",
      "OSX/Shlayer (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "P.A.S. Webshell (Malware)",
      "Penquin (Malware)",
      "Rocke (Group)",
      "TeamTNT (Group)",
      "XCSSET (Malware)",
    ],
    "T1505.003": [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "Agrius (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 DUST (Campaign)",
      "APT5 (Group)",
      "ASPXSpy (Malware)",
      "BackdoorDiplomacy (Group)",
      "BlackByte (Group)",
      "BUSHWALK (Malware)",
      "C0017 (Campaign)",
      "C0032 (Campaign)",
      "China Chopper (Malware)",
      "CURIUM (Group)",
      "Cutting Edge (Campaign)",
      "Deep Panda (Group)",
      "Dragonfly (Group)",
      "Ember Bear (Group)",
      "FIN13 (Group)",
      "Fox Kitten (Group)",
      "FRAMESTING (Malware)",
      "FrostyGoop Incident (Campaign)",
      "GALLIUM (Group)",
      "GLASSTOKEN (Malware)",
      "HAFNIUM (Group)",
      "HomeLand Justice (Campaign)",
      "Kimsuky (Group)",
      "Leviathan (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "LIGHTWIRE (Malware)",
      "Line Runner (Malware)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "Moses Staff (Group)",
      "Mustang Panda (Group)",
      "Neo-reGeorg (Malware)",
      "OilRig (Group)",
    ],
    T1564: [
      "Bundlore (Malware)",
      "DarkTortilla (Malware)",
      "NOOPLDR (Malware)",
      "OSX/Shlayer (Malware)",
      "Remcos (Tool)",
      "Tarrask (Malware)",
      "WarzoneRAT (Malware)",
    ],
    "T1056.002": [
      "Bundlore (Malware)",
      "Calisto (Malware)",
      "Cuckoo Stealer (Malware)",
      "Dok (Malware)",
      "FIN4 (Group)",
      "iKitten (Malware)",
      "Keydnap (Malware)",
      "LP-Notes (Malware)",
      "Metamorfo (Malware)",
      "Mispadu (Malware)",
      "MuddyViper (Malware)",
      "Proton (Malware)",
      "RedCurl (Group)",
      "SILENTTRINITY (Tool)",
      "XCSSET (Malware)",
    ],
    T1657: [
      "Akira (Group)",
      "AppleJeus (Group)",
      "BeaverTail (Malware)",
      "Cinnamon Tempest (Group)",
      "Contagious Interview (Group)",
      "Crocodilus (Malware)",
      "DarkGate (Malware)",
      "Embargo (Malware)",
      "FIN13 (Group)",
      "GlassWorm (Malware)",
      "INC Ransom (Group)",
      "InvisibleFerret (Malware)",
      "Kimsuky (Group)",
      "Malteiro (Group)",
      "Medusa Group (Group)",
      "Play (Group)",
      "RedLine Stealer (Malware)",
      "Scattered Spider (Group)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "SilverTerrier (Group)",
      "Storm-0501 (Group)",
      "VOID MANTICORE (Group)",
      "Water Galura (Group)",
    ],
    "T1588.002": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "Aoqin Dragon (Group)",
      "APT-C-36 (Group)",
      "APT1 (Group)",
      "APT19 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Aquatic Panda (Group)",
      "BackdoorDiplomacy (Group)",
      "BITTER (Group)",
      "BlackTech (Group)",
      "Blue Mockingbird (Group)",
      "BRONZE BUTLER (Group)",
      "C0010 (Campaign)",
      "C0015 (Campaign)",
      "C0017 (Campaign)",
      "C0018 (Campaign)",
      "C0021 (Campaign)",
      "C0027 (Campaign)",
      "C0032 (Campaign)",
      "Carbanak (Group)",
      "Chimera (Group)",
      "Cinnamon Tempest (Group)",
      "Cleaver (Group)",
      "Cobalt Group (Group)",
      "Contagious Interview (Group)",
      "CopyKittens (Group)",
      "CostaRicto (Campaign)",
      "Cutting Edge (Campaign)",
      "DarkHydrus (Group)",
      "DarkVishnya (Group)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "Ferocious Kitten (Group)",
    ],
    T1001: [
      "DarkGate (Malware)",
      "evilginx2 (Tool)",
      "FlawedAmmyy (Malware)",
      "FRAMESTING (Malware)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "Ninja (Malware)",
      "Okrum (Malware)",
      "Operation Wocao (Campaign)",
      "RDAT (Malware)",
      "SideTwist (Malware)",
      "SLOTHFULMEDIA (Malware)",
      "StrelaStealer (Malware)",
      "SystemBC (Malware)",
      "TrailBlazer (Malware)",
    ],
    T1585: [
      "APT17 (Group)",
      "Contagious Interview (Group)",
      "Ember Bear (Group)",
      "Fox Kitten (Group)",
      "Kimsuky (Group)",
      "Salesforce Data Exfiltration (Campaign)",
    ],
    "T1222.001": [
      "BitPaymer (Malware)",
      "BlackByte Ransomware (Malware)",
      "BlackCat (Malware)",
      "CaddyWiper (Malware)",
      "Diskpart (Tool)",
      "Grandoreiro (Malware)",
      "JPIN (Malware)",
      "Ryuk (Malware)",
      "Storm-1811 (Group)",
      "WannaCry (Malware)",
      "WastedLocker (Malware)",
      "Wizard Spider (Group)",
    ],
    T1068: [
      "APT28 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "APT33 (Group)",
      "BITTER (Group)",
      "BlackByte (Group)",
      "BlackByte 2.0 Ransomware (Malware)",
      "Carberp (Malware)",
      "Cobalt Group (Group)",
      "Cobalt Strike (Malware)",
      "CosmicDuke (Malware)",
      "Embargo (Malware)",
      "Empire (Tool)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "HAFNIUM (Group)",
      "Hildegard (Malware)",
      "InvisiMole (Malware)",
      "JHUHUGIT (Malware)",
      "LAPSUS$ (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "MoustachedBouncer (Group)",
      "OilRig (Group)",
      "Pandora (Malware)",
      "PLATINUM (Group)",
      "PoshC2 (Tool)",
      "ProLock (Malware)",
      "Remsec (Malware)",
      "Scattered Spider (Group)",
      "ShadowRay (Campaign)",
      "Siloscape (Malware)",
      "Stuxnet (Malware)",
      "Threat Group-3390 (Group)",
      "Tonto Team (Group)",
      "Turla (Group)",
      "UNC3886 (Group)",
      "Volt Typhoon (Group)",
      "Whitefly (Group)",
      "Wingbird (Malware)",
      "XCSSET (Malware)",
    ],
    "T1685.006": [
      "JumbledPath (Malware)",
      "MacMa (Malware)",
      "Proton (Malware)",
      "Rocke (Group)",
      "Salt Typhoon (Group)",
      "Sea Turtle (Group)",
      "TeamTNT (Group)",
      "UPSTYLE (Malware)",
    ],
    T1202: [
      "Forfiles (Tool)",
      "Lazarus Group (Group)",
      "RedCurl (Group)",
      "Revenge RAT (Malware)",
    ],
    "T1546.011": [
      "FIN7 (Group)",
      "Pillowmint (Malware)",
      "SDBbot (Malware)",
      "ShimRat (Malware)",
    ],
    "T1059.008": [
      "2025 Poland Wiper Attacks (Campaign)",
      "DRYHOOK (Malware)",
      "Line Dancer (Malware)",
      "PHASEJAM (Malware)",
      "RedPenguin (Campaign)",
    ],
    "T1027.003": [
      "ABK (Malware)",
      "Andariel (Group)",
      "APT-C-36 (Group)",
      "APT37 (Group)",
      "Avenger (Malware)",
      "Bandook (Malware)",
      "BBK (Malware)",
      "BRONZE BUTLER (Group)",
      "build_downer (Malware)",
      "Diavol (Malware)",
      "Earth Lusca (Group)",
      "IcedID (Malware)",
      "Invoke-PSImage (Tool)",
      "Leviathan (Group)",
      "LiteDuke (Malware)",
      "MuddyWater (Group)",
      "ObliqueRAT (Malware)",
      "Okrum (Malware)",
      "Operation Ghost (Campaign)",
      "Operation Spalax (Campaign)",
      "Pikabot (Malware)",
      "PolyglotDuke (Malware)",
      "PowerDuke (Malware)",
      "ProLock (Malware)",
      "Raindrop (Malware)",
      "Ramsay (Malware)",
      "RDAT (Malware)",
      "RegDuke (Malware)",
      "TA551 (Group)",
      "Tropic Trooper (Group)",
    ],
    "T1583.003": [
      "APT-C-36 (Group)",
      "APT28 (Group)",
      "APT42 (Group)",
      "ArcaneDoor (Campaign)",
      "Axiom (Group)",
      "BlackByte (Group)",
      "C0032 (Campaign)",
      "Contagious Interview (Group)",
      "CURIUM (Group)",
      "Dragonfly (Group)",
      "Ember Bear (Group)",
      "FLORAHOX Activity (Campaign)",
      "Gamaredon Group (Group)",
      "HAFNIUM (Group)",
      "J-magic Campaign (Campaign)",
      "KV Botnet Activity (Campaign)",
      "LAPSUS$ (Group)",
      "Moonstone Sleet (Group)",
      "Sea Turtle (Group)",
      "SPACEHOP Activity (Campaign)",
      "VOID MANTICORE (Group)",
      "Winter Vivern (Group)",
    ],
    T1613: ["Hildegard (Malware)", "Peirates (Tool)", "TeamTNT (Group)"],
    "T1480.001": [
      "APT41 (Group)",
      "Equation (Group)",
      "InvisiMole (Malware)",
      "Ninja (Malware)",
      "Pikabot (Malware)",
      "PowerPunch (Malware)",
      "PUBLOAD (Malware)",
      "ROKRAT (Malware)",
      "TONESHELL (Malware)",
      "Winnti for Windows (Malware)",
    ],
    T1134: [
      "AppleSeed (Malware)",
      "BlackCat (Malware)",
      "Blue Mockingbird (Group)",
      "C0017 (Campaign)",
      "Cuba (Malware)",
      "Duqu (Malware)",
      "Empire (Tool)",
      "FIN6 (Group)",
      "Gelsemium (Malware)",
      "HermeticWiper (Malware)",
      "Hydraq (Malware)",
      "KillDisk (Malware)",
      "Lotus Blossom (Group)",
      "Mafalda (Malware)",
      "MegaCortex (Malware)",
      "PoshC2 (Tool)",
      "PowerSploit (Tool)",
      "Qilin (Malware)",
      "Ryuk (Malware)",
      "Sagerunex (Malware)",
      "Sliver (Tool)",
      "SslMM (Malware)",
      "SUNSPOT (Malware)",
    ],
    "T1071.002": [
      "APT41 (Group)",
      "Attor (Malware)",
      "BADHATCH (Malware)",
      "CARROTBALL (Tool)",
      "Cobalt Strike (Malware)",
      "Disco (Malware)",
      "Dragonfly (Group)",
      "Havoc (Malware)",
      "JPIN (Malware)",
      "Kazuar (Malware)",
      "Kimsuky (Group)",
      "Machete (Malware)",
      "MirrorFace (Group)",
      "Mythic (Tool)",
      "NOKKI (Malware)",
      "Operation Honeybee (Campaign)",
      "PoetRAT (Malware)",
      "PUBLOAD (Malware)",
      "Qilin (Malware)",
      "Quad7 Activity (Campaign)",
      "Regin (Malware)",
      "ShadowPad (Malware)",
      "SharpDisco (Malware)",
      "SilverTerrier (Group)",
      "SYSCON (Malware)",
      "XAgentOSX (Malware)",
      "ZxShell (Malware)",
    ],
    T1584: [
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
    ],
    T1573: [
      "APT29 (Group)",
      "BITTER (Group)",
      "Chaes (Malware)",
      "Cryptoistic (Malware)",
      "Emotet (Malware)",
      "gh0st RAT (Malware)",
      "Gomir (Malware)",
      "KV Botnet Activity (Campaign)",
      "Lizar (Malware)",
      "MacMa (Malware)",
      "Magic Hound (Group)",
      "NETWIRE (Malware)",
      "PowerLess (Malware)",
      "PowGoop (Malware)",
      "RCSession (Malware)",
      "Triton Safety Instrumented System Attack (Campaign)",
      "Tropic Trooper (Group)",
    ],
    "T1027.001": [
      "Akira (Group)",
      "APT29 (Group)",
      "Bisonal (Malware)",
      "Black Basta (Malware)",
      "BRONZE BUTLER (Group)",
      "Caminho (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Comnie (Malware)",
      "CostaBricks (Malware)",
      "Emissary (Malware)",
      "Emotet (Malware)",
      "Goopy (Malware)",
      "Grandoreiro (Malware)",
      "GrimAgent (Malware)",
      "HeartCrypt (Malware)",
      "Higaisa (Group)",
      "Javali (Malware)",
      "Kimsuky (Group)",
      "Kwampirs (Malware)",
      "Latrodectus (Malware)",
      "Leviathan (Group)",
      "LightSpy (Malware)",
      "Moafee (Group)",
      "Patchwork (Group)",
      "PlugX (Malware)",
      "QakBot (Malware)",
      "Rifdoor (Malware)",
      "Snip3 (Malware)",
      "TAINTEDSCRIBE (Malware)",
      "TONESHELL (Malware)",
    ],
    "T1048.003": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Agent Tesla (Malware)",
      "APT32 (Group)",
      "APT33 (Group)",
      "BITSAdmin (Tool)",
      "Brave Prince (Malware)",
      "C0017 (Campaign)",
      "Carbon (Malware)",
      "ccf32 (Malware)",
      "CharmPower (Malware)",
      "Cherry Picker (Malware)",
      "Contagious Interview (Group)",
      "CookieMiner (Malware)",
      "CORALDECK (Malware)",
      "CosmicDuke (Malware)",
      "Dok (Malware)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "ftp (Tool)",
      "InvisibleFerret (Malware)",
      "Kessel (Malware)",
      "KONNI (Malware)",
      "Lazarus Group (Group)",
      "Mustang Panda (Group)",
      "OilRig (Group)",
      "PoetRAT (Malware)",
      "PUBLOAD (Malware)",
      "Rclone (Tool)",
      "Remsec (Malware)",
      "Salt Typhoon (Group)",
      "SocGholish (Malware)",
      "Thrip (Group)",
      "WARPWIRE (Malware)",
      "WindTail (Malware)",
      "Wizard Spider (Group)",
    ],
    "T1059.011": [
      "EvilBunny (Malware)",
      "Line Runner (Malware)",
      "PoetRAT (Malware)",
      "RedLine Stealer (Malware)",
      "Remsec (Malware)",
    ],
    "T1556.009": ["Scattered Spider (Group)", "Storm-0501 (Group)"],
    "T1078.001": [
      "Ember Bear (Group)",
      "FIN13 (Group)",
      "HomeLand Justice (Campaign)",
      "HyperStack (Malware)",
      "Magic Hound (Group)",
      "Stuxnet (Malware)",
      "UNC3886 (Group)",
    ],
    "T1591.004": [
      "FIN7 (Group)",
      "HEXANE (Group)",
      "LAPSUS$ (Group)",
      "Operation Dream Job (Campaign)",
      "Volt Typhoon (Group)",
    ],
    "T1134.001": [
      "APT28 (Group)",
      "Aria-body (Malware)",
      "BADHATCH (Malware)",
      "BitPaymer (Malware)",
      "Cobalt Strike (Malware)",
      "Emotet (Malware)",
      "FIN8 (Group)",
      "FinFisher (Malware)",
      "Fooder (Malware)",
      "Havoc (Malware)",
      "HomeLand Justice (Campaign)",
      "LP-Notes (Malware)",
      "Okrum (Malware)",
      "Pupy (Tool)",
      "REvil (Malware)",
      "Shamoon (Malware)",
      "SILENTTRINITY (Tool)",
      "Siloscape (Malware)",
      "Stuxnet (Malware)",
      "Tarrask (Malware)",
    ],
    "T1001.003": [
      "BADCALL (Malware)",
      "Bankshot (Malware)",
      "BOOKWORM (Malware)",
      "C0017 (Campaign)",
      "Cobalt Strike (Malware)",
      "FakeM (Malware)",
      "FALLCHILL (Malware)",
      "FRAMESTING (Malware)",
      "HARDRAIN (Malware)",
      "Higaisa (Group)",
      "InvisiMole (Malware)",
      "KeyBoy (Malware)",
      "Lazarus Group (Group)",
      "Mustang Panda (Group)",
      "Ninja (Malware)",
      "Okrum (Malware)",
      "PUBLOAD (Malware)",
      "StarProxy (Malware)",
      "SUNBURST (Malware)",
      "TAINTEDSCRIBE (Malware)",
      "TONESHELL (Malware)",
      "Uroburos (Malware)",
    ],
    "T1071.003": [
      "Agent Tesla (Malware)",
      "APT28 (Group)",
      "APT32 (Group)",
      "BadPatch (Malware)",
      "Cannon (Malware)",
      "CHOPSTICK (Malware)",
      "ComRAT (Malware)",
      "Contagious Interview (Group)",
      "CORESHELL (Malware)",
      "Goopy (Malware)",
      "IMAPLoader (Malware)",
      "JPIN (Malware)",
      "Kimsuky (Group)",
      "LightNeuron (Malware)",
      "LunarMail (Malware)",
      "NavRAT (Malware)",
      "NightClub (Malware)",
      "OLDBAIT (Malware)",
      "PowerExchange (Malware)",
      "RDAT (Malware)",
      "Remsec (Malware)",
      "SilverTerrier (Group)",
      "SUGARDUMP (Malware)",
      "Turla (Group)",
      "Uroburos (Malware)",
      "Zebrocy (Malware)",
    ],
    T1119: [
      "Agrius (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "AppleSeed (Malware)",
      "APT1 (Group)",
      "APT28 (Group)",
      "APT41 DUST (Campaign)",
      "ArcaneDoor (Campaign)",
      "Attor (Malware)",
      "BADNEWS (Malware)",
      "Bankshot (Malware)",
      "ccf32 (Malware)",
      "Chimera (Group)",
      "Comnie (Malware)",
      "Confucius (Group)",
      "Crutch (Malware)",
      "DarkGate (Malware)",
      "Ember Bear (Group)",
      "Empire (Tool)",
      "FIN5 (Group)",
      "FIN6 (Group)",
      "Frankenstein (Campaign)",
      "FunnyDream (Malware)",
      "Gamaredon Group (Group)",
      "GoldFinder (Malware)",
      "HAFNIUM (Group)",
      "Helminth (Malware)",
      "InvisiMole (Malware)",
      "Ke3chang (Group)",
      "LAMEHUG (Malware)",
      "LightNeuron (Malware)",
      "LoFiSe (Malware)",
      "Lumma Stealer (Malware)",
      "menuPass (Group)",
      "MESSAGETAP (Malware)",
      "Metamorfo (Malware)",
      "Micropsia (Malware)",
      "Mustang Panda (Group)",
      "Mythic (Tool)",
      "NETWIRE (Malware)",
      "NPPSPY (Tool)",
    ],
    "T1132.001": [
      "ADVSTORESHELL (Malware)",
      "APT19 (Group)",
      "APT33 (Group)",
      "APT42 (Group)",
      "Astaroth (Malware)",
      "AutoIt backdoor (Malware)",
      "BabyShark (Malware)",
      "Backdoor.Oldrea (Malware)",
      "BADNEWS (Malware)",
      "Bisonal (Malware)",
      "BLINDINGCAN (Malware)",
      "BRICKSTORM (Malware)",
      "BRONZE BUTLER (Group)",
      "BS2005 (Malware)",
      "Bumblebee (Malware)",
      "Carbanak (Malware)",
      "Chaes (Malware)",
      "CharmPower (Malware)",
      "ChChes (Malware)",
      "Cobalt Strike (Malware)",
      "Cobian RAT (Malware)",
      "CORESHELL (Malware)",
      "CreepySnail (Malware)",
      "DarkWatchman (Malware)",
      "Daserf (Malware)",
      "Denis (Malware)",
      "Dipsind (Malware)",
      "DnsSystem (Malware)",
      "down_new (Malware)",
      "Ebury (Malware)",
      "Elise (Malware)",
      "Emotet (Malware)",
      "Felismus (Malware)",
      "Flagpro (Malware)",
      "Fysbis (Malware)",
      "gh0st RAT (Malware)",
      "GLASSTOKEN (Malware)",
      "Gomir (Malware)",
      "Gootloader (Malware)",
      "GrimAgent (Malware)",
    ],
    "T1556.003": ["Ebury (Malware)", "Skidmap (Malware)"],
    "T1561.001": [
      "AcidPour (Malware)",
      "AcidRain (Malware)",
      "Apostle (Malware)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "BlackCat (Malware)",
      "cipher.exe (Tool)",
      "DarkGate (Malware)",
      "DEADWOOD (Malware)",
      "Gamaredon Group (Group)",
      "HermeticWiper (Malware)",
      "Lazarus Group (Group)",
      "MegaCortex (Malware)",
      "RawDisk (Tool)",
      "StoneDrill (Malware)",
      "VOID MANTICORE (Group)",
      "VPNFilter (Malware)",
      "WhisperGate (Malware)",
    ],
    T1596: ["APT28 (Group)", "Kimsuky (Group)"],
    "T1027.002": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Anchor (Malware)",
      "Aoqin Dragon (Group)",
      "AppleSeed (Malware)",
      "APT29 (Group)",
      "APT3 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Astaroth (Malware)",
      "Babuk (Malware)",
      "Bazar (Malware)",
      "Bisonal (Malware)",
      "BLINDINGCAN (Malware)",
      "C0017 (Campaign)",
      "China Chopper (Malware)",
      "Clop (Malware)",
      "COATHANGER (Malware)",
      "CostaBricks (Malware)",
      "CSPY Downloader (Tool)",
      "Cuba (Malware)",
      "Dark Caracal (Group)",
      "DarkComet (Malware)",
      "Daserf (Malware)",
      "Dok (Malware)",
      "Donut (Tool)",
      "DRATzarus (Malware)",
      "Dyre (Malware)",
      "Egregor (Malware)",
      "Elderwood (Group)",
      "Emotet (Malware)",
      "FatDuke (Malware)",
      "FinFisher (Malware)",
      "FYAnti (Malware)",
      "GALLIUM (Group)",
      "GoldMax (Malware)",
      "GreyEnergy (Malware)",
      "H1N1 (Malware)",
      "HeartCrypt (Malware)",
      "Hildegard (Malware)",
    ],
    "T1027.016": [
      "ANELLDR (Malware)",
      "APT-C-36 (Group)",
      "APT32 (Group)",
      "CORESHELL (Malware)",
      "FatDuke (Malware)",
      "FIN7 (Group)",
      "FinFisher (Malware)",
      "Gamaredon Group (Group)",
      "Gelsemium (Malware)",
      "Goopy (Malware)",
      "Kimsuky (Group)",
      "LODEINFO (Malware)",
      "Maze (Malware)",
      "Mustang Panda (Group)",
      "NOOPLDR (Malware)",
      "Pony (Malware)",
      "POWERSTATS (Malware)",
      "PureCrypter (Malware)",
      "SamSam (Malware)",
      "StrelaStealer (Malware)",
      "WastedLocker (Malware)",
      "XTunnel (Malware)",
      "yty (Malware)",
      "ZeroT (Malware)",
    ],
    "T1087.001": [
      "admin@338 (Group)",
      "Agent Tesla (Malware)",
      "APT1 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT41 (Group)",
      "APT42 (Group)",
      "Bankshot (Malware)",
      "Bazar (Malware)",
      "BitPaymer (Malware)",
      "BloodHound (Tool)",
      "Chimera (Group)",
      "Comnie (Malware)",
      "Duqu (Malware)",
      "DUSTTRAP (Malware)",
      "Elise (Malware)",
      "Empire (Tool)",
      "Epic (Malware)",
      "Fox Kitten (Group)",
      "GeminiDuke (Malware)",
      "HyperStack (Malware)",
      "InvisibleFerret (Malware)",
      "InvisiMole (Malware)",
      "Kazuar (Malware)",
      "Ke3chang (Group)",
      "Kwampirs (Malware)",
      "Lotus Blossom (Group)",
      "Medusa Group (Group)",
      "MgBot (Malware)",
      "Milan (Malware)",
      "Mis-Type (Malware)",
      "Moses Staff (Group)",
      "MURKYTOP (Malware)",
      "Net (Tool)",
      "OilRig (Group)",
      "Operation CuckooBees (Campaign)",
      "Operation Digital Eye (Campaign)",
      "OSInfo (Malware)",
      "P.A.S. Webshell (Malware)",
      "Pikabot (Malware)",
    ],
    "T1218.003": [
      "CHIMNEYSWEEP (Malware)",
      "Cobalt Group (Group)",
      "LockBit 3.0 (Malware)",
      "MuddyWater (Group)",
    ],
    "T1036.001": [
      "APT37 (Group)",
      "BADNEWS (Malware)",
      "Gelsemium (Malware)",
      "NETWIRE (Malware)",
      "PcShare (Tool)",
      "Regin (Malware)",
      "SplatCloak (Malware)",
      "Windshift (Group)",
      "WindTail (Malware)",
    ],
    T1048: [
      "AADInternals (Tool)",
      "Bundlore (Malware)",
      "Chaes (Malware)",
      "FrameworkPOS (Malware)",
      "Hydraq (Malware)",
      "Kobalos (Malware)",
      "Play (Group)",
      "PoetRAT (Malware)",
      "TeamTNT (Group)",
    ],
    T1621: [
      "APT29 (Group)",
      "C0027 (Campaign)",
      "LAPSUS$ (Group)",
      "Scattered Spider (Group)",
    ],
    T1482: [
      "AdFind (Tool)",
      "Akira (Group)",
      "BADHATCH (Malware)",
      "Bazar (Malware)",
      "BlackByte (Group)",
      "BloodHound (Tool)",
      "Brute Ratel C4 (Tool)",
      "C0015 (Campaign)",
      "Chimera (Group)",
      "dsquery (Tool)",
      "DUSTTRAP (Malware)",
      "Earth Lusca (Group)",
      "Empire (Tool)",
      "FIN8 (Group)",
      "IcedID (Malware)",
      "LAMEHUG (Malware)",
      "Latrodectus (Malware)",
      "Leviathan Australian Intrusions (Campaign)",
      "Lotus Blossom (Group)",
      "Magic Hound (Group)",
      "MgBot (Malware)",
      "MirrorFace (Group)",
      "Nltest (Tool)",
      "Pikabot (Malware)",
      "PoshC2 (Tool)",
      "PowerSploit (Tool)",
      "QakBot (Malware)",
      "Rubeus (Tool)",
      "SocGholish (Malware)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
      "Storm-1811 (Group)",
      "TrickBot (Malware)",
    ],
    "T1480.002": [
      "APT38 (Group)",
      "Black Basta (Malware)",
      "BPFDoor (Malware)",
      "CLAIMLOADER (Malware)",
      "Embargo (Malware)",
      "Gazer (Malware)",
      "GrimAgent (Malware)",
      "HiddenFace (Malware)",
      "Kimsuky (Group)",
      "LockBit 3.0 (Malware)",
      "PlugX (Malware)",
      "PoisonIvy (Malware)",
      "PureCrypter (Malware)",
      "Qilin (Malware)",
      "REvil (Malware)",
      "SPAWNCHIMERA (Malware)",
      "StrelaStealer (Malware)",
      "SUNSPOT (Malware)",
      "TONESHELL (Malware)",
      "Troll Stealer (Malware)",
    ],
    "T1565.002": [
      "APT38 (Group)",
      "GlassWorm (Malware)",
      "LightNeuron (Malware)",
      "Melcoz (Malware)",
      "Metamorfo (Malware)",
    ],
    T1049: [
      "2025 Poland Wiper Attacks (Campaign)",
      "admin@338 (Group)",
      "Andariel (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT1 (Group)",
      "APT3 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "Aria-body (Malware)",
      "Babuk (Malware)",
      "BackdoorDiplomacy (Group)",
      "BADHATCH (Malware)",
      "BlackEnergy (Malware)",
      "Carbon (Malware)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "Comnie (Malware)",
      "Conti (Malware)",
      "CrackMapExec (Tool)",
      "Cuba (Malware)",
      "Dtrack (Malware)",
      "Duqu (Malware)",
      "Earth Lusca (Group)",
      "Egregor (Malware)",
      "Empire (Tool)",
      "Epic (Malware)",
      "FIN13 (Group)",
      "Flagpro (Malware)",
      "FRP (Tool)",
      "FunnyDream (Campaign)",
      "GALLIUM (Group)",
      "GravityRAT (Malware)",
      "HEXANE (Group)",
      "INC Ransom (Group)",
      "jRAT (Malware)",
      "Ke3chang (Group)",
      "KONNI (Malware)",
      "KOPILUWAK (Malware)",
    ],
    "T1090.001": [
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "APT39 (Group)",
      "BACKSPACE (Malware)",
      "BRICKSTORM (Malware)",
      "CHOPSTICK (Malware)",
      "Cobalt Strike (Malware)",
      "Drovorub (Malware)",
      "Duqu (Malware)",
      "FatDuke (Malware)",
      "FIN13 (Group)",
      "GlassWorm (Malware)",
      "Gomir (Malware)",
      "HiddenFace (Malware)",
      "Higaisa (Group)",
      "Hikit (Malware)",
      "InvisiMole (Malware)",
      "Kazuar (Malware)",
      "Lazarus Group (Group)",
      "Lotus Blossom (Group)",
      "Mafalda (Malware)",
      "metaMain (Malware)",
      "MiniDuke (Malware)",
      "Mythic (Tool)",
      "Ninja (Malware)",
      "Operation Wocao (Campaign)",
      "Pay2Key (Malware)",
      "Sliver (Tool)",
      "SolarWinds Compromise (Campaign)",
      "StarProxy (Malware)",
      "Strider (Group)",
      "Stuxnet (Malware)",
      "Turla (Group)",
      "Velvet Ant (Group)",
      "Volt Typhoon (Group)",
      "Winnti for Windows (Malware)",
    ],
    T1008: [
      "Anchor (Malware)",
      "AppleSeed (Malware)",
      "APT41 (Group)",
      "Bazar (Malware)",
      "BISCUIT (Malware)",
      "BlackEnergy (Malware)",
      "Bumblebee (Malware)",
      "Cardinal RAT (Malware)",
      "CharmPower (Malware)",
      "CHOPSTICK (Malware)",
      "Crutch (Malware)",
      "Derusbi (Malware)",
      "DustySky (Malware)",
      "Ebury (Malware)",
      "Exaramel for Linux (Malware)",
      "FatDuke (Malware)",
      "FIN7 (Group)",
      "Gelsemium (Malware)",
      "GlassWorm (Malware)",
      "HiddenFace (Malware)",
      "HOPLIGHT (Malware)",
      "InvisiMole (Malware)",
      "JHUHUGIT (Malware)",
      "Kazuar (Malware)",
      "Kevin (Malware)",
      "Kwampirs (Malware)",
      "Lazarus Group (Group)",
      "Linfo (Malware)",
      "Machete (Malware)",
      "MiniDuke (Malware)",
      "Mis-Type (Malware)",
      "Mythic (Tool)",
      "NETEAGLE (Malware)",
      "Night Dragon (Campaign)",
      "OilBooster (Malware)",
      "OilRig (Group)",
      "PipeMon (Malware)",
      "QUADAGENT (Malware)",
      "QUIETEXIT (Malware)",
      "RainyDay (Malware)",
    ],
    "T1070.006": [
      "3PARA RAT (Malware)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "APT5 (Group)",
      "Attor (Malware)",
      "Bankshot (Malware)",
      "BitPaymer (Malware)",
      "BlackByte 2.0 Ransomware (Malware)",
      "BLINDINGCAN (Malware)",
      "BOOKWORM (Malware)",
      "BPFDoor (Malware)",
      "C0032 (Campaign)",
      "Chimera (Group)",
      "CHIMNEYSWEEP (Malware)",
      "China Chopper (Malware)",
      "Cobalt Strike (Malware)",
      "Cutting Edge (Campaign)",
      "Cyclops Blink (Malware)",
      "Derusbi (Malware)",
      "Elise (Malware)",
      "Empire (Tool)",
      "EVILNUM (Malware)",
      "FALLCHILL (Malware)",
      "Gazer (Malware)",
      "Gelsemium (Malware)",
      "HiddenFace (Malware)",
      "InvisiMole (Malware)",
      "KeyBoy (Malware)",
      "Kimsuky (Group)",
      "Kobalos (Malware)",
      "Lazarus Group (Group)",
      "MacMa (Malware)",
      "metaMain (Malware)",
      "Misdat (Malware)",
      "MultiLayer Wiper (Malware)",
      "Mustang Panda (Group)",
      "NightClub (Malware)",
      "Ninja (Malware)",
    ],
    T1029: [
      "ADVSTORESHELL (Malware)",
      "Chrommme (Malware)",
      "Cobalt Strike (Malware)",
      "ComRAT (Malware)",
      "Dipsind (Malware)",
      "Flagpro (Malware)",
      "Higaisa (Group)",
      "jRAT (Malware)",
      "Kazuar (Malware)",
      "LightNeuron (Malware)",
      "Linfo (Malware)",
      "Machete (Malware)",
      "Ninja (Malware)",
      "POWERSTATS (Malware)",
      "ShadowPad (Malware)",
      "Shark (Malware)",
      "ShimRat (Malware)",
      "TinyTurla (Malware)",
    ],
    "T1213.001": ["LAPSUS$ (Group)", "TruffleHog (Tool)"],
    "T1584.004": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT16 (Group)",
      "Daggerfly (Group)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "Indrik Spider (Group)",
      "Juicy Mix (Campaign)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Night Dragon (Campaign)",
      "Operation Dream Job (Campaign)",
      "Operation Sharpshooter (Campaign)",
      "Outer Space (Campaign)",
      "Sandworm Team (Group)",
      "Turla (Group)",
      "Volt Typhoon (Group)",
    ],
    T1010: [
      "Aria-body (Malware)",
      "Attor (Malware)",
      "Cadelspy (Malware)",
      "Catchamas (Malware)",
      "DarkGate (Malware)",
      "DarkWatchman (Malware)",
      "Duqu (Malware)",
      "DUSTTRAP (Malware)",
      "Flagpro (Malware)",
      "FunnyDream (Malware)",
      "Grandoreiro (Malware)",
      "HEXANE (Group)",
      "HotCroissant (Malware)",
      "InvisiMole (Malware)",
      "Kazuar (Malware)",
      "Lazarus Group (Group)",
      "Machete (Malware)",
      "Metamorfo (Malware)",
      "NetTraveler (Malware)",
      "NETWIRE (Malware)",
      "NightClub (Malware)",
      "njRAT (Malware)",
      "PAKLOG (Malware)",
      "PLEAD (Malware)",
      "PoisonIvy (Malware)",
      "PowerDuke (Malware)",
      "QakBot (Malware)",
      "QuasarRAT (Tool)",
      "Remcos (Tool)",
      "Remexi (Malware)",
      "ROKRAT (Malware)",
      "SILENTTRINITY (Tool)",
      "SOUNDBITE (Malware)",
      "TONESHELL (Malware)",
      "Trojan.Karagany (Malware)",
      "Volt Typhoon (Group)",
      "WINERACK (Malware)",
    ],
    "T1546.016": [
      "3CX Supply Chain Attack (Campaign)",
      "AppleJeus (Malware)",
      "Shai-Hulud (Malware)",
    ],
    T1020: [
      "ArcaneDoor (Campaign)",
      "Attor (Malware)",
      "CosmicDuke (Malware)",
      "Crutch (Malware)",
      "Doki (Malware)",
      "Ebury (Malware)",
      "Empire (Tool)",
      "Frankenstein (Campaign)",
      "Gamaredon Group (Group)",
      "Hannotog (Malware)",
      "Ke3chang (Group)",
      "Kimsuky (Group)",
      "LightNeuron (Malware)",
      "Machete (Malware)",
      "OutSteel (Malware)",
      "Peppy (Malware)",
      "Raccoon Stealer (Malware)",
      "RedCurl (Group)",
      "Rover (Malware)",
      "Salesforce Data Exfiltration (Campaign)",
      "ShimRatReporter (Tool)",
      "Sidewinder (Group)",
      "Solar (Malware)",
      "StrelaStealer (Malware)",
      "StrongPity (Malware)",
      "TajMahal (Malware)",
      "TINYTYPHON (Malware)",
      "Tropic Trooper (Group)",
      "USBStealer (Malware)",
      "Winter Vivern (Group)",
    ],
    "T1574.012": ["Blue Mockingbird (Group)", "DarkTortilla (Malware)"],
    "T1219.002": [
      "C0015 (Campaign)",
      "C0018 (Campaign)",
      "C0027 (Campaign)",
      "Contagious Interview (Group)",
      "Evilnum (Group)",
      "Kimsuky (Group)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "Qilin (Malware)",
      "RTM (Group)",
      "Scattered Spider (Group)",
      "Storm-0501 (Group)",
      "Storm-1811 (Group)",
      "Thrip (Group)",
      "VOID MANTICORE (Group)",
    ],
    "T1564.002": [
      "Dragonfly (Group)",
      "Kimsuky (Group)",
      "SMOKEDHAM (Malware)",
    ],
    "T1218.005": [
      "APT29 (Group)",
      "APT32 (Group)",
      "APT38 (Group)",
      "BabyShark (Malware)",
      "C0015 (Campaign)",
      "Confucius (Group)",
      "Covenant (Tool)",
      "Earth Lusca (Group)",
      "FIN7 (Group)",
      "Gamaredon Group (Group)",
      "Inception (Group)",
      "Kimsuky (Group)",
      "Koadic (Tool)",
      "Lazarus Group (Group)",
      "LazyScripter (Group)",
      "Lumma Stealer (Malware)",
      "Metamorfo (Malware)",
      "MuddyWater (Group)",
      "Mustang Panda (Group)",
      "NanHaiShu (Malware)",
      "Operation Dust Storm (Campaign)",
      "POWERSTATS (Malware)",
      "Pteranodon (Malware)",
      "Revenge RAT (Malware)",
      "Sibot (Malware)",
      "SideCopy (Group)",
      "Sidewinder (Group)",
      "TA2541 (Group)",
      "TA551 (Group)",
      "Xbash (Malware)",
    ],
    "T1563.001": ["MEDUSA (Malware)"],
    "T1552.006": [
      "APT33 (Group)",
      "MirrorStealer (Malware)",
      "PowerSploit (Tool)",
      "SILENTTRINITY (Tool)",
      "Wizard Spider (Group)",
    ],
    T1665: [
      "APT29 (Group)",
      "DarkGate (Malware)",
      "JumbledPath (Malware)",
      "Operation Digital Eye (Campaign)",
      "Quad7 Activity (Campaign)",
      "SolarWinds Compromise (Campaign)",
      "UPSTYLE (Malware)",
      "ZIRCONIUM (Group)",
    ],
    "T1021.006": [
      "Brute Ratel C4 (Tool)",
      "Chimera (Group)",
      "Cobalt Strike (Malware)",
      "FIN13 (Group)",
      "Operation MidnightEclipse (Campaign)",
      "SILENTTRINITY (Tool)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
      "Threat Group-3390 (Group)",
      "Wizard Spider (Group)",
    ],
    T1217: [
      "3CX Supply Chain Attack (Campaign)",
      "APT38 (Group)",
      "BeaverTail (Malware)",
      "Calisto (Malware)",
      "Chimera (Group)",
      "Cuckoo Stealer (Malware)",
      "DarkWatchman (Malware)",
      "Dtrack (Malware)",
      "Empire (Tool)",
      "Fox Kitten (Group)",
      "GlassWorm (Malware)",
      "Juicy Mix (Campaign)",
      "Kimsuky (Group)",
      "LightSpy (Malware)",
      "Lizar (Malware)",
      "Lumma Stealer (Malware)",
      "Machete (Malware)",
      "Mafalda (Malware)",
      "Mispadu (Malware)",
      "MobileOrder (Malware)",
      "Moonstone Sleet (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Outer Space (Campaign)",
      "PowerLess (Malware)",
      "RedLine Stealer (Malware)",
      "Scattered Spider (Group)",
      "SUGARDUMP (Malware)",
      "Troll Stealer (Malware)",
      "Volt Typhoon (Group)",
    ],
    T1197: [
      "APT39 (Group)",
      "APT41 (Group)",
      "Bazar (Malware)",
      "BITSAdmin (Tool)",
      "Cobalt Strike (Malware)",
      "Egregor (Malware)",
      "JPIN (Malware)",
      "Leviathan (Group)",
      "MarkiRAT (Malware)",
      "Patchwork (Group)",
      "ProLock (Malware)",
      "UBoatRAT (Malware)",
      "Wizard Spider (Group)",
    ],
    "T1204.005": ["Contagious Interview (Group)"],
    T1610: [
      "Doki (Malware)",
      "Kinsing (Malware)",
      "Peirates (Tool)",
      "TeamTNT (Group)",
    ],
    T1580: [
      "Pacu (Tool)",
      "Scattered Spider (Group)",
      "Storm-0501 (Group)",
      "TruffleHog (Tool)",
    ],
    "T1595.002": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT28 (Group)",
      "APT29 (Group)",
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "Cutting Edge (Campaign)",
      "Dragonfly (Group)",
      "Earth Lusca (Group)",
      "Ember Bear (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
      "Sandworm Team (Group)",
      "SharePoint ToolShell Exploitation (Campaign)",
      "TeamTNT (Group)",
      "VOID MANTICORE (Group)",
      "Volatile Cedar (Group)",
      "Winter Vivern (Group)",
    ],
    "T1598.003": [
      "AADInternals (Tool)",
      "APT28 (Group)",
      "APT32 (Group)",
      "CURIUM (Group)",
      "Dragonfly (Group)",
      "evilginx2 (Tool)",
      "Kimsuky (Group)",
      "Magic Hound (Group)",
      "Moonstone Sleet (Group)",
      "Mustang Panda (Group)",
      "Patchwork (Group)",
      "Sandworm Team (Group)",
      "Scattered Spider (Group)",
      "Sidewinder (Group)",
      "Silent Librarian (Group)",
      "SMOKEDHAM (Malware)",
      "Star Blizzard (Group)",
      "ZIRCONIUM (Group)",
    ],
    T1534: [
      "APT-C-36 (Group)",
      "Gamaredon Group (Group)",
      "HEXANE (Group)",
      "Kimsuky (Group)",
      "Leviathan (Group)",
      "MuddyWater (Group)",
      "Operation Dream Job (Campaign)",
      "SameCoin (Malware)",
    ],
    "T1561.002": [
      "APT37 (Group)",
      "APT38 (Group)",
      "BFG Agonizer (Malware)",
      "CaddyWiper (Malware)",
      "DEADWOOD (Malware)",
      "Diskpart (Tool)",
      "Ember Bear (Group)",
      "HermeticWiper (Malware)",
      "HomeLand Justice (Campaign)",
      "KillDisk (Malware)",
      "Lazarus Group (Group)",
      "MultiLayer Wiper (Malware)",
      "RawDisk (Tool)",
      "Sandworm Team (Group)",
      "Shamoon (Malware)",
      "ShrinkLocker (Malware)",
      "StoneDrill (Malware)",
      "VOID MANTICORE (Group)",
      "WhisperGate (Malware)",
      "ZeroCleare (Malware)",
    ],
    "T1036.012": ["FatDuke (Malware)"],
    "T1195.002": [
      "3CX Supply Chain Attack (Campaign)",
      "APT41 (Group)",
      "CCBkdr (Malware)",
      "Cobalt Group (Group)",
      "Daggerfly (Group)",
      "Dragonfly (Group)",
      "FIN7 (Group)",
      "GOLD SOUTHFIELD (Group)",
      "GoldenSpy (Malware)",
      "Moonstone Sleet (Group)",
      "Sandworm Team (Group)",
      "SolarWinds Compromise (Campaign)",
      "SUNSPOT (Malware)",
      "Threat Group-3390 (Group)",
    ],
    "T1016.002": [
      "Agent Tesla (Malware)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "CharmPower (Malware)",
      "Emotet (Malware)",
      "Machete (Malware)",
      "Magic Hound (Group)",
      "PUBLOAD (Malware)",
    ],
    "T1608.005": [
      "FIN7 (Group)",
      "LuminousMoth (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Salesforce Data Exfiltration (Campaign)",
      "Silent Librarian (Group)",
    ],
    "T1056.003": [
      "Cutting Edge (Campaign)",
      "IceApple (Malware)",
      "Kimsuky (Group)",
      "Triton Safety Instrumented System Attack (Campaign)",
      "WARPWIRE (Malware)",
      "Winter Vivern (Group)",
    ],
    "T1590.004": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "FIN13 (Group)",
      "MuddyWater (Group)",
      "Salt Typhoon (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1546.009": ["PUNCHBUGGY (Malware)"],
    "T1497.002": [
      "Cobalt Strike (Malware)",
      "Darkhotel (Group)",
      "FIN7 (Group)",
      "Okrum (Malware)",
      "ROAMINGHOUSE (Malware)",
      "Spark (Malware)",
      "TONESHELL (Malware)",
    ],
    T1530: [
      "2025 Poland Wiper Attacks (Campaign)",
      "AADInternals (Tool)",
      "APT42 (Group)",
      "C0027 (Campaign)",
      "Fox Kitten (Group)",
      "HAFNIUM (Group)",
      "Pacu (Tool)",
      "Peirates (Tool)",
      "Scattered Spider (Group)",
      "Storm-0501 (Group)",
      "TruffleHog (Tool)",
    ],
    "T1069.003": [
      "AADInternals (Tool)",
      "C0027 (Campaign)",
      "Pacu (Tool)",
      "ROADTools (Tool)",
    ],
    "T1560.002": [
      "BADFLICK (Malware)",
      "BBSRAT (Malware)",
      "Cardinal RAT (Malware)",
      "Denis (Malware)",
      "Epic (Malware)",
      "FoggyWeb (Malware)",
      "FunnyDream (Malware)",
      "InvisiMole (Malware)",
      "Lazarus Group (Group)",
      "LunarWeb (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "SeaDuke (Malware)",
      "TajMahal (Malware)",
      "Threat Group-3390 (Group)",
      "ZLib (Malware)",
    ],
    "T1114.003": [
      "Kimsuky (Group)",
      "LAPSUS$ (Group)",
      "Scattered Spider (Group)",
      "Silent Librarian (Group)",
      "Star Blizzard (Group)",
    ],
    T1104: [
      "APT3 (Group)",
      "APT41 (Group)",
      "BACKSPACE (Malware)",
      "Bazar (Malware)",
      "BLACKCOFFEE (Malware)",
      "Chaos (Malware)",
      "JumbledPath (Malware)",
      "Latrodectus (Malware)",
      "Lazarus Group (Group)",
      "LunarWeb (Malware)",
      "MuddyWater (Group)",
      "RedPenguin (Campaign)",
      "Snip3 (Malware)",
      "Uroburos (Malware)",
      "Valak (Malware)",
    ],
    "T1585.001": [
      "APT32 (Group)",
      "Cleaver (Group)",
      "Contagious Interview (Group)",
      "CURIUM (Group)",
      "EXOTIC LILY (Group)",
      "Fox Kitten (Group)",
      "HEXANE (Group)",
      "Kimsuky (Group)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "Moonstone Sleet (Group)",
      "Operation Dream Job (Campaign)",
      "Operation Ghost (Campaign)",
      "Sandworm Team (Group)",
      "Scattered Spider (Group)",
      "Star Blizzard (Group)",
      "VOID MANTICORE (Group)",
      "Water Galura (Group)",
    ],
    T1609: [
      "Hildegard (Malware)",
      "Kinsing (Malware)",
      "Peirates (Tool)",
      "Siloscape (Malware)",
      "TeamTNT (Group)",
    ],
    "T1098.004": [
      "Bundlore (Malware)",
      "Earth Lusca (Group)",
      "Operation Digital Eye (Campaign)",
      "Salt Typhoon (Group)",
      "Skidmap (Malware)",
      "TeamTNT (Group)",
      "XCSSET (Malware)",
    ],
    "T1569.001": [
      "AppleJeus (Malware)",
      "Calisto (Malware)",
      "Cuckoo Stealer (Malware)",
      "LoudMiner (Malware)",
      "macOS.OSAMiner (Malware)",
      "XCSSET (Malware)",
    ],
    "T1110.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT3 (Group)",
      "Dragonfly (Group)",
      "FIN6 (Group)",
      "Net Crawler (Malware)",
      "Night Dragon (Campaign)",
      "Salt Typhoon (Group)",
    ],
    "T1584.001": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT1 (Group)",
      "C0010 (Campaign)",
      "C0021 (Campaign)",
      "Gootloader (Malware)",
      "Kimsuky (Group)",
      "Magic Hound (Group)",
      "Mustard Tempest (Group)",
      "Operation Dream Job (Campaign)",
      "SideCopy (Group)",
      "SolarWinds Compromise (Campaign)",
      "Transparent Tribe (Group)",
    ],
    T1557: [
      "ArcaneDoor (Campaign)",
      "Dok (Malware)",
      "evilginx2 (Tool)",
      "Kimsuky (Group)",
      "Line Runner (Malware)",
      "Mustang Panda (Group)",
      "NPPSPY (Tool)",
      "Sea Turtle (Group)",
    ],
    "T1555.005": [
      "Fox Kitten (Group)",
      "Indrik Spider (Group)",
      "InvisibleFerret (Malware)",
      "LAPSUS$ (Group)",
      "MarkiRAT (Malware)",
      "Operation Wocao (Campaign)",
      "Proton (Malware)",
      "Scattered Spider (Group)",
      "Storm-0501 (Group)",
      "Threat Group-3390 (Group)",
      "TrickBot (Malware)",
      "UNC3886 (Group)",
    ],
    "T1552.004": [
      "AADInternals (Tool)",
      "Ebury (Malware)",
      "Empire (Tool)",
      "FoggyWeb (Malware)",
      "Hildegard (Malware)",
      "jRAT (Malware)",
      "Kimsuky (Group)",
      "Kinsing (Malware)",
      "Machete (Malware)",
      "Mafalda (Malware)",
      "Mimikatz (Tool)",
      "Operation Wocao (Campaign)",
      "Rocke (Group)",
      "Scattered Spider (Group)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
      "TeamTNT (Group)",
      "Troll Stealer (Malware)",
      "Volt Typhoon (Group)",
    ],
    T1136: [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Indrik Spider (Group)",
      "LockBit 2.0 (Malware)",
      "Salt Typhoon (Group)",
      "Scattered Spider (Group)",
    ],
    T1080: [
      "BRONZE BUTLER (Group)",
      "Cinnamon Tempest (Group)",
      "Conti (Malware)",
      "Darkhotel (Group)",
      "Gamaredon Group (Group)",
      "H1N1 (Malware)",
      "InvisiMole (Malware)",
      "Miner-C (Malware)",
      "Ramsay (Malware)",
      "RedCurl (Group)",
      "Stuxnet (Malware)",
      "Ursnif (Malware)",
    ],
    T1199: [
      "APT28 (Group)",
      "APT29 (Group)",
      "GOLD SOUTHFIELD (Group)",
      "HAFNIUM (Group)",
      "LAPSUS$ (Group)",
      "menuPass (Group)",
      "POLONIUM (Group)",
      "RedCurl (Group)",
      "Sandworm Team (Group)",
      "Sea Turtle (Group)",
      "SolarWinds Compromise (Campaign)",
      "Threat Group-3390 (Group)",
      "VOID MANTICORE (Group)",
    ],
    T1205: [
      "BRUSHFIRE (Malware)",
      "BUSHWALK (Malware)",
      "Chaos (Malware)",
      "Cutting Edge (Campaign)",
      "J-magic (Malware)",
      "Kimsuky (Group)",
      "Kobalos (Malware)",
      "Mustang Panda (Group)",
      "Pandora (Malware)",
      "Penquin (Malware)",
      "PUBLOAD (Malware)",
      "RedPenguin (Campaign)",
      "REPTILE (Malware)",
      "Ryuk (Malware)",
      "SYNful Knock (Malware)",
      "TONESHELL (Malware)",
      "TRANSLATEXT (Malware)",
      "Umbreon (Malware)",
      "UNC3886 (Group)",
      "Uroburos (Malware)",
      "Winnti for Linux (Malware)",
      "ZIPLINE (Malware)",
    ],
    "T1021.004": [
      "APT39 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "BlackTech (Group)",
      "C0032 (Campaign)",
      "Cobalt Strike (Malware)",
      "Cutting Edge (Campaign)",
      "Empire (Tool)",
      "FIN13 (Group)",
      "FIN7 (Group)",
      "Fox Kitten (Group)",
      "GCMAN (Group)",
      "Indrik Spider (Group)",
      "Kinsing (Malware)",
      "Lazarus Group (Group)",
      "Leviathan (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "menuPass (Group)",
      "OilRig (Group)",
      "Qilin (Malware)",
      "reGeorg (Malware)",
      "Rocke (Group)",
      "Salt Typhoon (Group)",
      "Scattered Spider (Group)",
      "Storm-1811 (Group)",
      "TeamTNT (Group)",
      "UNC3886 (Group)",
    ],
    "T1053.003": [
      "Anchor (Malware)",
      "APT38 (Group)",
      "APT5 (Group)",
      "Exaramel for Linux (Malware)",
      "GoldMax (Malware)",
      "Gomir (Malware)",
      "Janicab (Malware)",
      "Kinsing (Malware)",
      "NETWIRE (Malware)",
      "NKAbuse (Malware)",
      "Operation MidnightEclipse (Campaign)",
      "Penquin (Malware)",
      "Rocke (Group)",
      "Skidmap (Malware)",
      "SpeakUp (Malware)",
      "Xbash (Malware)",
    ],
    "T1074.002": [
      "APT28 (Group)",
      "ccf32 (Malware)",
      "Chimera (Group)",
      "FIN6 (Group)",
      "FIN8 (Group)",
      "Leviathan (Group)",
      "menuPass (Group)",
      "MirrorFace (Group)",
      "MoustachedBouncer (Group)",
      "Night Dragon (Campaign)",
      "Sea Turtle (Group)",
      "SolarWinds Compromise (Campaign)",
      "Threat Group-3390 (Group)",
      "ToddyCat (Group)",
    ],
    T1207: ["Mimikatz (Tool)"],
    "T1205.002": [
      "BPFDoor (Malware)",
      "CASTLETAP (Malware)",
      "Penquin (Malware)",
      "PITSTOP (Malware)",
    ],
    "T1574.006": [
      "APT41 (Group)",
      "Aquatic Panda (Group)",
      "COATHANGER (Malware)",
      "Ebury (Malware)",
      "HiddenWasp (Malware)",
      "Hildegard (Malware)",
      "MEDUSA (Malware)",
      "Rocke (Group)",
      "SPAWNCHIMERA (Malware)",
      "XCSSET (Malware)",
    ],
    T1069: [
      "APT3 (Group)",
      "APT41 (Group)",
      "Carbon (Malware)",
      "FIN13 (Group)",
      "IcedID (Malware)",
      "MURKYTOP (Malware)",
      "Scattered Spider (Group)",
      "ShimRatReporter (Tool)",
      "Siloscape (Malware)",
      "SolarWinds Compromise (Campaign)",
      "TA505 (Group)",
      "TrickBot (Malware)",
      "Volt Typhoon (Group)",
    ],
    T1092: ["APT28 (Group)", "CHOPSTICK (Malware)", "USBStealer (Malware)"],
    T1114: [
      "Ember Bear (Group)",
      "Emotet (Malware)",
      "Magic Hound (Group)",
      "Scattered Spider (Group)",
      "Silent Librarian (Group)",
      "TRANSLATEXT (Malware)",
    ],
    "T1205.001": [
      "cd00r (Malware)",
      "Mafalda (Malware)",
      "metaMain (Malware)",
      "PROMETHIUM (Group)",
      "REPTILE (Malware)",
      "UNC3886 (Group)",
    ],
    "T1583.005": ["APT5 (Group)", "HAFNIUM (Group)", "Ke3chang (Group)"],
    "T1685.002": ["APT29 (Group)", "Pacu (Tool)"],
    T1526: [
      "AADInternals (Tool)",
      "Pacu (Tool)",
      "ROADTools (Tool)",
      "Storm-0501 (Group)",
      "TruffleHog (Tool)",
    ],
    "T1591.002": [
      "Dragonfly (Group)",
      "LAPSUS$ (Group)",
      "Sandworm Team (Group)",
    ],
    T1537: ["INC Ransom (Group)", "RedCurl (Group)", "Storm-0501 (Group)"],
    "T1048.002": [
      "APT28 (Group)",
      "BRUSHFIRE (Malware)",
      "CURIUM (Group)",
      "IcedID (Malware)",
      "MirrorFace (Group)",
      "Rclone (Tool)",
      "SolarWinds Compromise (Campaign)",
      "Storm-1811 (Group)",
    ],
    "T1553.006": [
      "APT39 (Group)",
      "BlackEnergy (Malware)",
      "Hikit (Malware)",
      "Pandora (Malware)",
      "Turla (Group)",
    ],
    "T1036.006": ["APT38 (Group)", "Keydnap (Malware)"],
    "T1134.003": [
      "BlackByte (Group)",
      "Cobalt Strike (Malware)",
      "FIN13 (Group)",
      "Mafalda (Malware)",
      "SILENTTRINITY (Tool)",
    ],
    "T1070.003": [
      "APT41 (Group)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "Hildegard (Malware)",
      "J-magic (Malware)",
      "Kobalos (Malware)",
      "Lazarus Group (Group)",
      "Magic Hound (Group)",
      "Medusa Group (Group)",
      "menuPass (Group)",
      "TeamTNT (Group)",
    ],
    "T1053.002": [
      "APT18 (Group)",
      "at (Tool)",
      "BRONZE BUTLER (Group)",
      "CrackMapExec (Tool)",
      "MURKYTOP (Malware)",
      "Threat Group-3390 (Group)",
    ],
    "T1598.004": [
      "C0027 (Campaign)",
      "LAPSUS$ (Group)",
      "Salesforce Data Exfiltration (Campaign)",
      "Scattered Spider (Group)",
    ],
    "T1543.002": [
      "2022 Ukraine Electric Power Attack (Campaign)",
      "Exaramel for Linux (Malware)",
      "Fysbis (Malware)",
      "Gomir (Malware)",
      "Hildegard (Malware)",
      "Pupy (Tool)",
      "RIFLESPINE (Malware)",
      "Rocke (Group)",
      "RotaJakiro (Malware)",
      "Scattered Spider (Group)",
      "Shai-Hulud (Malware)",
      "SysUpdate (Malware)",
      "TeamTNT (Group)",
    ],
    "T1568.002": [
      "APT41 (Group)",
      "Aria-body (Malware)",
      "Astaroth (Malware)",
      "AsyncRAT (Tool)",
      "Bazar (Malware)",
      "BONDUPDATER (Malware)",
      "CCBkdr (Malware)",
      "CHOPSTICK (Malware)",
      "Conficker (Malware)",
      "DarkWatchman (Malware)",
      "Doki (Malware)",
      "Ebury (Malware)",
      "Grandoreiro (Malware)",
      "HiddenFace (Malware)",
      "Milan (Malware)",
      "MiniDuke (Malware)",
      "ngrok (Tool)",
      "POSHSPY (Malware)",
      "QakBot (Malware)",
      "ShadowPad (Malware)",
      "Shark (Malware)",
      "SombRAT (Malware)",
      "TA551 (Group)",
      "Ursnif (Malware)",
    ],
    "T1070.008": [
      "APT42 (Group)",
      "Goopy (Malware)",
      "LunarMail (Malware)",
      "Scattered Spider (Group)",
      "SolarWinds Compromise (Campaign)",
    ],
    "T1586.001": ["Leviathan (Group)", "Sandworm Team (Group)"],
    "T1078.003": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT29 (Group)",
      "APT32 (Group)",
      "Cobalt Strike (Malware)",
      "Emotet (Malware)",
      "FIN10 (Group)",
      "FIN7 (Group)",
      "HAFNIUM (Group)",
      "Kimsuky (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "LockBit 3.0 (Malware)",
      "NotPetya (Malware)",
      "Operation Wocao (Campaign)",
      "Play (Group)",
      "PROMETHIUM (Group)",
      "Sea Turtle (Group)",
      "SolarWinds Compromise (Campaign)",
      "Tropic Trooper (Group)",
      "Turla (Group)",
      "Umbreon (Malware)",
      "Velvet Ant (Group)",
    ],
    T1547: [
      "APT42 (Group)",
      "BoxCaon (Malware)",
      "Dtrack (Malware)",
      "Mis-Type (Malware)",
      "Misdat (Malware)",
      "xCaon (Malware)",
    ],
    "T1546.013": ["Turla (Group)"],
    T1006: [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT28 Nearest Neighbor Campaign (Campaign)",
      "esentutl (Tool)",
      "Scattered Spider (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1027.011": [
      "APT32 (Group)",
      "Chaes (Malware)",
      "CHOPSTICK (Malware)",
      "ComRAT (Malware)",
      "DarkWatchman (Malware)",
      "Exaramel for Windows (Malware)",
      "Gelsemium (Malware)",
      "Grandoreiro (Malware)",
      "Mosquito (Malware)",
      "NETWIRE (Malware)",
      "Operation CuckooBees (Campaign)",
      "Pikabot (Malware)",
      "Pillowmint (Malware)",
      "PipeMon (Malware)",
      "PolyglotDuke (Malware)",
      "QakBot (Malware)",
      "Quad7 Activity (Campaign)",
      "QUADAGENT (Malware)",
      "RCSession (Malware)",
      "RegDuke (Malware)",
      "REvil (Malware)",
      "ShadowPad (Malware)",
      "Sibot (Malware)",
      "SysUpdate (Malware)",
      "ThreatNeedle (Malware)",
      "TinyTurla (Malware)",
      "Turla (Group)",
      "TYPEFRAME (Malware)",
      "Uroburos (Malware)",
      "Valak (Malware)",
      "Volgmer (Malware)",
    ],
    "T1027.015": [
      "BADHATCH (Malware)",
      "DarkWatchman (Malware)",
      "Donut (Tool)",
      "Gamaredon Group (Group)",
      "Gelsemium (Malware)",
      "Hancitor (Malware)",
      "HermeticWiper (Malware)",
      "Higaisa (Group)",
      "Kerrdown (Malware)",
      "Kimsuky (Group)",
      "Leviathan (Group)",
      "Line Runner (Malware)",
      "LODEINFO (Malware)",
      "Mofang (Group)",
      "Molerats (Group)",
      "Ninja (Malware)",
      "Pandora (Malware)",
      "PcShare (Tool)",
      "Pillowmint (Malware)",
      "Pony (Malware)",
      "PUBLOAD (Malware)",
      "RCSession (Malware)",
      "RTM (Malware)",
      "Samurai (Malware)",
      "ShimRat (Malware)",
      "SocGholish (Malware)",
      "StrelaStealer (Malware)",
      "SUNBURST (Malware)",
      "TA2541 (Group)",
      "Threat Group-3390 (Group)",
      "ThreatNeedle (Malware)",
      "VOID MANTICORE (Group)",
      "WindTail (Malware)",
      "Winnti for Windows (Malware)",
      "WIRTE (Group)",
    ],
    "T1595.003": ["APT41 (Group)", "Volatile Cedar (Group)"],
    "T1546.010": [
      "APT39 (Group)",
      "Cherry Picker (Malware)",
      "Ramsay (Malware)",
      "T9000 (Malware)",
    ],
    T1611: [
      "Doki (Malware)",
      "Hildegard (Malware)",
      "Peirates (Tool)",
      "Siloscape (Malware)",
      "TeamTNT (Group)",
    ],
    "T1552.002": [
      "Agent Tesla (Malware)",
      "APT32 (Group)",
      "IceApple (Malware)",
      "PowerSploit (Tool)",
      "RedCurl (Group)",
      "Reg (Tool)",
      "StrelaStealer (Malware)",
      "TrickBot (Malware)",
      "Valak (Malware)",
      "VOID MANTICORE (Group)",
    ],
    "T1213.005": [
      "Fox Kitten (Group)",
      "LAPSUS$ (Group)",
      "Scattered Spider (Group)",
      "TruffleHog (Tool)",
    ],
    "T1608.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "C0010 (Campaign)",
      "Medusa Group (Group)",
      "Operation Dream Job (Campaign)",
      "Threat Group-3390 (Group)",
    ],
    "T1588.004": [
      "BlackTech (Group)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
      "Lazarus Group (Group)",
      "LuminousMoth (Group)",
      "Mustang Panda (Group)",
      "Operation Honeybee (Campaign)",
      "RedDelta Modified PlugX Infection Chain Operations (Campaign)",
      "Sea Turtle (Group)",
      "Silent Librarian (Group)",
      "UNC3886 (Group)",
    ],
    "T1546.003": [
      "adbupd (Malware)",
      "APT29 (Group)",
      "APT33 (Group)",
      "BADHATCH (Malware)",
      "Blue Mockingbird (Group)",
      "FIN8 (Group)",
      "HEXANE (Group)",
      "HOPLIGHT (Malware)",
      "Kevin (Malware)",
      "Leviathan (Group)",
      "Metador (Group)",
      "metaMain (Malware)",
      "Mustang Panda (Group)",
      "Operation Ghost (Campaign)",
      "PoshC2 (Tool)",
      "POSHSPY (Malware)",
      "POWERTON (Malware)",
      "Rancor (Group)",
      "RegDuke (Malware)",
      "Sardonic (Malware)",
      "SeaDuke (Malware)",
      "SILENTTRINITY (Tool)",
      "SolarWinds Compromise (Campaign)",
      "TrailBlazer (Malware)",
      "Turla (Group)",
    ],
    "T1213.004": ["Salesforce Data Exfiltration (Campaign)"],
    "T1204.004": [
      "Contagious Interview (Group)",
      "Havoc (Malware)",
      "Kimsuky (Group)",
      "MuddyWater (Group)",
    ],
    "T1586.002": [
      "APT-C-36 (Group)",
      "APT28 (Group)",
      "APT29 (Group)",
      "HEXANE (Group)",
      "IndigoZebra (Group)",
      "Kimsuky (Group)",
      "LAPSUS$ (Group)",
      "Leviathan (Group)",
      "Magic Hound (Group)",
      "Mustang Panda (Group)",
      "OilRig (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Salesforce Data Exfiltration (Campaign)",
      "Star Blizzard (Group)",
      "TA577 (Group)",
      "WIRTE (Group)",
    ],
    T1110: [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Agrius (Group)",
      "APT28 (Group)",
      "APT38 (Group)",
      "APT39 (Group)",
      "APT41 (Group)",
      "Caterpillar WebShell (Malware)",
      "Chaos (Malware)",
      "CrackMapExec (Tool)",
      "DarkVishnya (Group)",
      "Dragonfly (Group)",
      "Ember Bear (Group)",
      "FIN5 (Group)",
      "Fox Kitten (Group)",
      "HEXANE (Group)",
      "Kinsing (Malware)",
      "OilRig (Group)",
      "Operation Dream Job (Campaign)",
      "PoshC2 (Tool)",
      "Pysa (Malware)",
      "QakBot (Malware)",
      "Storm-0501 (Group)",
      "Turla (Group)",
      "VOID MANTICORE (Group)",
    ],
    T1574: [
      "C0017 (Campaign)",
      "COATHANGER (Malware)",
      "DarkGate (Malware)",
      "Denis (Malware)",
      "Dtrack (Malware)",
      "Nightdoor (Malware)",
      "Pikabot Distribution February 2024 (Campaign)",
      "Raspberry Robin (Malware)",
      "Saint Bot (Malware)",
      "ShimRat (Malware)",
      "SPAWNCHIMERA (Malware)",
    ],
    T1671: ["Salesforce Data Exfiltration (Campaign)"],
    T1673: [
      "Cheerscrypt (Malware)",
      "PureCrypter (Malware)",
      "Qilin (Malware)",
      "UNC3886 (Group)",
      "VIRTUALPITA (Malware)",
    ],
    "T1546.001": ["Kimsuky (Group)", "SILENTTRINITY (Tool)"],
    "T1589.002": [
      "AADInternals (Tool)",
      "APT32 (Group)",
      "EXOTIC LILY (Group)",
      "HAFNIUM (Group)",
      "HEXANE (Group)",
      "Kimsuky (Group)",
      "LAPSUS$ (Group)",
      "Lazarus Group (Group)",
      "Magic Hound (Group)",
      "Moonstone Sleet (Group)",
      "Quad7 Activity (Campaign)",
      "Saint Bear (Group)",
      "Sandworm Team (Group)",
      "Silent Librarian (Group)",
      "TA551 (Group)",
      "Volt Typhoon (Group)",
      "Water Curupira Pikabot Distribution (Campaign)",
    ],
    "T1218.008": [
      "Bumblebee (Malware)",
      "Cobalt Group (Group)",
      "Raspberry Robin (Malware)",
    ],
    T1072: [
      "APT32 (Group)",
      "C0018 (Campaign)",
      "Medusa Group (Group)",
      "Mustang Panda (Group)",
      "Sandworm Team (Group)",
      "Silence (Group)",
      "Threat Group-1314 (Group)",
      "VOID MANTICORE (Group)",
      "Wiper (Malware)",
    ],
    "T1568.001": [
      "Amadey (Malware)",
      "Gamaredon Group (Group)",
      "gh0st RAT (Malware)",
      "menuPass (Group)",
      "njRAT (Malware)",
      "TA505 (Group)",
    ],
    "T1132.002": [
      "BACKSPACE (Malware)",
      "Bankshot (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "Cyclops Blink (Malware)",
      "HTTPTroy (Malware)",
      "InvisiMole (Malware)",
      "Kimsuky (Group)",
      "Lizar (Malware)",
      "Neo-reGeorg (Malware)",
      "NightClub (Malware)",
      "Ninja (Malware)",
      "OceanSalt (Malware)",
      "PowGoop (Malware)",
      "RDAT (Malware)",
      "ShadowPad (Malware)",
      "Small Sieve (Malware)",
      "TONESHELL (Malware)",
      "Uroburos (Malware)",
    ],
    "T1587.002": [
      "Daggerfly (Group)",
      "Operation Dream Job (Campaign)",
      "Patchwork (Group)",
      "PROMETHIUM (Group)",
    ],
    "T1557.002": ["Cleaver (Group)", "LuminousMoth (Group)"],
    "T1003.004": [
      "AADInternals (Tool)",
      "APT29 (Group)",
      "APT33 (Group)",
      "CosmicDuke (Malware)",
      "CrackMapExec (Tool)",
      "Dragonfly (Group)",
      "Ember Bear (Group)",
      "gsecdump (Tool)",
      "IceApple (Malware)",
      "Impacket (Tool)",
      "Ke3chang (Group)",
      "LaZagne (Tool)",
      "Leafminer (Group)",
      "menuPass (Group)",
      "Mimikatz (Tool)",
      "MuddyWater (Group)",
      "OilRig (Group)",
      "Pupy (Tool)",
      "Threat Group-3390 (Group)",
    ],
    "T1564.004": [
      "Anchor (Malware)",
      "APT32 (Group)",
      "Astaroth (Malware)",
      "BitPaymer (Malware)",
      "DEADEYE (Malware)",
      "esentutl (Tool)",
      "Expand (Tool)",
      "Gazer (Malware)",
      "Latrodectus (Malware)",
      "LoJax (Malware)",
      "PowerDuke (Malware)",
      "POWERSOURCE (Malware)",
      "Regin (Malware)",
      "Valak (Malware)",
      "WastedLocker (Malware)",
      "Zeroaccess (Malware)",
    ],
    T1552: [
      "Astaroth (Malware)",
      "DarkGate (Malware)",
      "Leviathan Australian Intrusions (Campaign)",
      "NPPSPY (Tool)",
      "Pacu (Tool)",
      "Volt Typhoon (Group)",
    ],
    "T1021.005": [
      "Carberp (Malware)",
      "DanBot (Malware)",
      "FIN7 (Group)",
      "Fox Kitten (Group)",
      "Gamaredon Group (Group)",
      "GCMAN (Group)",
      "Latrodectus (Malware)",
      "Proton (Malware)",
      "TrickBot (Malware)",
      "WarzoneRAT (Malware)",
      "ZxShell (Malware)",
    ],
    "T1601.001": ["SYNful Knock (Malware)"],
    T1039: [
      "APT28 (Group)",
      "BADNEWS (Malware)",
      "BRONZE BUTLER (Group)",
      "C0015 (Campaign)",
      "Chimera (Group)",
      "CosmicDuke (Malware)",
      "Egregor (Malware)",
      "Fox Kitten (Group)",
      "Gamaredon Group (Group)",
      "menuPass (Group)",
      "Ramsay (Malware)",
      "RedCurl (Group)",
      "Sowbug (Group)",
    ],
    T1587: [
      "Contagious Interview (Group)",
      "Kimsuky (Group)",
      "Moonstone Sleet (Group)",
    ],
    "T1591.001": ["Magic Hound (Group)"],
    T1185: [
      "Agent Tesla (Malware)",
      "Carberp (Malware)",
      "Chaes (Malware)",
      "Cobalt Strike (Malware)",
      "Dridex (Malware)",
      "evilginx2 (Tool)",
      "Grandoreiro (Malware)",
      "IcedID (Malware)",
      "Kimsuky (Group)",
      "Melcoz (Malware)",
      "QakBot (Malware)",
      "TRANSLATEXT (Malware)",
      "TrickBot (Malware)",
      "Ursnif (Malware)",
      "XLoader (Malware)",
    ],
    T1593: [
      "APT-C-36 (Group)",
      "Contagious Interview (Group)",
      "Mustang Panda (Group)",
      "Sandworm Team (Group)",
      "Star Blizzard (Group)",
      "Volt Typhoon (Group)",
    ],
    T1531: [
      "Akira (Group)",
      "DEADWOOD (Malware)",
      "LAPSUS$ (Group)",
      "LockerGoga (Malware)",
      "MegaCortex (Malware)",
      "Meteor (Malware)",
    ],
    "T1683.001": ["APT-C-36 (Group)", "Contagious Interview (Group)"],
    "T1546.004": [
      "Contagious Interview (Group)",
      "Green Lambert (Malware)",
      "Linux Rabbit (Malware)",
      "PHASEJAM (Malware)",
      "RotaJakiro (Malware)",
      "ShadowRay (Campaign)",
      "XCSSET (Malware)",
    ],
    "T1027.004": [
      "Cardinal RAT (Malware)",
      "DarkWatchman (Malware)",
      "FoggyWeb (Malware)",
      "Gamaredon Group (Group)",
      "MuddyWater (Group)",
      "njRAT (Malware)",
      "Rocke (Group)",
      "Samurai (Malware)",
      "Sea Turtle (Group)",
      "Sliver (Tool)",
    ],
    T1619: ["Pacu (Tool)", "Peirates (Tool)", "TruffleHog (Tool)"],
    T1559: [
      "3CX Supply Chain Attack (Campaign)",
      "Cyclops Blink (Malware)",
      "Havoc (Malware)",
      "HyperStack (Malware)",
      "LunarWeb (Malware)",
      "Medusa Ransomware (Malware)",
      "Ninja (Malware)",
      "OilBooster (Malware)",
      "Operation MidnightEclipse (Campaign)",
      "PITSTOP (Malware)",
      "Raspberry Robin (Malware)",
      "ROADSWEEP (Malware)",
      "RotaJakiro (Malware)",
      "SPAWNCHIMERA (Malware)",
      "StealBit (Malware)",
      "TONESHELL (Malware)",
      "Uroburos (Malware)",
    ],
    T1098: [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Calisto (Malware)",
      "HAFNIUM (Group)",
      "Lazarus Group (Group)",
      "Mimikatz (Tool)",
      "Scattered Spider (Group)",
      "Shai-Hulud (Malware)",
      "VOID MANTICORE (Group)",
    ],
    T1543: [
      "Akira _v2 (Malware)",
      "BOLDMOVE (Malware)",
      "BRICKSTORM (Malware)",
      "Exaramel for Linux (Malware)",
      "IMAPLoader (Malware)",
      "LITTLELAMB.WOOLTEA (Malware)",
      "LunarMail (Malware)",
    ],
    T1649: ["AADInternals (Tool)", "APT29 (Group)", "Mimikatz (Tool)"],
    T1495: [
      "2025 Poland Wiper Attacks (Campaign)",
      "Bad Rabbit (Malware)",
      "TrickBot (Malware)",
    ],
    "T1037.001": [
      "APT28 (Group)",
      "Attor (Malware)",
      "Cobalt Group (Group)",
      "JHUHUGIT (Malware)",
      "KGH_SPY (Malware)",
      "Zebrocy (Malware)",
    ],
    "T1550.001": [
      "APT28 (Group)",
      "CreepyDrive (Malware)",
      "HAFNIUM (Group)",
      "Peirates (Tool)",
      "Shai-Hulud (Malware)",
      "SolarWinds Compromise (Campaign)",
    ],
    T1688: [
      "AvosLocker (Malware)",
      "Black Basta (Malware)",
      "Embargo (Malware)",
      "LockBit 3.0 (Malware)",
      "Qilin (Malware)",
      "RansomHub (Malware)",
      "REvil (Malware)",
    ],
    T1056: [
      "APT39 (Group)",
      "APT42 (Group)",
      "Chaes (Malware)",
      "FlawedAmmyy (Malware)",
      "InvisibleFerret (Malware)",
      "Kobalos (Malware)",
      "Leviathan Australian Intrusions (Campaign)",
      "Mafalda (Malware)",
      "metaMain (Malware)",
      "NPPSPY (Tool)",
      "Storm-1811 (Group)",
      "Versa Director Zero Day Exploitation (Campaign)",
    ],
    "T1553.005": [
      "Amadey (Malware)",
      "APT29 (Group)",
      "APT38 (Group)",
      "QakBot (Malware)",
      "TA505 (Group)",
    ],
    "T1127.001": [
      "Empire (Tool)",
      "Frankenstein (Campaign)",
      "NOOPLDR (Malware)",
      "Operation AkaiRy\u016b (Campaign)",
      "PlugX (Malware)",
    ],
    "T1484.002": [
      "AADInternals (Tool)",
      "Scattered Spider (Group)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
    ],
    T1071: [
      "Clambling (Malware)",
      "Duqu (Malware)",
      "FrostyGoop Incident (Campaign)",
      "Hildegard (Malware)",
      "INC Ransom (Group)",
      "Lucifer (Malware)",
      "Magic Hound (Group)",
      "NETEAGLE (Malware)",
      "Nightdoor (Malware)",
      "QUIETEXIT (Malware)",
      "Raspberry Robin (Malware)",
      "Rocke (Group)",
      "Siloscape (Malware)",
      "Sliver (Tool)",
      "TeamTNT (Group)",
      "Velvet Ant (Group)",
    ],
    "T1003.007": [
      "LaZagne (Tool)",
      "MimiPenguin (Tool)",
      "PACEMAKER (Malware)",
    ],
    "T1505.001": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "Stuxnet (Malware)",
    ],
    "T1218.004": [
      "Chaes (Malware)",
      "Covenant (Tool)",
      "menuPass (Group)",
      "Mustang Panda (Group)",
      "Saint Bot (Malware)",
      "WhisperGate (Malware)",
    ],
    T1221: [
      "APT28 (Group)",
      "Chaes (Malware)",
      "Confucius (Group)",
      "DarkHydrus (Group)",
      "Dragonfly (Group)",
      "Frankenstein (Campaign)",
      "Gamaredon Group (Group)",
      "Inception (Group)",
      "MirrorFace (Group)",
      "Operation Dream Job (Campaign)",
      "Tropic Trooper (Group)",
      "WarzoneRAT (Malware)",
    ],
    T1132: [
      "BADNEWS (Malware)",
      "evilginx2 (Tool)",
      "H1N1 (Malware)",
      "LAMEHUG (Malware)",
      "Linux Rabbit (Malware)",
      "Mythic (Tool)",
      "Ursnif (Malware)",
      "Velvet Ant (Group)",
    ],
    "T1564.011": [
      "BOLDMOVE (Malware)",
      "BPFDoor (Malware)",
      "GoldMax (Malware)",
      "Kimsuky (Group)",
      "OSX/Shlayer (Malware)",
      "Sea Turtle (Group)",
      "Shai-Hulud (Malware)",
      "UNC3886 (Group)",
    ],
    "T1011.001": ["Flame (Malware)"],
    T1690: [
      "APT38 (Group)",
      "ArcaneDoor (Campaign)",
      "BPFDoor (Malware)",
      "BRICKSTORM (Malware)",
      "Line Dancer (Malware)",
      "Medusa Group (Group)",
      "RedPenguin (Campaign)",
      "Sea Turtle (Group)",
      "SILENTTRINITY (Tool)",
      "SPAWNCHIMERA (Malware)",
      "UNC3886 (Group)",
      "VIRTUALPITA (Malware)",
    ],
    "T1564.008": ["FIN4 (Group)", "Scattered Spider (Group)"],
    T1528: [
      "AADInternals (Tool)",
      "APT28 (Group)",
      "APT29 (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Peirates (Tool)",
      "Shai-Hulud (Malware)",
      "TruffleHog (Tool)",
    ],
    T1550: ["FoggyWeb (Malware)", "SolarWinds Compromise (Campaign)"],
    "T1546.017": ["REPTILE (Malware)"],
    "T1547.012": [
      "Earth Lusca (Group)",
      "Gelsemium (Malware)",
      "PipeMon (Malware)",
    ],
    "T1213.003": [
      "APT41 (Group)",
      "GlassWorm (Malware)",
      "LAPSUS$ (Group)",
      "Scattered Spider (Group)",
      "Shai-Hulud (Malware)",
      "SolarWinds Compromise (Campaign)",
      "TruffleHog (Tool)",
    ],
    "T1505.004": [
      "IceApple (Malware)",
      "Operation Dream Job (Campaign)",
      "OwaAuth (Malware)",
      "RGDoor (Malware)",
      "SharePoint ToolShell Exploitation (Campaign)",
    ],
    T1074: [
      "INC Ransom (Group)",
      "Kevin (Malware)",
      "Kobalos (Malware)",
      "QUIETCANARY (Malware)",
      "Scattered Spider (Group)",
      "Shark (Malware)",
      "VOID MANTICORE (Group)",
      "Volt Typhoon (Group)",
      "Wizard Spider (Group)",
    ],
    "T1547.006": [
      "Drovorub (Malware)",
      "Operation CuckooBees (Campaign)",
      "REPTILE (Malware)",
      "Skidmap (Malware)",
    ],
    T1679: [
      "DynoWiper (Malware)",
      "Embargo (Malware)",
      "InvisibleFerret (Malware)",
      "LazyWiper (Malware)",
      "Medusa Ransomware (Malware)",
      "SameCoin (Malware)",
      "VOID MANTICORE (Group)",
    ],
    T1654: [
      "Akira _v2 (Malware)",
      "APT5 (Group)",
      "Aquatic Panda (Group)",
      "BeaverTail (Malware)",
      "DUSTTRAP (Malware)",
      "Ember Bear (Group)",
      "Megazord (Malware)",
      "Mustang Panda (Group)",
      "Pacu (Tool)",
      "Volt Typhoon (Group)",
    ],
    T1187: ["DarkHydrus (Group)", "Dragonfly (Group)", "EnvyScout (Malware)"],
    "T1574.009": ["Empire (Tool)", "PowerSploit (Tool)"],
    "T1219.001": [
      "Mustang Panda (Group)",
      "Operation AkaiRy\u016b (Campaign)",
      "Operation Digital Eye (Campaign)",
    ],
    "T1036.011": ["BPFDoor (Malware)"],
    T1677: ["Shai-Hulud (Malware)"],
    "T1584.005": [
      "APT-C-36 (Group)",
      "Axiom (Group)",
      "HAFNIUM (Group)",
      "Quad7 Activity (Campaign)",
      "Sandworm Team (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1218.009": ["Agent Tesla (Malware)"],
    "T1134.004": [
      "Cobalt Strike (Malware)",
      "DarkGate (Malware)",
      "KONNI (Malware)",
      "PipeMon (Malware)",
    ],
    "T1218.012": ["Hancitor (Malware)"],
    T1594: [
      "APT41 DUST (Campaign)",
      "Cutting Edge (Campaign)",
      "EXOTIC LILY (Group)",
      "Kimsuky (Group)",
      "Leviathan Australian Intrusions (Campaign)",
      "Sandworm Team (Group)",
      "Silent Librarian (Group)",
      "TA578 (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1588.007": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "APT28 (Group)",
      "Contagious Interview (Group)",
      "LazyWiper (Malware)",
    ],
    "T1593.003": [
      "Contagious Interview (Group)",
      "HAFNIUM (Group)",
      "LAPSUS$ (Group)",
      "Shai-Hulud (Malware)",
    ],
    T1590: ["HAFNIUM (Group)", "Indrik Spider (Group)", "Volt Typhoon (Group)"],
    "T1592.002": [
      "Andariel (Group)",
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "Magic Hound (Group)",
      "Sandworm Team (Group)",
    ],
    "T1602.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "GlassWorm (Malware)",
      "Salt Typhoon (Group)",
    ],
    "T1098.007": [
      "APT3 (Group)",
      "APT41 (Group)",
      "APT5 (Group)",
      "DarkGate (Malware)",
      "Dragonfly (Group)",
      "FIN13 (Group)",
      "Kimsuky (Group)",
      "Magic Hound (Group)",
      "Net (Tool)",
      "ServHelper (Malware)",
      "SMOKEDHAM (Malware)",
    ],
    "T1218.001": [
      "APT38 (Group)",
      "APT41 (Group)",
      "Astaroth (Malware)",
      "Dark Caracal (Group)",
      "OilRig (Group)",
      "Silence (Group)",
    ],
    "T1596.005": [
      "APT41 (Group)",
      "APT41 DUST (Campaign)",
      "Volt Typhoon (Group)",
    ],
    "T1195.001": [
      "BeaverTail (Malware)",
      "GlassWorm (Malware)",
      "Shai-Hulud (Malware)",
      "Tsundere Botnet (Malware)",
      "XCSSET (Malware)",
    ],
    "T1583.004": [
      "CURIUM (Group)",
      "Earth Lusca (Group)",
      "GALLIUM (Group)",
      "Kimsuky (Group)",
      "Mustard Tempest (Group)",
      "Night Dragon (Campaign)",
      "Operation Dream Job (Campaign)",
      "Operation Honeybee (Campaign)",
      "Operation Wocao (Campaign)",
      "Sandworm Team (Group)",
      "VOID MANTICORE (Group)",
    ],
    "T1567.004": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Shai-Hulud (Malware)",
    ],
    "T1556.007": ["AADInternals (Tool)", "APT29 (Group)"],
    "T1036.003": [
      "APT32 (Group)",
      "APT38 (Group)",
      "CozyCar (Malware)",
      "Daggerfly (Group)",
      "DarkGate (Malware)",
      "GALLIUM (Group)",
      "Kevin (Malware)",
      "Lazarus Group (Group)",
      "menuPass (Group)",
      "PHASEJAM (Malware)",
      "StrelaStealer (Malware)",
    ],
    "T1216.001": ["APT32 (Group)"],
    "T1176.001": [
      "Bundlore (Malware)",
      "Grandoreiro (Malware)",
      "Kimsuky (Group)",
      "Lumma Stealer (Malware)",
      "Mispadu (Malware)",
      "OSX/Shlayer (Malware)",
      "TRANSLATEXT (Malware)",
    ],
    "T1003.008": ["LaZagne (Tool)", "ShadowRay (Campaign)"],
    T1647: ["Cuckoo Stealer (Malware)", "XCSSET (Malware)"],
    "T1070.009": [
      "Bazar (Malware)",
      "GrimAgent (Malware)",
      "IPsec Helper (Malware)",
      "Kapeka (Malware)",
      "KOCTOPUS (Malware)",
      "MCMD (Tool)",
      "Misdat (Malware)",
      "njRAT (Malware)",
      "Pillowmint (Malware)",
      "PlugX (Malware)",
      "Raspberry Robin (Malware)",
      "RTM (Malware)",
      "S-Type (Malware)",
      "SplatDropper (Malware)",
      "SUNBURST (Malware)",
    ],
    "T1136.003": ["AADInternals (Tool)", "APT29 (Group)", "LAPSUS$ (Group)"],
    "T1027.007": [
      "AvosLocker (Malware)",
      "Bazar (Malware)",
      "Brute Ratel C4 (Tool)",
      "CANONSTAGER (Malware)",
      "CHIMNEYSWEEP (Malware)",
      "CLAIMLOADER (Malware)",
      "HiddenFace (Malware)",
      "HTTPTroy (Malware)",
      "Kimsuky (Group)",
      "Latrodectus (Malware)",
      "Lazarus Group (Group)",
      "LODEINFO (Malware)",
      "LP-Notes (Malware)",
      "Mustang Panda (Group)",
      "PlugX (Malware)",
      "Pteranodon (Malware)",
      "Raccoon Stealer (Malware)",
      "Samurai (Malware)",
      "SplatDropper (Malware)",
      "TONESHELL (Malware)",
    ],
    "T1098.002": [
      "APT28 (Group)",
      "APT29 (Group)",
      "HomeLand Justice (Campaign)",
      "Magic Hound (Group)",
      "SolarWinds Compromise (Campaign)",
    ],
    "T1553.001": [
      "CoinTicker (Malware)",
      "Cuckoo Stealer (Malware)",
      "MacMa (Malware)",
      "OSX/Shlayer (Malware)",
      "OSX_OCEANLOTUS.D (Malware)",
      "XCSSET (Malware)",
    ],
    T1565: ["FIN13 (Group)", "PHASEJAM (Malware)"],
    "T1136.002": [
      "2015 Ukraine Electric Power Attack (Campaign)",
      "2016 Ukraine Electric Power Attack (Campaign)",
      "BlackByte (Group)",
      "Empire (Tool)",
      "GALLIUM (Group)",
      "HAFNIUM (Group)",
      "Medusa Group (Group)",
      "Net (Tool)",
      "PsExec (Tool)",
      "Pupy (Tool)",
      "Wizard Spider (Group)",
    ],
    T1669: ["APT28 (Group)", "APT28 Nearest Neighbor Campaign (Campaign)"],
    "T1098.005": [
      "AADInternals (Tool)",
      "APT29 (Group)",
      "C0027 (Campaign)",
      "SolarWinds Compromise (Campaign)",
    ],
    "T1587.003": [
      "APT29 (Group)",
      "ArcaneDoor (Campaign)",
      "C0011 (Campaign)",
      "Gamaredon Group (Group)",
      "J-magic Campaign (Campaign)",
      "PROMETHIUM (Group)",
      "Storm-0501 (Group)",
    ],
    "T1137.004": ["OilRig (Group)", "Ruler (Tool)"],
    T1558: ["2025 Poland Wiper Attacks (Campaign)", "Akira (Group)"],
    "T1564.006": [
      "LoudMiner (Malware)",
      "Maze (Malware)",
      "Ragnar Locker (Malware)",
    ],
    "T1036.010": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "APT3 (Group)",
      "Dragonfly (Group)",
      "Flame (Malware)",
      "Magic Hound (Group)",
      "ServHelper (Malware)",
      "Storm-1811 (Group)",
    ],
    T1651: [
      "AADInternals (Tool)",
      "APT29 (Group)",
      "Pacu (Tool)",
      "VOID MANTICORE (Group)",
    ],
    "T1593.001": [
      "Contagious Interview (Group)",
      "EXOTIC LILY (Group)",
      "Kimsuky (Group)",
      "Operation Dream Job (Campaign)",
    ],
    "T1134.005": ["Empire (Tool)", "Mimikatz (Tool)"],
    T1659: ["Disco (Malware)", "MoustachedBouncer (Group)"],
    T1675: ["UNC3886 (Group)", "VIRTUALPITA (Malware)"],
    "T1055.003": [
      "Gazer (Malware)",
      "Pikabot (Malware)",
      "Trojan.Karagany (Malware)",
      "Waterbear (Malware)",
    ],
    "T1547.013": [
      "Contagious Interview (Group)",
      "CrossRAT (Malware)",
      "Fysbis (Malware)",
      "InvisibleFerret (Malware)",
      "NETWIRE (Malware)",
      "Pupy (Tool)",
      "RotaJakiro (Malware)",
    ],
    T1653: [
      "ArcaneDoor (Campaign)",
      "Line Dancer (Malware)",
      "Line Runner (Malware)",
    ],
    "T1137.006": [
      "Bisonal (Malware)",
      "LunarLoader (Malware)",
      "LunarMail (Malware)",
      "Naikon (Group)",
    ],
    "T1055.013": ["Bazar (Malware)", "Leafminer (Group)", "SynAck (Malware)"],
    "T1564.010": ["Cobalt Strike (Malware)", "SombRAT (Malware)"],
    "T1542.002": ["Cyclops Blink (Malware)", "Equation (Group)"],
    "T1565.001": [
      "APT38 (Group)",
      "MultiLayer Wiper (Malware)",
      "SUNSPOT (Malware)",
    ],
    "T1547.005": ["Empire (Tool)", "Mimikatz (Tool)", "PowerSploit (Tool)"],
    "T1558.001": [
      "Empire (Tool)",
      "Ke3chang (Group)",
      "Mimikatz (Tool)",
      "Rubeus (Tool)",
      "Sliver (Tool)",
    ],
    "T1556.001": ["Chimera (Group)", "Skeleton Key (Malware)"],
    "T1555.002": ["Keydnap (Malware)"],
    T1021: [
      "Aquatic Panda (Group)",
      "Brute Ratel C4 (Tool)",
      "Ember Bear (Group)",
      "Kivars (Malware)",
      "MacMa (Malware)",
      "Stuxnet (Malware)",
      "Wizard Spider (Group)",
    ],
    "T1583.002": ["Axiom (Group)", "HEXANE (Group)", "Sea Turtle (Group)"],
    "T1550.004": ["SolarWinds Compromise (Campaign)", "Star Blizzard (Group)"],
    "T1070.010": ["BRICKSTORM (Malware)"],
    "T1608.003": ["Sea Turtle (Group)"],
    T1538: ["Scattered Spider (Group)"],
    T1212: ["Leviathan Australian Intrusions (Campaign)", "UNC3886 (Group)"],
    "T1036.007": [
      "Bazar (Malware)",
      "DarkGate (Malware)",
      "Kimsuky (Group)",
      "Milan (Malware)",
      "Mustang Panda (Group)",
    ],
    "T1556.002": [
      "MirrorFace (Group)",
      "OilRig (Group)",
      "Remsec (Malware)",
      "Strider (Group)",
    ],
    T1204: [
      "LAPSUS$ (Group)",
      "Lumma Stealer (Malware)",
      "Raspberry Robin (Malware)",
      "Scattered Spider (Group)",
      "Water Curupira Pikabot Distribution (Campaign)",
    ],
    "T1546.008": [
      "APT29 (Group)",
      "APT3 (Group)",
      "APT41 (Group)",
      "Axiom (Group)",
      "Deep Panda (Group)",
      "Empire (Tool)",
      "Fox Kitten (Group)",
    ],
    "T1589.003": [
      "Kimsuky (Group)",
      "Sandworm Team (Group)",
      "Silent Librarian (Group)",
    ],
    T1650: ["Medusa Group (Group)"],
    "T1027.006": ["APT29 (Group)", "EnvyScout (Malware)", "QakBot (Malware)"],
    "T1552.003": ["Kinsing (Malware)"],
    "T1218.015": [
      "3CX Supply Chain Attack (Campaign)",
      "Lumma Stealer (Malware)",
    ],
    "T1584.002": ["LAPSUS$ (Group)", "Sea Turtle (Group)"],
    "T1070.005": [
      "DUSTTRAP (Malware)",
      "InvisiMole (Malware)",
      "Net (Tool)",
      "RobbinHood (Malware)",
      "Threat Group-3390 (Group)",
    ],
    "T1098.003": [
      "C0027 (Campaign)",
      "LAPSUS$ (Group)",
      "Scattered Spider (Group)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
    ],
    "T1070.007": [
      "RedPenguin (Campaign)",
      "SUNBURST (Malware)",
      "UNC3886 (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1590.005": ["Andariel (Group)", "HAFNIUM (Group)", "Magic Hound (Group)"],
    "T1564.009": ["Keydnap (Malware)", "OSX/Shlayer (Malware)"],
    T1599: [
      "APT41 (Group)",
      "Indian Critical Infrastructure Intrusions (Campaign)",
    ],
    "T1552.005": [
      "Hildegard (Malware)",
      "Peirates (Tool)",
      "Shai-Hulud (Malware)",
      "TeamTNT (Group)",
      "TruffleHog (Tool)",
    ],
    "T1059.013": ["TeamTNT (Group)"],
    T1213: [
      "APT28 (Group)",
      "Raccoon Stealer (Malware)",
      "SolarWinds Compromise (Campaign)",
      "Troll Stealer (Malware)",
    ],
    "T1553.004": [
      "certutil (Tool)",
      "Dok (Malware)",
      "evilginx2 (Tool)",
      "Hikit (Malware)",
      "RTM (Malware)",
    ],
    "T1036.002": [
      "BlackTech (Group)",
      "BRONZE BUTLER (Group)",
      "Ferocious Kitten (Group)",
      "Ke3chang (Group)",
      "Scarlet Mimic (Group)",
    ],
    "T1556.006": [
      "2025 Poland Wiper Attacks (Campaign)",
      "AADInternals (Tool)",
      "Scattered Spider (Group)",
      "SLOWPULSE (Malware)",
    ],
    "T1546.007": ["netsh (Tool)"],
    "T1578.002": [
      "C0027 (Campaign)",
      "LAPSUS$ (Group)",
      "Scattered Spider (Group)",
    ],
    "T1027.008": ["Cuckoo Stealer (Malware)", "macOS.OSAMiner (Malware)"],
    "T1685.001": [
      "2016 Ukraine Electric Power Attack (Campaign)",
      "HomeLand Justice (Campaign)",
      "Magic Hound (Group)",
      "SolarWinds Compromise (Campaign)",
      "Threat Group-3390 (Group)",
      "Wevtutil (Tool)",
    ],
    T1556: [
      "ArcaneDoor (Campaign)",
      "DRYHOOK (Malware)",
      "Ebury (Malware)",
      "FIN13 (Group)",
      "Kessel (Malware)",
      "SILENTTRINITY (Tool)",
    ],
    "T1557.004": ["APT28 (Group)"],
    T1674: ["FIN7 (Group)"],
    "T1059.009": [
      "APT29 (Group)",
      "Pacu (Tool)",
      "Storm-0501 (Group)",
      "TeamTNT (Group)",
      "TruffleHog (Tool)",
    ],
    T1499: [
      "OnionDuke (Malware)",
      "Sandworm Team (Group)",
      "ZxShell (Malware)",
    ],
    T1498: ["APT28 (Group)", "Lucifer (Malware)", "NKAbuse (Malware)"],
    T1592: ["Volt Typhoon (Group)"],
    "T1021.007": [
      "APT29 (Group)",
      "C0027 (Campaign)",
      "Scattered Spider (Group)",
      "Storm-0501 (Group)",
    ],
    "T1590.001": ["AADInternals (Tool)", "Sandworm Team (Group)"],
    "T1055.005": ["CANONSTAGER (Malware)", "Ursnif (Malware)"],
    "T1542.001": [
      "Hacking Team UEFI Rootkit (Malware)",
      "LoJax (Malware)",
      "Trojan.Mebromi (Malware)",
    ],
    "T1558.005": ["Impacket (Tool)"],
    "T1598.002": [
      "Dragonfly (Group)",
      "SideCopy (Group)",
      "Sidewinder (Group)",
      "Star Blizzard (Group)",
    ],
    "T1176.002": ["Mustang Panda (Group)"],
    T1553: ["Axiom (Group)", "Shai-Hulud (Malware)"],
    "T1547.014": ["PoisonIvy (Malware)"],
    T1548: ["Raspberry Robin (Malware)", "UNC3886 (Group)"],
    "T1218.014": [
      "Medusa Group (Group)",
      "RedDelta Modified PlugX Infection Chain Operations (Campaign)",
    ],
    "T1552.008": ["LAPSUS$ (Group)"],
    "T1137.003": ["Ruler (Tool)"],
    "T1568.003": ["APT12 (Group)"],
    "T1204.003": ["TeamTNT (Group)"],
    "T1595.001": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "Ember Bear (Group)",
      "TeamTNT (Group)",
    ],
    "T1555.006": [
      "HAFNIUM (Group)",
      "Pacu (Tool)",
      "Shai-Hulud (Malware)",
      "Storm-0501 (Group)",
      "TruffleHog (Tool)",
    ],
    "T1037.005": ["jRAT (Malware)"],
    "T1558.002": [
      "AADInternals (Tool)",
      "Empire (Tool)",
      "Mimikatz (Tool)",
      "Rubeus (Tool)",
    ],
    "T1563.002": ["Axiom (Group)", "WannaCry (Malware)"],
    "T1593.002": ["APT41 DUST (Campaign)", "Kimsuky (Group)"],
    "T1218.002": ["InvisiMole (Malware)", "Reaver (Malware)"],
    "T1584.003": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Operation MidnightEclipse (Campaign)",
      "Turla (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1574.008": ["Empire (Tool)", "PowerSploit (Tool)"],
    "T1548.001": ["Exaramel for Linux (Malware)", "Keydnap (Malware)"],
    "T1055.008": ["PACEMAKER (Malware)"],
    "T1564.012": ["Turla (Group)"],
    "T1491.002": ["Ember Bear (Group)", "Sandworm Team (Group)"],
    "T1567.001": ["Empire (Tool)", "Shai-Hulud (Malware)"],
    T1601: ["DRYHOOK (Malware)"],
    "T1546.012": ["C0032 (Campaign)", "SDBbot (Malware)", "SUNBURST (Malware)"],
    "T1027.018": ["GlassWorm (Malware)"],
    "T1059.002": [
      "Bundlore (Malware)",
      "Cuckoo Stealer (Malware)",
      "Dok (Malware)",
      "GlassWorm (Malware)",
      "macOS.OSAMiner (Malware)",
      "ThiefQuest (Malware)",
    ],
    "T1055.011": ["Epic (Malware)", "Power Loader (Malware)"],
    "T1027.014": ["BendyBear (Malware)"],
    T1689: [
      "BlackByte Ransomware (Malware)",
      "FrostyGoop Incident (Campaign)",
      "SILENTTRINITY (Tool)",
    ],
    "T1037.004": [
      "APT29 (Group)",
      "Cyclops Blink (Malware)",
      "Green Lambert (Malware)",
      "HiddenWasp (Malware)",
      "iKitten (Malware)",
      "UNC3886 (Group)",
      "Velvet Ant (Group)",
    ],
    T1220: [
      "Astaroth (Malware)",
      "Cobalt Group (Group)",
      "Higaisa (Group)",
      "Operation Dream Job (Campaign)",
    ],
    "T1036.009": ["BPFDoor (Malware)", "Shai-Hulud (Malware)"],
    "T1027.012": [
      "Gamaredon Group (Group)",
      "Kimsuky (Group)",
      "Mustang Panda (Group)",
      "TONESHELL (Malware)",
    ],
    "T1566.004": ["C0027 (Campaign)", "Storm-1811 (Group)"],
    T1546: [
      "KV Botnet Activity (Campaign)",
      "Pacu (Tool)",
      "UPSTYLE (Malware)",
      "XCSSET (Malware)",
    ],
    "T1578.003": ["LAPSUS$ (Group)", "Storm-0501 (Group)"],
    "T1587.004": [
      "Anthropic AI-orchestrated Campaign (Campaign)",
      "Leviathan (Group)",
      "UNC3886 (Group)",
      "Volt Typhoon (Group)",
    ],
    "T1586.003": ["APT-C-36 (Group)", "APT29 (Group)", "APT41 DUST (Campaign)"],
    "T1548.006": ["XCSSET (Malware)"],
    "T1055.009": ["KV Botnet Activity (Campaign)"],
    "T1558.004": ["Rubeus (Tool)"],
    T1682: ["APT42 (Group)", "Kimsuky (Group)"],
    "T1518.002": ["Wizard Spider (Group)"],
    T1222: ["Qilin (Malware)"],
    T1218: ["Lazarus Group (Group)", "Volt Typhoon (Group)"],
    "T1686.001": ["Pacu (Tool)"],
    "T1552.007": ["Peirates (Tool)"],
    "T1685.004": ["Ebury (Malware)"],
    "T1055.015": ["InvisiMole (Malware)"],
    "T1608.006": ["Mustard Tempest (Group)"],
    "T1598.001": ["C0027 (Campaign)"],
    "T1547.015": [
      "Dok (Malware)",
      "Green Lambert (Malware)",
      "NETWIRE (Malware)",
    ],
    "T1574.005": ["Mustang Panda (Group)"],
    "T1686.002": [
      "2025 Poland Wiper Attacks (Campaign)",
      "APT38 (Group)",
      "Cyclops Blink (Malware)",
      "Grandoreiro (Malware)",
    ],
    T1608: ["Mustang Panda (Group)"],
    "T1606.001": ["SolarWinds Compromise (Campaign)"],
    "T1574.011": ["Operation Honeybee (Campaign)"],
    "T1505.006": ["UNC3886 (Group)", "VIRTUALPIE (Malware)"],
    "T1098.001": [
      "C0027 (Campaign)",
      "Pacu (Tool)",
      "SolarWinds Compromise (Campaign)",
      "Storm-0501 (Group)",
    ],
    "T1683.002": ["APT-C-36 (Group)", "Contagious Interview (Group)"],
    T1597: ["EXOTIC LILY (Group)"],
    "T1588.005": ["Ember Bear (Group)", "Kimsuky (Group)"],
    "T1685.003": ["PHASEJAM (Malware)"],
    "T1546.002": ["Gazer (Malware)"],
    "T1071.005": ["GLOOXMAIL (Malware)"],
    "T1564.013": ["KV Botnet Activity (Campaign)"],
    "T1218.013": ["TONESHELL (Malware)"],
    T1683: ["Anthropic AI-orchestrated Campaign (Campaign)"],
    "T1505.002": ["LightNeuron (Malware)"],
    "T1574.014": ["IMAPLoader (Malware)"],
    "T1110.004": [
      "Chimera (Group)",
      "TrickBot (Malware)",
      "VOID MANTICORE (Group)",
    ],
    "T1574.013": ["FinFisher (Malware)", "Lazarus Group (Group)"],
    "T1574.004": ["Empire (Tool)"],
    "T1565.003": ["APT38 (Group)"],
    T1211: ["APT28 (Group)", "Velvet Ant (Group)"],
    "T1547.002": ["Flame (Malware)"],
    "T1548.004": ["OSX/Shlayer (Malware)"],
    "T1137.002": ["APT28 (Group)"],
    "T1583.007": ["APT41 DUST (Campaign)"],
    "T1574.010": ["BlackEnergy (Malware)"],
    "T1499.004": ["Industroyer (Malware)"],
    T1137: ["APT32 (Group)", "Gamaredon Group (Group)"],
    "T1590.006": [
      "2025 Poland Wiper Attacks (Campaign)",
      "Volt Typhoon (Group)",
    ],
    "T1597.002": ["LAPSUS$ (Group)"],
    "T1578.001": ["Pacu (Tool)"],
    T1595: ["Triton Safety Instrumented System Attack (Campaign)"],
  },
};

export default ATTACK_DATA;
